// PLANTS CUCURBITS
// Clean database with regional names support

import { PlantData } from './plants-master-database'

export const cucurbitsData: PlantData[] = [
  {
    id: 'pumpkin-pie',
    name: 'Pumpkin - Sugar Pie',
    scientificName: 'Cucurbita pepo',
    category: 'cucurbit',
    spacing: 48,
    rowSpacing: 72,
    daysToGermination: 7,
    daysToHarvest: 100,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'bean'],
    enemies: ['potato'],
    description: 'Small sweet pumpkins perfect for baking. Vining habit.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Sugar Pie', 'New England Pie'],
    uses: ['baking', 'pies', 'soup']
  },
  {
    id: 'pumpkin-jack-o-lantern',
    name: 'Pumpkin - Jack O Lantern',
    scientificName: 'Cucurbita pepo',
    category: 'cucurbit',
    spacing: 48,
    rowSpacing: 72,
    daysToGermination: 7,
    daysToHarvest: 110,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Large round pumpkins for carving. Thick walls and strong stems.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '10-12 feet',
    family: 'Cucurbitaceae',
    varieties: ['Connecticut Field', 'Howden'],
    uses: ['carving', 'decoration', 'seeds']
  },
  {
    id: 'squash-butternut',
    name: 'Squash - Butternut',
    scientificName: 'Cucurbita moschata',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'bean'],
    enemies: ['potato'],
    description: 'Tan bell-shaped squash with sweet orange flesh. Excellent storage.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Waltham Butternut', 'Butterbush'],
    uses: ['baking', 'soup', 'storage']
  },
  {
    id: 'squash-acorn',
    name: 'Squash - Acorn',
    scientificName: 'Cucurbita pepo',
    category: 'cucurbit',
    spacing: 24,
    rowSpacing: 48,
    daysToGermination: 7,
    daysToHarvest: 80,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Dark green ribbed squash, perfect for halving and baking.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '6-8 feet',
    family: 'Cucurbitaceae',
    varieties: ['Table Queen', 'Tay Belle'],
    uses: ['baking', 'stuffing', 'roasting']
  },
  {
    id: 'squash-spaghetti',
    name: 'Squash - Spaghetti',
    scientificName: 'Cucurbita pepo',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 90,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Oval yellow squash with stringy flesh like pasta when cooked.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Vegetable Spaghetti', 'Tivoli'],
    uses: ['pasta substitute', 'baking', 'low carb']
  },
  {
    id: 'squash-delicata',
    name: 'Squash - Delicata',
    scientificName: 'Cucurbita pepo',
    category: 'cucurbit',
    spacing: 18,
    rowSpacing: 36,
    daysToGermination: 7,
    daysToHarvest: 80,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Elongated striped squash with edible skin. Sweet nutty flavor.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '6-8 feet',
    family: 'Cucurbitaceae',
    varieties: ['Delicata', 'Honey Boat'],
    uses: ['roasting', 'baking', 'edible skin']
  },
  {
    id: 'squash-pattypan',
    name: 'Squash - Pattypan',
    scientificName: 'Cucurbita pepo',
    category: 'cucurbit',
    spacing: 24,
    rowSpacing: 36,
    daysToGermination: 7,
    daysToHarvest: 55,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'bean'],
    enemies: ['potato'],
    description: 'Small flying saucer shaped squash in white, yellow, or green.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '3-4 feet',
    family: 'Cucurbitaceae',
    varieties: ['Scallop', 'Sunburst'],
    uses: ['grilling', 'roasting', 'saute']
  },
  {
    id: 'watermelon-crimson-sweet',
    name: 'Watermelon - Crimson Sweet',
    scientificName: 'Citrullus lanatus',
    category: 'cucurbit',
    spacing: 48,
    rowSpacing: 72,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Round striped melon with bright red sweet flesh. 25 lb fruit.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '10-12 feet',
    family: 'Cucurbitaceae',
    varieties: ['Crimson Sweet', 'Sugar Baby'],
    uses: ['fresh', 'juice', 'picnic']
  },
  {
    id: 'cantaloupe-hales-best',
    name: 'Cantaloupe - Hales Best',
    scientificName: 'Cucumis melo',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Classic muskmelon with netted skin and orange flesh. Aromatic.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Hales Best Jumbo', 'Ambrosia'],
    uses: ['fresh', 'breakfast', 'salads']
  },
  {
    id: 'honeydew-green-flesh',
    name: 'Honeydew - Green Flesh',
    scientificName: 'Cucumis melo',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 90,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Smooth pale green skin with sweet green flesh. Longer season.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Honey Dew', 'Honey Orange'],
    uses: ['fresh', 'dessert', 'smoothies']
  }
,
  {
    id: 'squash-black-beauty',
    name: 'Squash - Black Beauty',
    scientificName: 'Cucurbita maxima',
    category: 'cucurbit',
    spacing: 24,
    rowSpacing: 36,
    daysToGermination: 7,
    daysToHarvest: 50,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'bean', 'radish', 'marigold'],
    enemies: ['potato'],
    description: 'green zucchini summer squash. Harvest young and tender, continuous producer. Heavy producer all season.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '3-4 feet',
    family: 'Cucurbitaceae',
    varieties: ['Black Beauty'],
    uses: ['grilling', 'saute', 'raw', 'baking']
  },
  {
    id: 'squash-raven',
    name: 'Squash - Raven',
    scientificName: 'Cucurbita maxima',
    category: 'cucurbit',
    spacing: 24,
    rowSpacing: 36,
    daysToGermination: 7,
    daysToHarvest: 48,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'bean', 'radish', 'marigold'],
    enemies: ['potato'],
    description: 'green zucchini summer squash. Harvest young and tender, continuous producer. Heavy producer all season.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '3-4 feet',
    family: 'Cucurbitaceae',
    varieties: ['Raven'],
    uses: ['grilling', 'saute', 'raw', 'baking']
  },
  {
    id: 'squash-dunja',
    name: 'Squash - Dunja',
    scientificName: 'Cucurbita maxima',
    category: 'cucurbit',
    spacing: 24,
    rowSpacing: 36,
    daysToGermination: 7,
    daysToHarvest: 48,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'bean', 'radish', 'marigold'],
    enemies: ['potato'],
    description: 'green zucchini summer squash. Harvest young and tender, continuous producer. Heavy producer all season.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '3-4 feet',
    family: 'Cucurbitaceae',
    varieties: ['Dunja'],
    uses: ['grilling', 'saute', 'raw', 'baking']
  },
  {
    id: 'squash-costata-romanesca',
    name: 'Squash - Costata Romanesca',
    scientificName: 'Cucurbita maxima',
    category: 'cucurbit',
    spacing: 24,
    rowSpacing: 36,
    daysToGermination: 7,
    daysToHarvest: 55,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'bean', 'radish', 'marigold'],
    enemies: ['potato'],
    description: 'striped zucchini summer squash. Harvest young and tender, continuous producer. Heavy producer all season.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '3-4 feet',
    family: 'Cucurbitaceae',
    varieties: ['Costata Romanesca'],
    uses: ['grilling', 'saute', 'raw', 'baking']
  },
  {
    id: 'squash-cocozelle',
    name: 'Squash - Cocozelle',
    scientificName: 'Cucurbita maxima',
    category: 'cucurbit',
    spacing: 24,
    rowSpacing: 36,
    daysToGermination: 7,
    daysToHarvest: 55,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'bean', 'radish', 'marigold'],
    enemies: ['potato'],
    description: 'striped zucchini summer squash. Harvest young and tender, continuous producer. Heavy producer all season.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '3-4 feet',
    family: 'Cucurbitaceae',
    varieties: ['Cocozelle'],
    uses: ['grilling', 'saute', 'raw', 'baking']
  },
  {
    id: 'squash-romanesco',
    name: 'Squash - Romanesco',
    scientificName: 'Cucurbita maxima',
    category: 'cucurbit',
    spacing: 24,
    rowSpacing: 36,
    daysToGermination: 7,
    daysToHarvest: 55,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'bean', 'radish', 'marigold'],
    enemies: ['potato'],
    description: 'striped zucchini summer squash. Harvest young and tender, continuous producer. Heavy producer all season.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '3-4 feet',
    family: 'Cucurbitaceae',
    varieties: ['Romanesco'],
    uses: ['grilling', 'saute', 'raw', 'baking']
  },
  {
    id: 'squash-eight-ball',
    name: 'Squash - Eight Ball',
    scientificName: 'Cucurbita maxima',
    category: 'cucurbit',
    spacing: 24,
    rowSpacing: 36,
    daysToGermination: 7,
    daysToHarvest: 45,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'bean', 'radish', 'marigold'],
    enemies: ['potato'],
    description: 'green zucchini summer squash. Harvest young and tender, continuous producer. Heavy producer all season.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '3-4 feet',
    family: 'Cucurbitaceae',
    varieties: ['Eight Ball'],
    uses: ['grilling', 'saute', 'raw', 'baking']
  },
  {
    id: 'squash-one-ball',
    name: 'Squash - One Ball',
    scientificName: 'Cucurbita maxima',
    category: 'cucurbit',
    spacing: 24,
    rowSpacing: 36,
    daysToGermination: 7,
    daysToHarvest: 45,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'bean', 'radish', 'marigold'],
    enemies: ['potato'],
    description: 'yellow zucchini summer squash. Harvest young and tender, continuous producer. Heavy producer all season.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '3-4 feet',
    family: 'Cucurbitaceae',
    varieties: ['One Ball'],
    uses: ['grilling', 'saute', 'raw', 'baking']
  },
  {
    id: 'squash-round-zucchini',
    name: 'Squash - Round Zucchini',
    scientificName: 'Cucurbita maxima',
    category: 'cucurbit',
    spacing: 24,
    rowSpacing: 36,
    daysToGermination: 7,
    daysToHarvest: 45,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'bean', 'radish', 'marigold'],
    enemies: ['potato'],
    description: 'green zucchini summer squash. Harvest young and tender, continuous producer. Heavy producer all season.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '3-4 feet',
    family: 'Cucurbitaceae',
    varieties: ['Round Zucchini'],
    uses: ['grilling', 'saute', 'raw', 'baking']
  },
  {
    id: 'squash-tondo-di-piacenza',
    name: 'Squash - Tondo di Piacenza',
    scientificName: 'Cucurbita maxima',
    category: 'cucurbit',
    spacing: 24,
    rowSpacing: 36,
    daysToGermination: 7,
    daysToHarvest: 45,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'bean', 'radish', 'marigold'],
    enemies: ['potato'],
    description: 'green zucchini summer squash. Harvest young and tender, continuous producer. Heavy producer all season.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '3-4 feet',
    family: 'Cucurbitaceae',
    varieties: ['Tondo di Piacenza'],
    uses: ['grilling', 'saute', 'raw', 'baking']
  },
  {
    id: 'squash-golden-zucchini',
    name: 'Squash - Golden Zucchini',
    scientificName: 'Cucurbita maxima',
    category: 'cucurbit',
    spacing: 24,
    rowSpacing: 36,
    daysToGermination: 7,
    daysToHarvest: 50,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'bean', 'radish', 'marigold'],
    enemies: ['potato'],
    description: 'yellow zucchini summer squash. Harvest young and tender, continuous producer. Heavy producer all season.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '3-4 feet',
    family: 'Cucurbitaceae',
    varieties: ['Golden Zucchini'],
    uses: ['grilling', 'saute', 'raw', 'baking']
  },
  {
    id: 'squash-gold-rush',
    name: 'Squash - Gold Rush',
    scientificName: 'Cucurbita maxima',
    category: 'cucurbit',
    spacing: 24,
    rowSpacing: 36,
    daysToGermination: 7,
    daysToHarvest: 50,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'bean', 'radish', 'marigold'],
    enemies: ['potato'],
    description: 'yellow zucchini summer squash. Harvest young and tender, continuous producer. Heavy producer all season.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '3-4 feet',
    family: 'Cucurbitaceae',
    varieties: ['Gold Rush'],
    uses: ['grilling', 'saute', 'raw', 'baking']
  },
  {
    id: 'squash-zucchini-elite',
    name: 'Squash - Zucchini Elite',
    scientificName: 'Cucurbita maxima',
    category: 'cucurbit',
    spacing: 24,
    rowSpacing: 36,
    daysToGermination: 7,
    daysToHarvest: 48,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'bean', 'radish', 'marigold'],
    enemies: ['potato'],
    description: 'green zucchini summer squash. Harvest young and tender, continuous producer. Heavy producer all season.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '3-4 feet',
    family: 'Cucurbitaceae',
    varieties: ['Zucchini Elite'],
    uses: ['grilling', 'saute', 'raw', 'baking']
  },
  {
    id: 'squash-ambassador',
    name: 'Squash - Ambassador',
    scientificName: 'Cucurbita maxima',
    category: 'cucurbit',
    spacing: 24,
    rowSpacing: 36,
    daysToGermination: 7,
    daysToHarvest: 48,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'bean', 'radish', 'marigold'],
    enemies: ['potato'],
    description: 'green zucchini summer squash. Harvest young and tender, continuous producer. Heavy producer all season.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '3-4 feet',
    family: 'Cucurbitaceae',
    varieties: ['Ambassador'],
    uses: ['grilling', 'saute', 'raw', 'baking']
  },
  {
    id: 'squash-spineless-beauty',
    name: 'Squash - Spineless Beauty',
    scientificName: 'Cucurbita maxima',
    category: 'cucurbit',
    spacing: 24,
    rowSpacing: 36,
    daysToGermination: 7,
    daysToHarvest: 48,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'bean', 'radish', 'marigold'],
    enemies: ['potato'],
    description: 'green zucchini summer squash. Harvest young and tender, continuous producer. Heavy producer all season.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '3-4 feet',
    family: 'Cucurbitaceae',
    varieties: ['Spineless Beauty'],
    uses: ['grilling', 'saute', 'raw', 'baking']
  },
  {
    id: 'squash-payroll',
    name: 'Squash - Payroll',
    scientificName: 'Cucurbita maxima',
    category: 'cucurbit',
    spacing: 24,
    rowSpacing: 36,
    daysToGermination: 7,
    daysToHarvest: 48,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'bean', 'radish', 'marigold'],
    enemies: ['potato'],
    description: 'green zucchini summer squash. Harvest young and tender, continuous producer. Heavy producer all season.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '3-4 feet',
    family: 'Cucurbitaceae',
    varieties: ['Payroll'],
    uses: ['grilling', 'saute', 'raw', 'baking']
  },
  {
    id: 'squash-partenon',
    name: 'Squash - Partenon',
    scientificName: 'Cucurbita maxima',
    category: 'cucurbit',
    spacing: 24,
    rowSpacing: 36,
    daysToGermination: 7,
    daysToHarvest: 48,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'bean', 'radish', 'marigold'],
    enemies: ['potato'],
    description: 'green zucchini summer squash. Harvest young and tender, continuous producer. Heavy producer all season.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '3-4 feet',
    family: 'Cucurbitaceae',
    varieties: ['Partenon'],
    uses: ['grilling', 'saute', 'raw', 'baking']
  },
  {
    id: 'squash-green-machine',
    name: 'Squash - Green Machine',
    scientificName: 'Cucurbita maxima',
    category: 'cucurbit',
    spacing: 24,
    rowSpacing: 36,
    daysToGermination: 7,
    daysToHarvest: 48,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'bean', 'radish', 'marigold'],
    enemies: ['potato'],
    description: 'green zucchini summer squash. Harvest young and tender, continuous producer. Heavy producer all season.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '3-4 feet',
    family: 'Cucurbitaceae',
    varieties: ['Green Machine'],
    uses: ['grilling', 'saute', 'raw', 'baking']
  },
  {
    id: 'squash-desert',
    name: 'Squash - Desert',
    scientificName: 'Cucurbita maxima',
    category: 'cucurbit',
    spacing: 24,
    rowSpacing: 36,
    daysToGermination: 7,
    daysToHarvest: 48,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'bean', 'radish', 'marigold'],
    enemies: ['potato'],
    description: 'green zucchini summer squash. Harvest young and tender, continuous producer. Heavy producer all season.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '3-4 feet',
    family: 'Cucurbitaceae',
    varieties: ['Desert'],
    uses: ['grilling', 'saute', 'raw', 'baking']
  },
  {
    id: 'squash-dividend',
    name: 'Squash - Dividend',
    scientificName: 'Cucurbita maxima',
    category: 'cucurbit',
    spacing: 24,
    rowSpacing: 36,
    daysToGermination: 7,
    daysToHarvest: 48,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'bean', 'radish', 'marigold'],
    enemies: ['potato'],
    description: 'green zucchini summer squash. Harvest young and tender, continuous producer. Heavy producer all season.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '3-4 feet',
    family: 'Cucurbitaceae',
    varieties: ['Dividend'],
    uses: ['grilling', 'saute', 'raw', 'baking']
  },
  {
    id: 'squash-yellow-crookneck',
    name: 'Squash - Yellow Crookneck',
    scientificName: 'Cucurbita maxima',
    category: 'cucurbit',
    spacing: 24,
    rowSpacing: 36,
    daysToGermination: 7,
    daysToHarvest: 50,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'bean', 'radish', 'marigold'],
    enemies: ['potato'],
    description: 'yellow crookneck summer squash. Harvest young and tender, continuous producer. ',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '3-4 feet',
    family: 'Cucurbitaceae',
    varieties: ['Yellow Crookneck'],
    uses: ['grilling', 'saute', 'raw', 'baking']
  },
  {
    id: 'squash-early-summer-crookneck',
    name: 'Squash - Early Summer Crookneck',
    scientificName: 'Cucurbita maxima',
    category: 'cucurbit',
    spacing: 24,
    rowSpacing: 36,
    daysToGermination: 7,
    daysToHarvest: 50,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'bean', 'radish', 'marigold'],
    enemies: ['potato'],
    description: 'yellow crookneck summer squash. Harvest young and tender, continuous producer. ',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '3-4 feet',
    family: 'Cucurbitaceae',
    varieties: ['Early Summer Crookneck'],
    uses: ['grilling', 'saute', 'raw', 'baking']
  },
  {
    id: 'squash-supersett',
    name: 'Squash - Supersett',
    scientificName: 'Cucurbita maxima',
    category: 'cucurbit',
    spacing: 24,
    rowSpacing: 36,
    daysToGermination: 7,
    daysToHarvest: 48,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'bean', 'radish', 'marigold'],
    enemies: ['potato'],
    description: 'yellow crookneck summer squash. Harvest young and tender, continuous producer. ',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '3-4 feet',
    family: 'Cucurbitaceae',
    varieties: ['Supersett'],
    uses: ['grilling', 'saute', 'raw', 'baking']
  },
  {
    id: 'squash-dixie',
    name: 'Squash - Dixie',
    scientificName: 'Cucurbita maxima',
    category: 'cucurbit',
    spacing: 24,
    rowSpacing: 36,
    daysToGermination: 7,
    daysToHarvest: 50,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'bean', 'radish', 'marigold'],
    enemies: ['potato'],
    description: 'yellow crookneck summer squash. Harvest young and tender, continuous producer. ',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '3-4 feet',
    family: 'Cucurbitaceae',
    varieties: ['Dixie'],
    uses: ['grilling', 'saute', 'raw', 'baking']
  },
  {
    id: 'squash-gentry',
    name: 'Squash - Gentry',
    scientificName: 'Cucurbita maxima',
    category: 'cucurbit',
    spacing: 24,
    rowSpacing: 36,
    daysToGermination: 7,
    daysToHarvest: 48,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'bean', 'radish', 'marigold'],
    enemies: ['potato'],
    description: 'yellow crookneck summer squash. Harvest young and tender, continuous producer. ',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '3-4 feet',
    family: 'Cucurbitaceae',
    varieties: ['Gentry'],
    uses: ['grilling', 'saute', 'raw', 'baking']
  },
  {
    id: 'squash-prelude-ii',
    name: 'Squash - Prelude II',
    scientificName: 'Cucurbita maxima',
    category: 'cucurbit',
    spacing: 24,
    rowSpacing: 36,
    daysToGermination: 7,
    daysToHarvest: 48,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'bean', 'radish', 'marigold'],
    enemies: ['potato'],
    description: 'yellow crookneck summer squash. Harvest young and tender, continuous producer. ',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '3-4 feet',
    family: 'Cucurbitaceae',
    varieties: ['Prelude II'],
    uses: ['grilling', 'saute', 'raw', 'baking']
  },
  {
    id: 'squash-saffron',
    name: 'Squash - Saffron',
    scientificName: 'Cucurbita maxima',
    category: 'cucurbit',
    spacing: 24,
    rowSpacing: 36,
    daysToGermination: 7,
    daysToHarvest: 48,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'bean', 'radish', 'marigold'],
    enemies: ['potato'],
    description: 'yellow crookneck summer squash. Harvest young and tender, continuous producer. ',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '3-4 feet',
    family: 'Cucurbitaceae',
    varieties: ['Saffron'],
    uses: ['grilling', 'saute', 'raw', 'baking']
  },
  {
    id: 'squash-sundance',
    name: 'Squash - Sundance',
    scientificName: 'Cucurbita maxima',
    category: 'cucurbit',
    spacing: 24,
    rowSpacing: 36,
    daysToGermination: 7,
    daysToHarvest: 48,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'bean', 'radish', 'marigold'],
    enemies: ['potato'],
    description: 'yellow crookneck summer squash. Harvest young and tender, continuous producer. ',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '3-4 feet',
    family: 'Cucurbitaceae',
    varieties: ['Sundance'],
    uses: ['grilling', 'saute', 'raw', 'baking']
  },
  {
    id: 'squash-straightneck',
    name: 'Squash - Straightneck',
    scientificName: 'Cucurbita maxima',
    category: 'cucurbit',
    spacing: 24,
    rowSpacing: 36,
    daysToGermination: 7,
    daysToHarvest: 50,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'bean', 'radish', 'marigold'],
    enemies: ['potato'],
    description: 'yellow straightneck summer squash. Harvest young and tender, continuous producer. ',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '3-4 feet',
    family: 'Cucurbitaceae',
    varieties: ['Straightneck'],
    uses: ['grilling', 'saute', 'raw', 'baking']
  },
  {
    id: 'squash-early-prolific-straightneck',
    name: 'Squash - Early Prolific Straightneck',
    scientificName: 'Cucurbita maxima',
    category: 'cucurbit',
    spacing: 24,
    rowSpacing: 36,
    daysToGermination: 7,
    daysToHarvest: 50,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'bean', 'radish', 'marigold'],
    enemies: ['potato'],
    description: 'yellow straightneck summer squash. Harvest young and tender, continuous producer. ',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '3-4 feet',
    family: 'Cucurbitaceae',
    varieties: ['Early Prolific Straightneck'],
    uses: ['grilling', 'saute', 'raw', 'baking']
  },
  {
    id: 'squash-lemon',
    name: 'Squash - Lemon',
    scientificName: 'Cucurbita maxima',
    category: 'cucurbit',
    spacing: 24,
    rowSpacing: 36,
    daysToGermination: 7,
    daysToHarvest: 55,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'bean', 'radish', 'marigold'],
    enemies: ['potato'],
    description: 'yellow pattypan summer squash. Harvest young and tender, continuous producer. ',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '3-4 feet',
    family: 'Cucurbitaceae',
    varieties: ['Lemon'],
    uses: ['grilling', 'saute', 'raw', 'baking']
  },
  {
    id: 'squash-lemon-squash',
    name: 'Squash - Lemon Squash',
    scientificName: 'Cucurbita maxima',
    category: 'cucurbit',
    spacing: 24,
    rowSpacing: 36,
    daysToGermination: 7,
    daysToHarvest: 55,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'bean', 'radish', 'marigold'],
    enemies: ['potato'],
    description: 'yellow pattypan summer squash. Harvest young and tender, continuous producer. ',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '3-4 feet',
    family: 'Cucurbitaceae',
    varieties: ['Lemon Squash'],
    uses: ['grilling', 'saute', 'raw', 'baking']
  },
  {
    id: 'squash-sunburst',
    name: 'Squash - Sunburst',
    scientificName: 'Cucurbita maxima',
    category: 'cucurbit',
    spacing: 24,
    rowSpacing: 36,
    daysToGermination: 7,
    daysToHarvest: 50,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'bean', 'radish', 'marigold'],
    enemies: ['potato'],
    description: 'yellow pattypan summer squash. Harvest young and tender, continuous producer. ',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '3-4 feet',
    family: 'Cucurbitaceae',
    varieties: ['Sunburst'],
    uses: ['grilling', 'saute', 'raw', 'baking']
  },
  {
    id: 'squash-peter-pan',
    name: 'Squash - Peter Pan',
    scientificName: 'Cucurbita maxima',
    category: 'cucurbit',
    spacing: 24,
    rowSpacing: 36,
    daysToGermination: 7,
    daysToHarvest: 50,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'bean', 'radish', 'marigold'],
    enemies: ['potato'],
    description: 'green pattypan summer squash. Harvest young and tender, continuous producer. ',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '3-4 feet',
    family: 'Cucurbitaceae',
    varieties: ['Peter Pan'],
    uses: ['grilling', 'saute', 'raw', 'baking']
  },
  {
    id: 'squash-scallopini',
    name: 'Squash - Scallopini',
    scientificName: 'Cucurbita maxima',
    category: 'cucurbit',
    spacing: 24,
    rowSpacing: 36,
    daysToGermination: 7,
    daysToHarvest: 50,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'bean', 'radish', 'marigold'],
    enemies: ['potato'],
    description: 'green pattypan summer squash. Harvest young and tender, continuous producer. ',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '3-4 feet',
    family: 'Cucurbitaceae',
    varieties: ['Scallopini'],
    uses: ['grilling', 'saute', 'raw', 'baking']
  },
  {
    id: 'squash-flying-saucer',
    name: 'Squash - Flying Saucer',
    scientificName: 'Cucurbita maxima',
    category: 'cucurbit',
    spacing: 24,
    rowSpacing: 36,
    daysToGermination: 7,
    daysToHarvest: 50,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'bean', 'radish', 'marigold'],
    enemies: ['potato'],
    description: 'bi-color pattypan summer squash. Harvest young and tender, continuous producer. ',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '3-4 feet',
    family: 'Cucurbitaceae',
    varieties: ['Flying Saucer'],
    uses: ['grilling', 'saute', 'raw', 'baking']
  },
  {
    id: 'squash-bennings-green-tint',
    name: 'Squash - Bennings Green Tint',
    scientificName: 'Cucurbita maxima',
    category: 'cucurbit',
    spacing: 24,
    rowSpacing: 36,
    daysToGermination: 7,
    daysToHarvest: 55,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'bean', 'radish', 'marigold'],
    enemies: ['potato'],
    description: 'green pattypan summer squash. Harvest young and tender, continuous producer. ',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '3-4 feet',
    family: 'Cucurbitaceae',
    varieties: ['Bennings Green Tint'],
    uses: ['grilling', 'saute', 'raw', 'baking']
  },
  {
    id: 'squash-white-bush-scallop',
    name: 'Squash - White Bush Scallop',
    scientificName: 'Cucurbita maxima',
    category: 'cucurbit',
    spacing: 24,
    rowSpacing: 36,
    daysToGermination: 7,
    daysToHarvest: 50,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'bean', 'radish', 'marigold'],
    enemies: ['potato'],
    description: 'white pattypan summer squash. Harvest young and tender, continuous producer. ',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '3-4 feet',
    family: 'Cucurbitaceae',
    varieties: ['White Bush Scallop'],
    uses: ['grilling', 'saute', 'raw', 'baking']
  },
  {
    id: 'squash-scallop-yellow-bush',
    name: 'Squash - Scallop Yellow Bush',
    scientificName: 'Cucurbita maxima',
    category: 'cucurbit',
    spacing: 24,
    rowSpacing: 36,
    daysToGermination: 7,
    daysToHarvest: 50,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'bean', 'radish', 'marigold'],
    enemies: ['potato'],
    description: 'yellow pattypan summer squash. Harvest young and tender, continuous producer. ',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '3-4 feet',
    family: 'Cucurbitaceae',
    varieties: ['Scallop Yellow Bush'],
    uses: ['grilling', 'saute', 'raw', 'baking']
  },
  {
    id: 'squash-patty-pan',
    name: 'Squash - Patty Pan',
    scientificName: 'Cucurbita maxima',
    category: 'cucurbit',
    spacing: 24,
    rowSpacing: 36,
    daysToGermination: 7,
    daysToHarvest: 50,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'bean', 'radish', 'marigold'],
    enemies: ['potato'],
    description: 'white pattypan summer squash. Harvest young and tender, continuous producer. ',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '3-4 feet',
    family: 'Cucurbitaceae',
    varieties: ['Patty Pan'],
    uses: ['grilling', 'saute', 'raw', 'baking']
  },
  {
    id: 'squash-butternut-waltham',
    name: 'Squash - Butternut Waltham',
    scientificName: 'Cucurbita pepo',
    category: 'cucurbit',
    spacing: 48,
    rowSpacing: 72,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'bean', 'radish', 'marigold'],
    enemies: ['potato'],
    description: 'tan butternut winter squash. Hard skin for storage, harvest when fully mature. Sweet, nutty flavor, excellent storage.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '6-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Butternut Waltham'],
    uses: ['baking', 'roasting', 'soup', 'storage']
  },
  {
    id: 'squash-butterbush',
    name: 'Squash - Butterbush',
    scientificName: 'Cucurbita pepo',
    category: 'cucurbit',
    spacing: 48,
    rowSpacing: 72,
    daysToGermination: 7,
    daysToHarvest: 80,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'bean', 'radish', 'marigold'],
    enemies: ['potato'],
    description: 'tan butternut winter squash. Hard skin for storage, harvest when fully mature. Sweet, nutty flavor, excellent storage.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '6-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Butterbush'],
    uses: ['baking', 'roasting', 'soup', 'storage']
  },
  {
    id: 'squash-ultra',
    name: 'Squash - Ultra',
    scientificName: 'Cucurbita pepo',
    category: 'cucurbit',
    spacing: 48,
    rowSpacing: 72,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'bean', 'radish', 'marigold'],
    enemies: ['potato'],
    description: 'tan butternut winter squash. Hard skin for storage, harvest when fully mature. Sweet, nutty flavor, excellent storage.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '6-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Ultra'],
    uses: ['baking', 'roasting', 'soup', 'storage']
  },
  {
    id: 'squash-pilgrim',
    name: 'Squash - Pilgrim',
    scientificName: 'Cucurbita pepo',
    category: 'cucurbit',
    spacing: 48,
    rowSpacing: 72,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'bean', 'radish', 'marigold'],
    enemies: ['potato'],
    description: 'tan butternut winter squash. Hard skin for storage, harvest when fully mature. Sweet, nutty flavor, excellent storage.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '6-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Pilgrim'],
    uses: ['baking', 'roasting', 'soup', 'storage']
  },
  {
    id: 'squash-zenith',
    name: 'Squash - Zenith',
    scientificName: 'Cucurbita pepo',
    category: 'cucurbit',
    spacing: 48,
    rowSpacing: 72,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'bean', 'radish', 'marigold'],
    enemies: ['potato'],
    description: 'tan butternut winter squash. Hard skin for storage, harvest when fully mature. Sweet, nutty flavor, excellent storage.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '6-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Zenith'],
    uses: ['baking', 'roasting', 'soup', 'storage']
  },
  {
    id: 'squash-savior',
    name: 'Squash - Savior',
    scientificName: 'Cucurbita pepo',
    category: 'cucurbit',
    spacing: 48,
    rowSpacing: 72,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'bean', 'radish', 'marigold'],
    enemies: ['potato'],
    description: 'tan butternut winter squash. Hard skin for storage, harvest when fully mature. Sweet, nutty flavor, excellent storage.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '6-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Savior'],
    uses: ['baking', 'roasting', 'soup', 'storage']
  },
  {
    id: 'squash-waltham',
    name: 'Squash - Waltham',
    scientificName: 'Cucurbita pepo',
    category: 'cucurbit',
    spacing: 48,
    rowSpacing: 72,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'bean', 'radish', 'marigold'],
    enemies: ['potato'],
    description: 'tan butternut winter squash. Hard skin for storage, harvest when fully mature. Sweet, nutty flavor, excellent storage.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '6-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Waltham'],
    uses: ['baking', 'roasting', 'soup', 'storage']
  },
  {
    id: 'squash-early-butternut',
    name: 'Squash - Early Butternut',
    scientificName: 'Cucurbita pepo',
    category: 'cucurbit',
    spacing: 48,
    rowSpacing: 72,
    daysToGermination: 7,
    daysToHarvest: 82,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'bean', 'radish', 'marigold'],
    enemies: ['potato'],
    description: 'tan butternut winter squash. Hard skin for storage, harvest when fully mature. Sweet, nutty flavor, excellent storage.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '6-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Early Butternut'],
    uses: ['baking', 'roasting', 'soup', 'storage']
  },
  {
    id: 'squash-butterscotch',
    name: 'Squash - Butterscotch',
    scientificName: 'Cucurbita pepo',
    category: 'cucurbit',
    spacing: 48,
    rowSpacing: 72,
    daysToGermination: 7,
    daysToHarvest: 80,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'bean', 'radish', 'marigold'],
    enemies: ['potato'],
    description: 'tan butternut winter squash. Hard skin for storage, harvest when fully mature. Sweet, nutty flavor, excellent storage.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '6-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Butterscotch'],
    uses: ['baking', 'roasting', 'soup', 'storage']
  },
  {
    id: 'squash-honeynut',
    name: 'Squash - Honeynut',
    scientificName: 'Cucurbita pepo',
    category: 'cucurbit',
    spacing: 48,
    rowSpacing: 72,
    daysToGermination: 7,
    daysToHarvest: 80,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'bean', 'radish', 'marigold'],
    enemies: ['potato'],
    description: 'tan butternut winter squash. Hard skin for storage, harvest when fully mature. Sweet, nutty flavor, excellent storage.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '6-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Honeynut'],
    uses: ['baking', 'roasting', 'soup', 'storage']
  },
  {
    id: 'squash-acorn-table-queen',
    name: 'Squash - Acorn Table Queen',
    scientificName: 'Cucurbita pepo',
    category: 'cucurbit',
    spacing: 48,
    rowSpacing: 72,
    daysToGermination: 7,
    daysToHarvest: 80,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'bean', 'radish', 'marigold'],
    enemies: ['potato'],
    description: 'green acorn winter squash. Hard skin for storage, harvest when fully mature. Ribbed, perfect for halving and baking.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '6-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Acorn Table Queen'],
    uses: ['baking', 'roasting', 'soup', 'storage']
  },
  {
    id: 'squash-acorn-honey-bear',
    name: 'Squash - Acorn Honey Bear',
    scientificName: 'Cucurbita pepo',
    category: 'cucurbit',
    spacing: 48,
    rowSpacing: 72,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'bean', 'radish', 'marigold'],
    enemies: ['potato'],
    description: 'green acorn winter squash. Hard skin for storage, harvest when fully mature. Ribbed, perfect for halving and baking.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '6-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Acorn Honey Bear'],
    uses: ['baking', 'roasting', 'soup', 'storage']
  },
  {
    id: 'squash-tay-belle',
    name: 'Squash - Tay Belle',
    scientificName: 'Cucurbita pepo',
    category: 'cucurbit',
    spacing: 48,
    rowSpacing: 72,
    daysToGermination: 7,
    daysToHarvest: 80,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'bean', 'radish', 'marigold'],
    enemies: ['potato'],
    description: 'green acorn winter squash. Hard skin for storage, harvest when fully mature. Ribbed, perfect for halving and baking.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '6-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Tay Belle'],
    uses: ['baking', 'roasting', 'soup', 'storage']
  },
  {
    id: 'squash-cream-of-the-crop',
    name: 'Squash - Cream of the Crop',
    scientificName: 'Cucurbita pepo',
    category: 'cucurbit',
    spacing: 48,
    rowSpacing: 72,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'bean', 'radish', 'marigold'],
    enemies: ['potato'],
    description: 'white acorn winter squash. Hard skin for storage, harvest when fully mature. Ribbed, perfect for halving and baking.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '6-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Cream of the Crop'],
    uses: ['baking', 'roasting', 'soup', 'storage']
  },
  {
    id: 'squash-golden-acorn',
    name: 'Squash - Golden Acorn',
    scientificName: 'Cucurbita pepo',
    category: 'cucurbit',
    spacing: 48,
    rowSpacing: 72,
    daysToGermination: 7,
    daysToHarvest: 80,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'bean', 'radish', 'marigold'],
    enemies: ['potato'],
    description: 'yellow acorn winter squash. Hard skin for storage, harvest when fully mature. Ribbed, perfect for halving and baking.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '6-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Golden Acorn'],
    uses: ['baking', 'roasting', 'soup', 'storage']
  },
  {
    id: 'squash-spaghetti',
    name: 'Squash - Spaghetti',
    scientificName: 'Cucurbita pepo',
    category: 'cucurbit',
    spacing: 48,
    rowSpacing: 72,
    daysToGermination: 7,
    daysToHarvest: 90,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'bean', 'radish', 'marigold'],
    enemies: ['potato'],
    description: 'yellow spaghetti winter squash. Hard skin for storage, harvest when fully mature. Stringy flesh like pasta when cooked.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '6-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Spaghetti'],
    uses: ['baking', 'roasting', 'soup', 'storage']
  },
  {
    id: 'squash-vegetable-spaghetti',
    name: 'Squash - Vegetable Spaghetti',
    scientificName: 'Cucurbita pepo',
    category: 'cucurbit',
    spacing: 48,
    rowSpacing: 72,
    daysToGermination: 7,
    daysToHarvest: 90,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'bean', 'radish', 'marigold'],
    enemies: ['potato'],
    description: 'yellow spaghetti winter squash. Hard skin for storage, harvest when fully mature. Stringy flesh like pasta when cooked.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '6-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Vegetable Spaghetti'],
    uses: ['baking', 'roasting', 'soup', 'storage']
  },
  {
    id: 'squash-tivoli',
    name: 'Squash - Tivoli',
    scientificName: 'Cucurbita pepo',
    category: 'cucurbit',
    spacing: 48,
    rowSpacing: 72,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'bean', 'radish', 'marigold'],
    enemies: ['potato'],
    description: 'yellow spaghetti winter squash. Hard skin for storage, harvest when fully mature. Stringy flesh like pasta when cooked.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '6-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Tivoli'],
    uses: ['baking', 'roasting', 'soup', 'storage']
  },
  {
    id: 'squash-delicata',
    name: 'Squash - Delicata',
    scientificName: 'Cucurbita maxima',
    category: 'cucurbit',
    spacing: 30,
    rowSpacing: 48,
    daysToGermination: 7,
    daysToHarvest: 80,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'bean', 'radish', 'marigold'],
    enemies: ['potato'],
    description: 'striped delicata winter squash. Hard skin for storage, harvest when fully mature. ',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '6-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Delicata'],
    uses: ['baking', 'roasting', 'soup', 'storage']
  },
  {
    id: 'squash-honey-boat',
    name: 'Squash - Honey Boat',
    scientificName: 'Cucurbita maxima',
    category: 'cucurbit',
    spacing: 30,
    rowSpacing: 48,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'bean', 'radish', 'marigold'],
    enemies: ['potato'],
    description: 'striped delicata winter squash. Hard skin for storage, harvest when fully mature. ',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '6-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Honey Boat'],
    uses: ['baking', 'roasting', 'soup', 'storage']
  },
  {
    id: 'squash-cornell-bush-delicata',
    name: 'Squash - Cornell Bush Delicata',
    scientificName: 'Cucurbita maxima',
    category: 'cucurbit',
    spacing: 30,
    rowSpacing: 48,
    daysToGermination: 7,
    daysToHarvest: 80,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'bean', 'radish', 'marigold'],
    enemies: ['potato'],
    description: 'striped delicata winter squash. Hard skin for storage, harvest when fully mature. ',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '6-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Cornell Bush Delicata'],
    uses: ['baking', 'roasting', 'soup', 'storage']
  },
  {
    id: 'squash-sugar-loaf',
    name: 'Squash - Sugar Loaf',
    scientificName: 'Cucurbita maxima',
    category: 'cucurbit',
    spacing: 30,
    rowSpacing: 48,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'bean', 'radish', 'marigold'],
    enemies: ['potato'],
    description: 'striped delicata winter squash. Hard skin for storage, harvest when fully mature. ',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '6-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Sugar Loaf'],
    uses: ['baking', 'roasting', 'soup', 'storage']
  },
  {
    id: 'squash-sweet-dumpling',
    name: 'Squash - Sweet Dumpling',
    scientificName: 'Cucurbita maxima',
    category: 'cucurbit',
    spacing: 30,
    rowSpacing: 48,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'bean', 'radish', 'marigold'],
    enemies: ['potato'],
    description: 'striped delicata winter squash. Hard skin for storage, harvest when fully mature. ',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '6-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Sweet Dumpling'],
    uses: ['baking', 'roasting', 'soup', 'storage']
  },
  {
    id: 'squash-carnival',
    name: 'Squash - Carnival',
    scientificName: 'Cucurbita maxima',
    category: 'cucurbit',
    spacing: 30,
    rowSpacing: 48,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'bean', 'radish', 'marigold'],
    enemies: ['potato'],
    description: 'multi carnival winter squash. Hard skin for storage, harvest when fully mature. ',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '6-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Carnival'],
    uses: ['baking', 'roasting', 'soup', 'storage']
  },
  {
    id: 'squash-festival',
    name: 'Squash - Festival',
    scientificName: 'Cucurbita maxima',
    category: 'cucurbit',
    spacing: 30,
    rowSpacing: 48,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'bean', 'radish', 'marigold'],
    enemies: ['potato'],
    description: 'multi carnival winter squash. Hard skin for storage, harvest when fully mature. ',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '6-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Festival'],
    uses: ['baking', 'roasting', 'soup', 'storage']
  },
  {
    id: 'squash-celebration',
    name: 'Squash - Celebration',
    scientificName: 'Cucurbita maxima',
    category: 'cucurbit',
    spacing: 30,
    rowSpacing: 48,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'bean', 'radish', 'marigold'],
    enemies: ['potato'],
    description: 'multi carnival winter squash. Hard skin for storage, harvest when fully mature. ',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '6-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Celebration'],
    uses: ['baking', 'roasting', 'soup', 'storage']
  },
  {
    id: 'squash-heart-of-gold',
    name: 'Squash - Heart of Gold',
    scientificName: 'Cucurbita maxima',
    category: 'cucurbit',
    spacing: 30,
    rowSpacing: 48,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'bean', 'radish', 'marigold'],
    enemies: ['potato'],
    description: 'multi carnival winter squash. Hard skin for storage, harvest when fully mature. ',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '6-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Heart of Gold'],
    uses: ['baking', 'roasting', 'soup', 'storage']
  },
  {
    id: 'squash-table-gold',
    name: 'Squash - Table Gold',
    scientificName: 'Cucurbita maxima',
    category: 'cucurbit',
    spacing: 30,
    rowSpacing: 48,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'bean', 'radish', 'marigold'],
    enemies: ['potato'],
    description: 'multi carnival winter squash. Hard skin for storage, harvest when fully mature. ',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '6-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Table Gold'],
    uses: ['baking', 'roasting', 'soup', 'storage']
  },
  {
    id: 'squash-red-kuri',
    name: 'Squash - Red Kuri',
    scientificName: 'Cucurbita maxima',
    category: 'cucurbit',
    spacing: 30,
    rowSpacing: 48,
    daysToGermination: 7,
    daysToHarvest: 90,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'bean', 'radish', 'marigold'],
    enemies: ['potato'],
    description: 'red kuri winter squash. Hard skin for storage, harvest when fully mature. ',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '6-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Red Kuri'],
    uses: ['baking', 'roasting', 'soup', 'storage']
  },
  {
    id: 'squash-orange-kuri',
    name: 'Squash - Orange Kuri',
    scientificName: 'Cucurbita maxima',
    category: 'cucurbit',
    spacing: 30,
    rowSpacing: 48,
    daysToGermination: 7,
    daysToHarvest: 90,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'bean', 'radish', 'marigold'],
    enemies: ['potato'],
    description: 'orange kuri winter squash. Hard skin for storage, harvest when fully mature. ',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '6-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Orange Kuri'],
    uses: ['baking', 'roasting', 'soup', 'storage']
  },
  {
    id: 'squash-blue-hubbard',
    name: 'Squash - Blue Hubbard',
    scientificName: 'Cucurbita maxima',
    category: 'cucurbit',
    spacing: 48,
    rowSpacing: 72,
    daysToGermination: 7,
    daysToHarvest: 110,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'bean', 'radish', 'marigold'],
    enemies: ['potato'],
    description: 'blue hubbard winter squash. Hard skin for storage, harvest when fully mature. ',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '6-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Blue Hubbard'],
    uses: ['baking', 'roasting', 'soup', 'storage']
  },
  {
    id: 'squash-golden-hubbard',
    name: 'Squash - Golden Hubbard',
    scientificName: 'Cucurbita maxima',
    category: 'cucurbit',
    spacing: 48,
    rowSpacing: 72,
    daysToGermination: 7,
    daysToHarvest: 105,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'bean', 'radish', 'marigold'],
    enemies: ['potato'],
    description: 'orange hubbard winter squash. Hard skin for storage, harvest when fully mature. ',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '6-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Golden Hubbard'],
    uses: ['baking', 'roasting', 'soup', 'storage']
  },
  {
    id: 'squash-green-hubbard',
    name: 'Squash - Green Hubbard',
    scientificName: 'Cucurbita maxima',
    category: 'cucurbit',
    spacing: 48,
    rowSpacing: 72,
    daysToGermination: 7,
    daysToHarvest: 110,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'bean', 'radish', 'marigold'],
    enemies: ['potato'],
    description: 'green hubbard winter squash. Hard skin for storage, harvest when fully mature. ',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '6-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Green Hubbard'],
    uses: ['baking', 'roasting', 'soup', 'storage']
  },
  {
    id: 'squash-chicago-warted-hubbard',
    name: 'Squash - Chicago Warted Hubbard',
    scientificName: 'Cucurbita maxima',
    category: 'cucurbit',
    spacing: 48,
    rowSpacing: 72,
    daysToGermination: 7,
    daysToHarvest: 110,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'bean', 'radish', 'marigold'],
    enemies: ['potato'],
    description: 'blue hubbard winter squash. Hard skin for storage, harvest when fully mature. ',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '6-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Chicago Warted Hubbard'],
    uses: ['baking', 'roasting', 'soup', 'storage']
  },
  {
    id: 'squash-buttercup',
    name: 'Squash - Buttercup',
    scientificName: 'Cucurbita maxima',
    category: 'cucurbit',
    spacing: 48,
    rowSpacing: 72,
    daysToGermination: 7,
    daysToHarvest: 95,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'bean', 'radish', 'marigold'],
    enemies: ['potato'],
    description: 'green buttercup winter squash. Hard skin for storage, harvest when fully mature. ',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '6-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Buttercup'],
    uses: ['baking', 'roasting', 'soup', 'storage']
  },
  {
    id: 'squash-burgess-buttercup',
    name: 'Squash - Burgess Buttercup',
    scientificName: 'Cucurbita maxima',
    category: 'cucurbit',
    spacing: 48,
    rowSpacing: 72,
    daysToGermination: 7,
    daysToHarvest: 95,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'bean', 'radish', 'marigold'],
    enemies: ['potato'],
    description: 'green buttercup winter squash. Hard skin for storage, harvest when fully mature. ',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '6-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Burgess Buttercup'],
    uses: ['baking', 'roasting', 'soup', 'storage']
  },
  {
    id: 'squash-kabocha',
    name: 'Squash - Kabocha',
    scientificName: 'Cucurbita maxima',
    category: 'cucurbit',
    spacing: 48,
    rowSpacing: 72,
    daysToGermination: 7,
    daysToHarvest: 95,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'bean', 'radish', 'marigold'],
    enemies: ['potato'],
    description: 'green kabocha winter squash. Hard skin for storage, harvest when fully mature. ',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '6-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Kabocha'],
    uses: ['baking', 'roasting', 'soup', 'storage']
  },
  {
    id: 'squash-sunshine',
    name: 'Squash - Sunshine',
    scientificName: 'Cucurbita maxima',
    category: 'cucurbit',
    spacing: 48,
    rowSpacing: 72,
    daysToGermination: 7,
    daysToHarvest: 95,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'bean', 'radish', 'marigold'],
    enemies: ['potato'],
    description: 'orange kabocha winter squash. Hard skin for storage, harvest when fully mature. ',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '6-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Sunshine'],
    uses: ['baking', 'roasting', 'soup', 'storage']
  },
  {
    id: 'squash-sweet-mama',
    name: 'Squash - Sweet Mama',
    scientificName: 'Cucurbita maxima',
    category: 'cucurbit',
    spacing: 48,
    rowSpacing: 72,
    daysToGermination: 7,
    daysToHarvest: 90,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'bean', 'radish', 'marigold'],
    enemies: ['potato'],
    description: 'green kabocha winter squash. Hard skin for storage, harvest when fully mature. ',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '6-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Sweet Mama'],
    uses: ['baking', 'roasting', 'soup', 'storage']
  },
  {
    id: 'squash-red-kabocha',
    name: 'Squash - Red Kabocha',
    scientificName: 'Cucurbita maxima',
    category: 'cucurbit',
    spacing: 48,
    rowSpacing: 72,
    daysToGermination: 7,
    daysToHarvest: 95,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'bean', 'radish', 'marigold'],
    enemies: ['potato'],
    description: 'red kabocha winter squash. Hard skin for storage, harvest when fully mature. ',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '6-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Red Kabocha'],
    uses: ['baking', 'roasting', 'soup', 'storage']
  },
  {
    id: 'squash-banana',
    name: 'Squash - Banana',
    scientificName: 'Cucurbita maxima',
    category: 'cucurbit',
    spacing: 48,
    rowSpacing: 72,
    daysToGermination: 7,
    daysToHarvest: 100,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'bean', 'radish', 'marigold'],
    enemies: ['potato'],
    description: 'pink banana winter squash. Hard skin for storage, harvest when fully mature. ',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '6-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Banana'],
    uses: ['baking', 'roasting', 'soup', 'storage']
  },
  {
    id: 'squash-pink-banana-jumbo',
    name: 'Squash - Pink Banana Jumbo',
    scientificName: 'Cucurbita maxima',
    category: 'cucurbit',
    spacing: 48,
    rowSpacing: 72,
    daysToGermination: 7,
    daysToHarvest: 105,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'bean', 'radish', 'marigold'],
    enemies: ['potato'],
    description: 'pink banana winter squash. Hard skin for storage, harvest when fully mature. ',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '6-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Pink Banana Jumbo'],
    uses: ['baking', 'roasting', 'soup', 'storage']
  },
  {
    id: 'squash-georgia-candy-roaster',
    name: 'Squash - Georgia Candy Roaster',
    scientificName: 'Cucurbita maxima',
    category: 'cucurbit',
    spacing: 48,
    rowSpacing: 72,
    daysToGermination: 7,
    daysToHarvest: 100,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'bean', 'radish', 'marigold'],
    enemies: ['potato'],
    description: 'pink banana winter squash. Hard skin for storage, harvest when fully mature. ',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '6-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Georgia Candy Roaster'],
    uses: ['baking', 'roasting', 'soup', 'storage']
  },
  {
    id: 'squash-long-island-cheese',
    name: 'Squash - Long Island Cheese',
    scientificName: 'Cucurbita maxima',
    category: 'cucurbit',
    spacing: 48,
    rowSpacing: 72,
    daysToGermination: 7,
    daysToHarvest: 105,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'bean', 'radish', 'marigold'],
    enemies: ['potato'],
    description: 'tan cheese winter squash. Hard skin for storage, harvest when fully mature. ',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '6-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Long Island Cheese'],
    uses: ['baking', 'roasting', 'soup', 'storage']
  },
  {
    id: 'squash-marina-di-chioggia',
    name: 'Squash - Marina di Chioggia',
    scientificName: 'Cucurbita maxima',
    category: 'cucurbit',
    spacing: 48,
    rowSpacing: 72,
    daysToGermination: 7,
    daysToHarvest: 100,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'bean', 'radish', 'marigold'],
    enemies: ['potato'],
    description: 'blue specialty winter squash. Hard skin for storage, harvest when fully mature. ',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '6-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Marina di Chioggia'],
    uses: ['baking', 'roasting', 'soup', 'storage']
  },
  {
    id: 'squash-musquee-de-provence',
    name: 'Squash - Musquee de Provence',
    scientificName: 'Cucurbita maxima',
    category: 'cucurbit',
    spacing: 48,
    rowSpacing: 72,
    daysToGermination: 7,
    daysToHarvest: 105,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'bean', 'radish', 'marigold'],
    enemies: ['potato'],
    description: 'tan specialty winter squash. Hard skin for storage, harvest when fully mature. ',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '6-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Musquee de Provence'],
    uses: ['baking', 'roasting', 'soup', 'storage']
  },
  {
    id: 'squash-fairytale',
    name: 'Squash - Fairytale',
    scientificName: 'Cucurbita maxima',
    category: 'cucurbit',
    spacing: 48,
    rowSpacing: 72,
    daysToGermination: 7,
    daysToHarvest: 100,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'bean', 'radish', 'marigold'],
    enemies: ['potato'],
    description: 'tan specialty winter squash. Hard skin for storage, harvest when fully mature. ',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '6-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Fairytale'],
    uses: ['baking', 'roasting', 'soup', 'storage']
  },
  {
    id: 'squash-queensland-blue',
    name: 'Squash - Queensland Blue',
    scientificName: 'Cucurbita maxima',
    category: 'cucurbit',
    spacing: 48,
    rowSpacing: 72,
    daysToGermination: 7,
    daysToHarvest: 110,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'bean', 'radish', 'marigold'],
    enemies: ['potato'],
    description: 'blue specialty winter squash. Hard skin for storage, harvest when fully mature. ',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '6-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Queensland Blue'],
    uses: ['baking', 'roasting', 'soup', 'storage']
  },
  {
    id: 'squash-jarrahdale',
    name: 'Squash - Jarrahdale',
    scientificName: 'Cucurbita maxima',
    category: 'cucurbit',
    spacing: 48,
    rowSpacing: 72,
    daysToGermination: 7,
    daysToHarvest: 100,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'bean', 'radish', 'marigold'],
    enemies: ['potato'],
    description: 'blue specialty winter squash. Hard skin for storage, harvest when fully mature. ',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '6-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Jarrahdale'],
    uses: ['baking', 'roasting', 'soup', 'storage']
  },
  {
    id: 'squash-kakai',
    name: 'Squash - Kakai',
    scientificName: 'Cucurbita maxima',
    category: 'cucurbit',
    spacing: 48,
    rowSpacing: 72,
    daysToGermination: 7,
    daysToHarvest: 90,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'bean', 'radish', 'marigold'],
    enemies: ['potato'],
    description: 'striped specialty winter squash. Hard skin for storage, harvest when fully mature. ',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '6-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Kakai'],
    uses: ['baking', 'roasting', 'soup', 'storage']
  },
  {
    id: 'squash-lakota',
    name: 'Squash - Lakota',
    scientificName: 'Cucurbita maxima',
    category: 'cucurbit',
    spacing: 48,
    rowSpacing: 72,
    daysToGermination: 7,
    daysToHarvest: 95,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'bean', 'radish', 'marigold'],
    enemies: ['potato'],
    description: 'multi specialty winter squash. Hard skin for storage, harvest when fully mature. ',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '6-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Lakota'],
    uses: ['baking', 'roasting', 'soup', 'storage']
  },
  {
    id: 'squash-turks-turban',
    name: 'Squash - Turks Turban',
    scientificName: 'Cucurbita maxima',
    category: 'cucurbit',
    spacing: 48,
    rowSpacing: 72,
    daysToGermination: 7,
    daysToHarvest: 95,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'bean', 'radish', 'marigold'],
    enemies: ['potato'],
    description: 'multi specialty winter squash. Hard skin for storage, harvest when fully mature. ',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '6-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Turks Turban'],
    uses: ['baking', 'roasting', 'soup', 'storage']
  },
  {
    id: 'squash-sweet-meat',
    name: 'Squash - Sweet Meat',
    scientificName: 'Cucurbita maxima',
    category: 'cucurbit',
    spacing: 48,
    rowSpacing: 72,
    daysToGermination: 7,
    daysToHarvest: 110,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'bean', 'radish', 'marigold'],
    enemies: ['potato'],
    description: 'blue specialty winter squash. Hard skin for storage, harvest when fully mature. ',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '6-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Sweet Meat'],
    uses: ['baking', 'roasting', 'soup', 'storage']
  },
  {
    id: 'squash-galeux-d-eysines',
    name: 'Squash - Galeux d Eysines',
    scientificName: 'Cucurbita maxima',
    category: 'cucurbit',
    spacing: 48,
    rowSpacing: 72,
    daysToGermination: 7,
    daysToHarvest: 100,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'bean', 'radish', 'marigold'],
    enemies: ['potato'],
    description: 'pink specialty winter squash. Hard skin for storage, harvest when fully mature. ',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '6-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Galeux d Eysines'],
    uses: ['baking', 'roasting', 'soup', 'storage']
  },
  {
    id: 'squash-rouge-vif-d-etampes',
    name: 'Squash - Rouge Vif d Etampes',
    scientificName: 'Cucurbita maxima',
    category: 'cucurbit',
    spacing: 48,
    rowSpacing: 72,
    daysToGermination: 7,
    daysToHarvest: 95,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'bean', 'radish', 'marigold'],
    enemies: ['potato'],
    description: 'red specialty winter squash. Hard skin for storage, harvest when fully mature. ',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '6-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Rouge Vif d Etampes'],
    uses: ['baking', 'roasting', 'soup', 'storage']
  },
  {
    id: 'squash-cinderella',
    name: 'Squash - Cinderella',
    scientificName: 'Cucurbita maxima',
    category: 'cucurbit',
    spacing: 48,
    rowSpacing: 72,
    daysToGermination: 7,
    daysToHarvest: 95,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'bean', 'radish', 'marigold'],
    enemies: ['potato'],
    description: 'red specialty winter squash. Hard skin for storage, harvest when fully mature. ',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '6-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Cinderella'],
    uses: ['baking', 'roasting', 'soup', 'storage']
  },
  {
    id: 'squash-blue-ballet',
    name: 'Squash - Blue Ballet',
    scientificName: 'Cucurbita maxima',
    category: 'cucurbit',
    spacing: 48,
    rowSpacing: 72,
    daysToGermination: 7,
    daysToHarvest: 95,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'bean', 'radish', 'marigold'],
    enemies: ['potato'],
    description: 'blue specialty winter squash. Hard skin for storage, harvest when fully mature. ',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '6-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Blue Ballet'],
    uses: ['baking', 'roasting', 'soup', 'storage']
  },
  {
    id: 'squash-red-warty-thing',
    name: 'Squash - Red Warty Thing',
    scientificName: 'Cucurbita maxima',
    category: 'cucurbit',
    spacing: 48,
    rowSpacing: 72,
    daysToGermination: 7,
    daysToHarvest: 100,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'bean', 'radish', 'marigold'],
    enemies: ['potato'],
    description: 'red specialty winter squash. Hard skin for storage, harvest when fully mature. ',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '6-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Red Warty Thing'],
    uses: ['baking', 'roasting', 'soup', 'storage']
  },
  {
    id: 'squash-black-futsu',
    name: 'Squash - Black Futsu',
    scientificName: 'Cucurbita maxima',
    category: 'cucurbit',
    spacing: 48,
    rowSpacing: 72,
    daysToGermination: 7,
    daysToHarvest: 100,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'bean', 'radish', 'marigold'],
    enemies: ['potato'],
    description: 'black specialty winter squash. Hard skin for storage, harvest when fully mature. ',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '6-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Black Futsu'],
    uses: ['baking', 'roasting', 'soup', 'storage']
  },
  {
    id: 'squash-yokohama',
    name: 'Squash - Yokohama',
    scientificName: 'Cucurbita maxima',
    category: 'cucurbit',
    spacing: 48,
    rowSpacing: 72,
    daysToGermination: 7,
    daysToHarvest: 95,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'bean', 'radish', 'marigold'],
    enemies: ['potato'],
    description: 'tan specialty winter squash. Hard skin for storage, harvest when fully mature. ',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '6-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Yokohama'],
    uses: ['baking', 'roasting', 'soup', 'storage']
  },
  {
    id: 'squash-sugar-pie',
    name: 'Pumpkin - Sugar Pie',
    scientificName: 'Cucurbita pepo',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 100,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'bean', 'radish', 'marigold'],
    enemies: ['potato'],
    description: 'orange pie pumpkin. Classic pumpkin for carving or cooking. Sweet flesh perfect for baking.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '6-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Sugar Pie'],
    uses: ['carving', 'pie', 'decoration', 'seeds']
  },
  {
    id: 'squash-new-england-pie',
    name: 'Pumpkin - New England Pie',
    scientificName: 'Cucurbita pepo',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 100,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'bean', 'radish', 'marigold'],
    enemies: ['potato'],
    description: 'orange pie pumpkin. Classic pumpkin for carving or cooking. Sweet flesh perfect for baking.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '6-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['New England Pie'],
    uses: ['carving', 'pie', 'decoration', 'seeds']
  },
  {
    id: 'squash-baby-pam',
    name: 'Pumpkin - Baby Pam',
    scientificName: 'Cucurbita pepo',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 95,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'bean', 'radish', 'marigold'],
    enemies: ['potato'],
    description: 'orange pie pumpkin. Classic pumpkin for carving or cooking. Sweet flesh perfect for baking.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '6-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Baby Pam'],
    uses: ['carving', 'pie', 'decoration', 'seeds']
  },
  {
    id: 'squash-winter-luxury',
    name: 'Pumpkin - Winter Luxury',
    scientificName: 'Cucurbita pepo',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 105,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'bean', 'radish', 'marigold'],
    enemies: ['potato'],
    description: 'orange pie pumpkin. Classic pumpkin for carving or cooking. Sweet flesh perfect for baking.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '6-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Winter Luxury'],
    uses: ['carving', 'pie', 'decoration', 'seeds']
  },
  {
    id: 'squash-long-pie',
    name: 'Pumpkin - Long Pie',
    scientificName: 'Cucurbita pepo',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 100,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'bean', 'radish', 'marigold'],
    enemies: ['potato'],
    description: 'orange pie pumpkin. Classic pumpkin for carving or cooking. Sweet flesh perfect for baking.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '6-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Long Pie'],
    uses: ['carving', 'pie', 'decoration', 'seeds']
  },
  {
    id: 'squash-dickinson',
    name: 'Pumpkin - Dickinson',
    scientificName: 'Cucurbita pepo',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 110,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'bean', 'radish', 'marigold'],
    enemies: ['potato'],
    description: 'tan pie pumpkin. Classic pumpkin for carving or cooking. Sweet flesh perfect for baking.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '6-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Dickinson'],
    uses: ['carving', 'pie', 'decoration', 'seeds']
  },
  {
    id: 'squash-kentucky-field',
    name: 'Pumpkin - Kentucky Field',
    scientificName: 'Cucurbita pepo',
    category: 'cucurbit',
    spacing: 48,
    rowSpacing: 72,
    daysToGermination: 7,
    daysToHarvest: 110,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'bean', 'radish', 'marigold'],
    enemies: ['potato'],
    description: 'orange field pumpkin. Classic pumpkin for carving or cooking. ',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '6-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Kentucky Field'],
    uses: ['carving', 'pie', 'decoration', 'seeds']
  },
  {
    id: 'squash-connecticut-field',
    name: 'Pumpkin - Connecticut Field',
    scientificName: 'Cucurbita pepo',
    category: 'cucurbit',
    spacing: 48,
    rowSpacing: 72,
    daysToGermination: 7,
    daysToHarvest: 110,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'bean', 'radish', 'marigold'],
    enemies: ['potato'],
    description: 'orange field pumpkin. Classic pumpkin for carving or cooking. ',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '6-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Connecticut Field'],
    uses: ['carving', 'pie', 'decoration', 'seeds']
  },
  {
    id: 'squash-howden',
    name: 'Pumpkin - Howden',
    scientificName: 'Cucurbita pepo',
    category: 'cucurbit',
    spacing: 48,
    rowSpacing: 72,
    daysToGermination: 7,
    daysToHarvest: 115,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'bean', 'radish', 'marigold'],
    enemies: ['potato'],
    description: 'orange jack pumpkin. Classic pumpkin for carving or cooking. Large, perfect for carving.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '6-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Howden'],
    uses: ['carving', 'pie', 'decoration', 'seeds']
  },
  {
    id: 'squash-howden-biggie',
    name: 'Pumpkin - Howden Biggie',
    scientificName: 'Cucurbita pepo',
    category: 'cucurbit',
    spacing: 48,
    rowSpacing: 72,
    daysToGermination: 7,
    daysToHarvest: 120,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'bean', 'radish', 'marigold'],
    enemies: ['potato'],
    description: 'orange jack pumpkin. Classic pumpkin for carving or cooking. Large, perfect for carving.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '6-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Howden Biggie'],
    uses: ['carving', 'pie', 'decoration', 'seeds']
  },
  {
    id: 'squash-jack-o-lantern',
    name: 'Pumpkin - Jack O Lantern',
    scientificName: 'Cucurbita pepo',
    category: 'cucurbit',
    spacing: 48,
    rowSpacing: 72,
    daysToGermination: 7,
    daysToHarvest: 110,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'bean', 'radish', 'marigold'],
    enemies: ['potato'],
    description: 'orange jack pumpkin. Classic pumpkin for carving or cooking. Large, perfect for carving.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '6-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Jack O Lantern'],
    uses: ['carving', 'pie', 'decoration', 'seeds']
  },
  {
    id: 'squash-jack-be-little',
    name: 'Pumpkin - Jack Be Little',
    scientificName: 'Cucurbita pepo',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'bean', 'radish', 'marigold'],
    enemies: ['potato'],
    description: 'orange mini pumpkin. Classic pumpkin for carving or cooking. ',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '6-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Jack Be Little'],
    uses: ['carving', 'pie', 'decoration', 'seeds']
  },
  {
    id: 'squash-baby-boo',
    name: 'Pumpkin - Baby Boo',
    scientificName: 'Cucurbita pepo',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'bean', 'radish', 'marigold'],
    enemies: ['potato'],
    description: 'white mini pumpkin. Classic pumpkin for carving or cooking. ',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '6-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Baby Boo'],
    uses: ['carving', 'pie', 'decoration', 'seeds']
  },
  {
    id: 'squash-munchkin',
    name: 'Pumpkin - Munchkin',
    scientificName: 'Cucurbita pepo',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'bean', 'radish', 'marigold'],
    enemies: ['potato'],
    description: 'orange mini pumpkin. Classic pumpkin for carving or cooking. ',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '6-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Munchkin'],
    uses: ['carving', 'pie', 'decoration', 'seeds']
  },
  {
    id: 'squash-wee-b-little',
    name: 'Pumpkin - Wee B Little',
    scientificName: 'Cucurbita pepo',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'bean', 'radish', 'marigold'],
    enemies: ['potato'],
    description: 'orange mini pumpkin. Classic pumpkin for carving or cooking. ',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '6-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Wee B Little'],
    uses: ['carving', 'pie', 'decoration', 'seeds']
  },
  {
    id: 'squash-hooligan',
    name: 'Pumpkin - Hooligan',
    scientificName: 'Cucurbita pepo',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'bean', 'radish', 'marigold'],
    enemies: ['potato'],
    description: 'multi mini pumpkin. Classic pumpkin for carving or cooking. ',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '6-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Hooligan'],
    uses: ['carving', 'pie', 'decoration', 'seeds']
  },
  {
    id: 'squash-gooligan',
    name: 'Pumpkin - Gooligan',
    scientificName: 'Cucurbita pepo',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'bean', 'radish', 'marigold'],
    enemies: ['potato'],
    description: 'white mini pumpkin. Classic pumpkin for carving or cooking. ',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '6-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Gooligan'],
    uses: ['carving', 'pie', 'decoration', 'seeds']
  },
  {
    id: 'squash-pepitas',
    name: 'Pumpkin - Pepitas',
    scientificName: 'Cucurbita pepo',
    category: 'cucurbit',
    spacing: 48,
    rowSpacing: 72,
    daysToGermination: 7,
    daysToHarvest: 100,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'bean', 'radish', 'marigold'],
    enemies: ['potato'],
    description: 'orange hulless pumpkin. Classic pumpkin for carving or cooking. ',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '6-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Pepitas'],
    uses: ['carving', 'pie', 'decoration', 'seeds']
  },
  {
    id: 'squash-kakai',
    name: 'Pumpkin - Kakai',
    scientificName: 'Cucurbita pepo',
    category: 'cucurbit',
    spacing: 48,
    rowSpacing: 72,
    daysToGermination: 7,
    daysToHarvest: 90,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'bean', 'radish', 'marigold'],
    enemies: ['potato'],
    description: 'striped hulless pumpkin. Classic pumpkin for carving or cooking. ',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '6-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Kakai'],
    uses: ['carving', 'pie', 'decoration', 'seeds']
  },
  {
    id: 'squash-lady-godiva',
    name: 'Pumpkin - Lady Godiva',
    scientificName: 'Cucurbita pepo',
    category: 'cucurbit',
    spacing: 48,
    rowSpacing: 72,
    daysToGermination: 7,
    daysToHarvest: 100,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'bean', 'radish', 'marigold'],
    enemies: ['potato'],
    description: 'orange hulless pumpkin. Classic pumpkin for carving or cooking. ',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '6-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Lady Godiva'],
    uses: ['carving', 'pie', 'decoration', 'seeds']
  },
  {
    id: 'squash-naked-bear',
    name: 'Pumpkin - Naked Bear',
    scientificName: 'Cucurbita pepo',
    category: 'cucurbit',
    spacing: 48,
    rowSpacing: 72,
    daysToGermination: 7,
    daysToHarvest: 100,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'bean', 'radish', 'marigold'],
    enemies: ['potato'],
    description: 'orange hulless pumpkin. Classic pumpkin for carving or cooking. ',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '6-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Naked Bear'],
    uses: ['carving', 'pie', 'decoration', 'seeds']
  },
  {
    id: 'squash-triple-treat',
    name: 'Pumpkin - Triple Treat',
    scientificName: 'Cucurbita pepo',
    category: 'cucurbit',
    spacing: 48,
    rowSpacing: 72,
    daysToGermination: 7,
    daysToHarvest: 105,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'bean', 'radish', 'marigold'],
    enemies: ['potato'],
    description: 'orange hulless pumpkin. Classic pumpkin for carving or cooking. ',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '6-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Triple Treat'],
    uses: ['carving', 'pie', 'decoration', 'seeds']
  },
  {
    id: 'squash-atlantic-giant',
    name: 'Pumpkin - Atlantic Giant',
    scientificName: 'Cucurbita pepo',
    category: 'cucurbit',
    spacing: 48,
    rowSpacing: 72,
    daysToGermination: 7,
    daysToHarvest: 125,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'bean', 'radish', 'marigold'],
    enemies: ['potato'],
    description: 'orange giant pumpkin. Classic pumpkin for carving or cooking. ',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '15-20 feet',
    family: 'Cucurbitaceae',
    varieties: ['Atlantic Giant'],
    uses: ['carving', 'pie', 'decoration', 'seeds']
  },
  {
    id: 'squash-dill-atlantic-giant',
    name: 'Pumpkin - Dill Atlantic Giant',
    scientificName: 'Cucurbita pepo',
    category: 'cucurbit',
    spacing: 48,
    rowSpacing: 72,
    daysToGermination: 7,
    daysToHarvest: 130,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'bean', 'radish', 'marigold'],
    enemies: ['potato'],
    description: 'orange giant pumpkin. Classic pumpkin for carving or cooking. ',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '15-20 feet',
    family: 'Cucurbitaceae',
    varieties: ['Dill Atlantic Giant'],
    uses: ['carving', 'pie', 'decoration', 'seeds']
  },
  {
    id: 'squash-big-max',
    name: 'Pumpkin - Big Max',
    scientificName: 'Cucurbita pepo',
    category: 'cucurbit',
    spacing: 48,
    rowSpacing: 72,
    daysToGermination: 7,
    daysToHarvest: 120,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'bean', 'radish', 'marigold'],
    enemies: ['potato'],
    description: 'orange giant pumpkin. Classic pumpkin for carving or cooking. ',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '15-20 feet',
    family: 'Cucurbitaceae',
    varieties: ['Big Max'],
    uses: ['carving', 'pie', 'decoration', 'seeds']
  },
  {
    id: 'squash-prizewinner',
    name: 'Pumpkin - Prizewinner',
    scientificName: 'Cucurbita pepo',
    category: 'cucurbit',
    spacing: 48,
    rowSpacing: 72,
    daysToGermination: 7,
    daysToHarvest: 120,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'bean', 'radish', 'marigold'],
    enemies: ['potato'],
    description: 'orange giant pumpkin. Classic pumpkin for carving or cooking. ',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '15-20 feet',
    family: 'Cucurbitaceae',
    varieties: ['Prizewinner'],
    uses: ['carving', 'pie', 'decoration', 'seeds']
  },
  {
    id: 'squash-big-moon',
    name: 'Pumpkin - Big Moon',
    scientificName: 'Cucurbita pepo',
    category: 'cucurbit',
    spacing: 48,
    rowSpacing: 72,
    daysToGermination: 7,
    daysToHarvest: 125,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'bean', 'radish', 'marigold'],
    enemies: ['potato'],
    description: 'orange giant pumpkin. Classic pumpkin for carving or cooking. ',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '15-20 feet',
    family: 'Cucurbitaceae',
    varieties: ['Big Moon'],
    uses: ['carving', 'pie', 'decoration', 'seeds']
  },
  {
    id: 'squash-cinderella',
    name: 'Pumpkin - Cinderella',
    scientificName: 'Cucurbita pepo',
    category: 'cucurbit',
    spacing: 48,
    rowSpacing: 72,
    daysToGermination: 7,
    daysToHarvest: 95,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'bean', 'radish', 'marigold'],
    enemies: ['potato'],
    description: 'red novelty pumpkin. Classic pumpkin for carving or cooking. ',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '6-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Cinderella'],
    uses: ['carving', 'pie', 'decoration', 'seeds']
  },
  {
    id: 'squash-rouge-vif-d-etampes',
    name: 'Pumpkin - Rouge Vif d Etampes',
    scientificName: 'Cucurbita pepo',
    category: 'cucurbit',
    spacing: 48,
    rowSpacing: 72,
    daysToGermination: 7,
    daysToHarvest: 95,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'bean', 'radish', 'marigold'],
    enemies: ['potato'],
    description: 'red novelty pumpkin. Classic pumpkin for carving or cooking. ',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '6-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Rouge Vif d Etampes'],
    uses: ['carving', 'pie', 'decoration', 'seeds']
  },
  {
    id: 'squash-jarrahdale',
    name: 'Pumpkin - Jarrahdale',
    scientificName: 'Cucurbita pepo',
    category: 'cucurbit',
    spacing: 48,
    rowSpacing: 72,
    daysToGermination: 7,
    daysToHarvest: 100,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'bean', 'radish', 'marigold'],
    enemies: ['potato'],
    description: 'blue novelty pumpkin. Classic pumpkin for carving or cooking. ',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '6-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Jarrahdale'],
    uses: ['carving', 'pie', 'decoration', 'seeds']
  },
  {
    id: 'squash-queensland-blue',
    name: 'Pumpkin - Queensland Blue',
    scientificName: 'Cucurbita pepo',
    category: 'cucurbit',
    spacing: 48,
    rowSpacing: 72,
    daysToGermination: 7,
    daysToHarvest: 110,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'bean', 'radish', 'marigold'],
    enemies: ['potato'],
    description: 'blue novelty pumpkin. Classic pumpkin for carving or cooking. ',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '6-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Queensland Blue'],
    uses: ['carving', 'pie', 'decoration', 'seeds']
  },
  {
    id: 'squash-marina-di-chioggia',
    name: 'Pumpkin - Marina di Chioggia',
    scientificName: 'Cucurbita pepo',
    category: 'cucurbit',
    spacing: 48,
    rowSpacing: 72,
    daysToGermination: 7,
    daysToHarvest: 100,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'bean', 'radish', 'marigold'],
    enemies: ['potato'],
    description: 'blue novelty pumpkin. Classic pumpkin for carving or cooking. ',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '6-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Marina di Chioggia'],
    uses: ['carving', 'pie', 'decoration', 'seeds']
  },
  {
    id: 'squash-fairytale',
    name: 'Pumpkin - Fairytale',
    scientificName: 'Cucurbita pepo',
    category: 'cucurbit',
    spacing: 48,
    rowSpacing: 72,
    daysToGermination: 7,
    daysToHarvest: 100,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'bean', 'radish', 'marigold'],
    enemies: ['potato'],
    description: 'tan novelty pumpkin. Classic pumpkin for carving or cooking. ',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '6-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Fairytale'],
    uses: ['carving', 'pie', 'decoration', 'seeds']
  },
  {
    id: 'squash-long-island-cheese',
    name: 'Pumpkin - Long Island Cheese',
    scientificName: 'Cucurbita pepo',
    category: 'cucurbit',
    spacing: 48,
    rowSpacing: 72,
    daysToGermination: 7,
    daysToHarvest: 105,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'bean', 'radish', 'marigold'],
    enemies: ['potato'],
    description: 'tan novelty pumpkin. Classic pumpkin for carving or cooking. ',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '6-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Long Island Cheese'],
    uses: ['carving', 'pie', 'decoration', 'seeds']
  },
  {
    id: 'squash-musquee-de-provence',
    name: 'Pumpkin - Musquee de Provence',
    scientificName: 'Cucurbita pepo',
    category: 'cucurbit',
    spacing: 48,
    rowSpacing: 72,
    daysToGermination: 7,
    daysToHarvest: 105,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'bean', 'radish', 'marigold'],
    enemies: ['potato'],
    description: 'tan novelty pumpkin. Classic pumpkin for carving or cooking. ',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '6-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Musquee de Provence'],
    uses: ['carving', 'pie', 'decoration', 'seeds']
  },
  {
    id: 'squash-one-too-many',
    name: 'Pumpkin - One Too Many',
    scientificName: 'Cucurbita pepo',
    category: 'cucurbit',
    spacing: 48,
    rowSpacing: 72,
    daysToGermination: 7,
    daysToHarvest: 95,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'bean', 'radish', 'marigold'],
    enemies: ['potato'],
    description: 'white novelty pumpkin. Classic pumpkin for carving or cooking. ',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '6-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['One Too Many'],
    uses: ['carving', 'pie', 'decoration', 'seeds']
  },
  {
    id: 'squash-lumina',
    name: 'Pumpkin - Lumina',
    scientificName: 'Cucurbita pepo',
    category: 'cucurbit',
    spacing: 48,
    rowSpacing: 72,
    daysToGermination: 7,
    daysToHarvest: 100,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'bean', 'radish', 'marigold'],
    enemies: ['potato'],
    description: 'white novelty pumpkin. Classic pumpkin for carving or cooking. ',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '6-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Lumina'],
    uses: ['carving', 'pie', 'decoration', 'seeds']
  },
  {
    id: 'squash-casper',
    name: 'Pumpkin - Casper',
    scientificName: 'Cucurbita pepo',
    category: 'cucurbit',
    spacing: 48,
    rowSpacing: 72,
    daysToGermination: 7,
    daysToHarvest: 95,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'bean', 'radish', 'marigold'],
    enemies: ['potato'],
    description: 'white novelty pumpkin. Classic pumpkin for carving or cooking. ',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '6-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Casper'],
    uses: ['carving', 'pie', 'decoration', 'seeds']
  },
  {
    id: 'squash-full-moon',
    name: 'Pumpkin - Full Moon',
    scientificName: 'Cucurbita pepo',
    category: 'cucurbit',
    spacing: 48,
    rowSpacing: 72,
    daysToGermination: 7,
    daysToHarvest: 100,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'bean', 'radish', 'marigold'],
    enemies: ['potato'],
    description: 'white novelty pumpkin. Classic pumpkin for carving or cooking. ',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '6-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Full Moon'],
    uses: ['carving', 'pie', 'decoration', 'seeds']
  },
  {
    id: 'squash-polar-bear',
    name: 'Pumpkin - Polar Bear',
    scientificName: 'Cucurbita pepo',
    category: 'cucurbit',
    spacing: 48,
    rowSpacing: 72,
    daysToGermination: 7,
    daysToHarvest: 105,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'bean', 'radish', 'marigold'],
    enemies: ['potato'],
    description: 'white novelty pumpkin. Classic pumpkin for carving or cooking. ',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '6-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Polar Bear'],
    uses: ['carving', 'pie', 'decoration', 'seeds']
  },
  {
    id: 'squash-galeux-d-eysines',
    name: 'Pumpkin - Galeux d Eysines',
    scientificName: 'Cucurbita pepo',
    category: 'cucurbit',
    spacing: 48,
    rowSpacing: 72,
    daysToGermination: 7,
    daysToHarvest: 100,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'bean', 'radish', 'marigold'],
    enemies: ['potato'],
    description: 'pink novelty pumpkin. Classic pumpkin for carving or cooking. ',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '6-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Galeux d Eysines'],
    uses: ['carving', 'pie', 'decoration', 'seeds']
  },
  {
    id: 'squash-porcelain-doll',
    name: 'Pumpkin - Porcelain Doll',
    scientificName: 'Cucurbita pepo',
    category: 'cucurbit',
    spacing: 48,
    rowSpacing: 72,
    daysToGermination: 7,
    daysToHarvest: 100,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'bean', 'radish', 'marigold'],
    enemies: ['potato'],
    description: 'pink novelty pumpkin. Classic pumpkin for carving or cooking. ',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '6-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Porcelain Doll'],
    uses: ['carving', 'pie', 'decoration', 'seeds']
  },
  {
    id: 'squash-knuckle-head',
    name: 'Pumpkin - Knuckle Head',
    scientificName: 'Cucurbita pepo',
    category: 'cucurbit',
    spacing: 48,
    rowSpacing: 72,
    daysToGermination: 7,
    daysToHarvest: 105,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'bean', 'radish', 'marigold'],
    enemies: ['potato'],
    description: 'warty novelty pumpkin. Classic pumpkin for carving or cooking. ',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '6-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Knuckle Head'],
    uses: ['carving', 'pie', 'decoration', 'seeds']
  },
  {
    id: 'squash-goosebumps',
    name: 'Pumpkin - Goosebumps',
    scientificName: 'Cucurbita pepo',
    category: 'cucurbit',
    spacing: 48,
    rowSpacing: 72,
    daysToGermination: 7,
    daysToHarvest: 100,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'bean', 'radish', 'marigold'],
    enemies: ['potato'],
    description: 'warty novelty pumpkin. Classic pumpkin for carving or cooking. ',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '6-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Goosebumps'],
    uses: ['carving', 'pie', 'decoration', 'seeds']
  },
  {
    id: 'squash-warty-goblin',
    name: 'Pumpkin - Warty Goblin',
    scientificName: 'Cucurbita pepo',
    category: 'cucurbit',
    spacing: 48,
    rowSpacing: 72,
    daysToGermination: 7,
    daysToHarvest: 100,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'bean', 'radish', 'marigold'],
    enemies: ['potato'],
    description: 'warty novelty pumpkin. Classic pumpkin for carving or cooking. ',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '6-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Warty Goblin'],
    uses: ['carving', 'pie', 'decoration', 'seeds']
  }
,
  {
    id: 'cantaloupe-hale-best-jumbo',
    name: 'Muskmelon - Hale Best Jumbo',
    scientificName: 'Cucumis melo',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Hale Best Jumbo muskmelon. Sweet aromatic flesh, slips from vine when ripe.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Hale Best Jumbo'],
    uses: ['fresh', 'dessert', 'fruit salad', 'smoothies']
  },
  {
    id: 'cantaloupe-ambrosia',
    name: 'Muskmelon - Ambrosia',
    scientificName: 'Cucumis melo',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Ambrosia muskmelon. Sweet aromatic flesh, slips from vine when ripe.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Ambrosia'],
    uses: ['fresh', 'dessert', 'fruit salad', 'smoothies']
  },
  {
    id: 'cantaloupe-athena',
    name: 'Muskmelon - Athena',
    scientificName: 'Cucumis melo',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 75,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Athena muskmelon. Sweet aromatic flesh, slips from vine when ripe.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Athena'],
    uses: ['fresh', 'dessert', 'fruit salad', 'smoothies']
  },
  {
    id: 'cantaloupe-sarahs-choice',
    name: 'Muskmelon - Sarahs Choice',
    scientificName: 'Cucumis melo',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 75,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Sarahs Choice muskmelon. Sweet aromatic flesh, slips from vine when ripe.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Sarahs Choice'],
    uses: ['fresh', 'dessert', 'fruit salad', 'smoothies']
  },
  {
    id: 'cantaloupe-sugar-cube',
    name: 'Muskmelon - Sugar Cube',
    scientificName: 'Cucumis melo',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 80,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Sugar Cube muskmelon. Sweet aromatic flesh, slips from vine when ripe.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Sugar Cube'],
    uses: ['fresh', 'dessert', 'fruit salad', 'smoothies']
  },
  {
    id: 'cantaloupe-minnesota-midget',
    name: 'Muskmelon - Minnesota Midget',
    scientificName: 'Cucumis melo',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 70,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Minnesota Midget muskmelon. Sweet aromatic flesh, slips from vine when ripe.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Minnesota Midget'],
    uses: ['fresh', 'dessert', 'fruit salad', 'smoothies']
  },
  {
    id: 'cantaloupe-hearts-of-gold',
    name: 'Muskmelon - Hearts of Gold',
    scientificName: 'Cucumis melo',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Hearts of Gold muskmelon. Sweet aromatic flesh, slips from vine when ripe.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Hearts of Gold'],
    uses: ['fresh', 'dessert', 'fruit salad', 'smoothies']
  },
  {
    id: 'cantaloupe-pmr-45',
    name: 'Muskmelon - PMR 45',
    scientificName: 'Cucumis melo',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'PMR 45 muskmelon. Sweet aromatic flesh, slips from vine when ripe.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['PMR 45'],
    uses: ['fresh', 'dessert', 'fruit salad', 'smoothies']
  },
  {
    id: 'cantaloupe-savor',
    name: 'Muskmelon - Savor',
    scientificName: 'Cucumis melo',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 80,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Savor muskmelon. Sweet aromatic flesh, slips from vine when ripe.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Savor'],
    uses: ['fresh', 'dessert', 'fruit salad', 'smoothies']
  },
  {
    id: 'cantaloupe-tasty-bites',
    name: 'Muskmelon - Tasty Bites',
    scientificName: 'Cucumis melo',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 75,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Tasty Bites muskmelon. Sweet aromatic flesh, slips from vine when ripe.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Tasty Bites'],
    uses: ['fresh', 'dessert', 'fruit salad', 'smoothies']
  },
  {
    id: 'cantaloupe-alvaro',
    name: 'Muskmelon - Alvaro',
    scientificName: 'Cucumis melo',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 75,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Alvaro muskmelon. Sweet aromatic flesh, slips from vine when ripe.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Alvaro'],
    uses: ['fresh', 'dessert', 'fruit salad', 'smoothies']
  },
  {
    id: 'cantaloupe-aphrodite',
    name: 'Muskmelon - Aphrodite',
    scientificName: 'Cucumis melo',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 75,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Aphrodite muskmelon. Sweet aromatic flesh, slips from vine when ripe.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Aphrodite'],
    uses: ['fresh', 'dessert', 'fruit salad', 'smoothies']
  },
  {
    id: 'cantaloupe-arava',
    name: 'Muskmelon - Arava',
    scientificName: 'Cucumis melo',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 75,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Arava muskmelon. Sweet aromatic flesh, slips from vine when ripe.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Arava'],
    uses: ['fresh', 'dessert', 'fruit salad', 'smoothies']
  },
  {
    id: 'cantaloupe-avatar',
    name: 'Muskmelon - Avatar',
    scientificName: 'Cucumis melo',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 75,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Avatar muskmelon. Sweet aromatic flesh, slips from vine when ripe.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Avatar'],
    uses: ['fresh', 'dessert', 'fruit salad', 'smoothies']
  },
  {
    id: 'cantaloupe-caribe',
    name: 'Muskmelon - Caribe',
    scientificName: 'Cucumis melo',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 75,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Caribe muskmelon. Sweet aromatic flesh, slips from vine when ripe.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Caribe'],
    uses: ['fresh', 'dessert', 'fruit salad', 'smoothies']
  },
  {
    id: 'cantaloupe-cordele',
    name: 'Muskmelon - Cordele',
    scientificName: 'Cucumis melo',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 75,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Cordele muskmelon. Sweet aromatic flesh, slips from vine when ripe.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Cordele'],
    uses: ['fresh', 'dessert', 'fruit salad', 'smoothies']
  },
  {
    id: 'cantaloupe-eclipse',
    name: 'Muskmelon - Eclipse',
    scientificName: 'Cucumis melo',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 75,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Eclipse muskmelon. Sweet aromatic flesh, slips from vine when ripe.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Eclipse'],
    uses: ['fresh', 'dessert', 'fruit salad', 'smoothies']
  },
  {
    id: 'cantaloupe-esteem',
    name: 'Muskmelon - Esteem',
    scientificName: 'Cucumis melo',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 75,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Esteem muskmelon. Sweet aromatic flesh, slips from vine when ripe.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Esteem'],
    uses: ['fresh', 'dessert', 'fruit salad', 'smoothies']
  },
  {
    id: 'cantaloupe-fastbreak',
    name: 'Muskmelon - Fastbreak',
    scientificName: 'Cucumis melo',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 70,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Fastbreak muskmelon. Sweet aromatic flesh, slips from vine when ripe.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Fastbreak'],
    uses: ['fresh', 'dessert', 'fruit salad', 'smoothies']
  },
  {
    id: 'cantaloupe-festival',
    name: 'Muskmelon - Festival',
    scientificName: 'Cucumis melo',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 75,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Festival muskmelon. Sweet aromatic flesh, slips from vine when ripe.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Festival'],
    uses: ['fresh', 'dessert', 'fruit salad', 'smoothies']
  },
  {
    id: 'cantaloupe-gold-express',
    name: 'Muskmelon - Gold Express',
    scientificName: 'Cucumis melo',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 75,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Gold Express muskmelon. Sweet aromatic flesh, slips from vine when ripe.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Gold Express'],
    uses: ['fresh', 'dessert', 'fruit salad', 'smoothies']
  },
  {
    id: 'cantaloupe-gold-rush',
    name: 'Muskmelon - Gold Rush',
    scientificName: 'Cucumis melo',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 75,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Gold Rush muskmelon. Sweet aromatic flesh, slips from vine when ripe.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Gold Rush'],
    uses: ['fresh', 'dessert', 'fruit salad', 'smoothies']
  },
  {
    id: 'cantaloupe-grand-sierra',
    name: 'Muskmelon - Grand Sierra',
    scientificName: 'Cucumis melo',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 80,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Grand Sierra muskmelon. Sweet aromatic flesh, slips from vine when ripe.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Grand Sierra'],
    uses: ['fresh', 'dessert', 'fruit salad', 'smoothies']
  },
  {
    id: 'cantaloupe-halona',
    name: 'Muskmelon - Halona',
    scientificName: 'Cucumis melo',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 70,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Halona muskmelon. Sweet aromatic flesh, slips from vine when ripe.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Halona'],
    uses: ['fresh', 'dessert', 'fruit salad', 'smoothies']
  },
  {
    id: 'cantaloupe-hannahs-choice',
    name: 'Muskmelon - Hannahs Choice',
    scientificName: 'Cucumis melo',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 75,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Hannahs Choice muskmelon. Sweet aromatic flesh, slips from vine when ripe.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Hannahs Choice'],
    uses: ['fresh', 'dessert', 'fruit salad', 'smoothies']
  },
  {
    id: 'cantaloupe-infinite-gold',
    name: 'Muskmelon - Infinite Gold',
    scientificName: 'Cucumis melo',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 80,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Infinite Gold muskmelon. Sweet aromatic flesh, slips from vine when ripe.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Infinite Gold'],
    uses: ['fresh', 'dessert', 'fruit salad', 'smoothies']
  },
  {
    id: 'cantaloupe-lilly',
    name: 'Muskmelon - Lilly',
    scientificName: 'Cucumis melo',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 75,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Lilly muskmelon. Sweet aromatic flesh, slips from vine when ripe.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Lilly'],
    uses: ['fresh', 'dessert', 'fruit salad', 'smoothies']
  },
  {
    id: 'cantaloupe-magnum-45',
    name: 'Muskmelon - Magnum 45',
    scientificName: 'Cucumis melo',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Magnum 45 muskmelon. Sweet aromatic flesh, slips from vine when ripe.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Magnum 45'],
    uses: ['fresh', 'dessert', 'fruit salad', 'smoothies']
  },
  {
    id: 'cantaloupe-morning-ice',
    name: 'Muskmelon - Morning Ice',
    scientificName: 'Cucumis melo',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 75,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Morning Ice muskmelon. Sweet aromatic flesh, slips from vine when ripe.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Morning Ice'],
    uses: ['fresh', 'dessert', 'fruit salad', 'smoothies']
  },
  {
    id: 'cantaloupe-olympic-gold',
    name: 'Muskmelon - Olympic Gold',
    scientificName: 'Cucumis melo',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 80,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Olympic Gold muskmelon. Sweet aromatic flesh, slips from vine when ripe.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Olympic Gold'],
    uses: ['fresh', 'dessert', 'fruit salad', 'smoothies']
  },
  {
    id: 'cantaloupe-pacific-gold',
    name: 'Muskmelon - Pacific Gold',
    scientificName: 'Cucumis melo',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 80,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Pacific Gold muskmelon. Sweet aromatic flesh, slips from vine when ripe.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Pacific Gold'],
    uses: ['fresh', 'dessert', 'fruit salad', 'smoothies']
  },
  {
    id: 'cantaloupe-san-juan',
    name: 'Muskmelon - San Juan',
    scientificName: 'Cucumis melo',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 75,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'San Juan muskmelon. Sweet aromatic flesh, slips from vine when ripe.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['San Juan'],
    uses: ['fresh', 'dessert', 'fruit salad', 'smoothies']
  },
  {
    id: 'cantaloupe-sugar-rush',
    name: 'Muskmelon - Sugar Rush',
    scientificName: 'Cucumis melo',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 75,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Sugar Rush muskmelon. Sweet aromatic flesh, slips from vine when ripe.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Sugar Rush'],
    uses: ['fresh', 'dessert', 'fruit salad', 'smoothies']
  },
  {
    id: 'cantaloupe-tasty-bites',
    name: 'Muskmelon - Tasty Bites',
    scientificName: 'Cucumis melo',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 75,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Tasty Bites muskmelon. Sweet aromatic flesh, slips from vine when ripe.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Tasty Bites'],
    uses: ['fresh', 'dessert', 'fruit salad', 'smoothies']
  },
  {
    id: 'cantaloupe-tirreno',
    name: 'Muskmelon - Tirreno',
    scientificName: 'Cucumis melo',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 75,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Tirreno muskmelon. Sweet aromatic flesh, slips from vine when ripe.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Tirreno'],
    uses: ['fresh', 'dessert', 'fruit salad', 'smoothies']
  },
  {
    id: 'cantaloupe-true-love',
    name: 'Muskmelon - True Love',
    scientificName: 'Cucumis melo',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 75,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'True Love muskmelon. Sweet aromatic flesh, slips from vine when ripe.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['True Love'],
    uses: ['fresh', 'dessert', 'fruit salad', 'smoothies']
  },
  {
    id: 'cantaloupe-wrangler',
    name: 'Muskmelon - Wrangler',
    scientificName: 'Cucumis melo',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 75,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Wrangler muskmelon. Sweet aromatic flesh, slips from vine when ripe.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Wrangler'],
    uses: ['fresh', 'dessert', 'fruit salad', 'smoothies']
  },
  {
    id: 'watermelon-crimson-sweet',
    name: 'Watermelon - Crimson Sweet',
    scientificName: 'Citrullus lanatus',
    category: 'cucurbit',
    spacing: 48,
    rowSpacing: 72,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Crimson Sweet watermelon. Standard size, reliable producer.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '10-12 feet',
    family: 'Cucurbitaceae',
    varieties: ['Crimson Sweet'],
    uses: ['fresh', 'dessert', 'fruit salad', 'smoothies']
  },
  {
    id: 'watermelon-sugar-baby',
    name: 'Watermelon - Sugar Baby',
    scientificName: 'Citrullus lanatus',
    category: 'cucurbit',
    spacing: 48,
    rowSpacing: 72,
    daysToGermination: 7,
    daysToHarvest: 75,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Sugar Baby watermelon. Standard size, reliable producer.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '10-12 feet',
    family: 'Cucurbitaceae',
    varieties: ['Sugar Baby'],
    uses: ['fresh', 'dessert', 'fruit salad', 'smoothies']
  },
  {
    id: 'watermelon-yellow-doll',
    name: 'Watermelon - Yellow Doll',
    scientificName: 'Citrullus lanatus',
    category: 'cucurbit',
    spacing: 48,
    rowSpacing: 72,
    daysToGermination: 7,
    daysToHarvest: 70,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Yellow Doll watermelon. Icebox size, perfect for small families.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '10-12 feet',
    family: 'Cucurbitaceae',
    varieties: ['Yellow Doll'],
    uses: ['fresh', 'dessert', 'fruit salad', 'smoothies']
  },
  {
    id: 'watermelon-moon-and-stars',
    name: 'Watermelon - Moon and Stars',
    scientificName: 'Citrullus lanatus',
    category: 'cucurbit',
    spacing: 48,
    rowSpacing: 72,
    daysToGermination: 7,
    daysToHarvest: 90,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Moon and Stars watermelon. Large picnic size, sweet and juicy.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '10-12 feet',
    family: 'Cucurbitaceae',
    varieties: ['Moon and Stars'],
    uses: ['fresh', 'dessert', 'fruit salad', 'smoothies']
  },
  {
    id: 'watermelon-charleston-gray',
    name: 'Watermelon - Charleston Gray',
    scientificName: 'Citrullus lanatus',
    category: 'cucurbit',
    spacing: 48,
    rowSpacing: 72,
    daysToGermination: 7,
    daysToHarvest: 90,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Charleston Gray watermelon. Large picnic size, sweet and juicy.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '10-12 feet',
    family: 'Cucurbitaceae',
    varieties: ['Charleston Gray'],
    uses: ['fresh', 'dessert', 'fruit salad', 'smoothies']
  },
  {
    id: 'watermelon-jubilee',
    name: 'Watermelon - Jubilee',
    scientificName: 'Citrullus lanatus',
    category: 'cucurbit',
    spacing: 48,
    rowSpacing: 72,
    daysToGermination: 7,
    daysToHarvest: 95,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Jubilee watermelon. Large picnic size, sweet and juicy.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '10-12 feet',
    family: 'Cucurbitaceae',
    varieties: ['Jubilee'],
    uses: ['fresh', 'dessert', 'fruit salad', 'smoothies']
  },
  {
    id: 'watermelon-allsweet',
    name: 'Watermelon - Allsweet',
    scientificName: 'Citrullus lanatus',
    category: 'cucurbit',
    spacing: 48,
    rowSpacing: 72,
    daysToGermination: 7,
    daysToHarvest: 90,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Allsweet watermelon. Large picnic size, sweet and juicy.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '10-12 feet',
    family: 'Cucurbitaceae',
    varieties: ['Allsweet'],
    uses: ['fresh', 'dessert', 'fruit salad', 'smoothies']
  },
  {
    id: 'watermelon-congo',
    name: 'Watermelon - Congo',
    scientificName: 'Citrullus lanatus',
    category: 'cucurbit',
    spacing: 48,
    rowSpacing: 72,
    daysToGermination: 7,
    daysToHarvest: 95,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Congo watermelon. Large picnic size, sweet and juicy.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '10-12 feet',
    family: 'Cucurbitaceae',
    varieties: ['Congo'],
    uses: ['fresh', 'dessert', 'fruit salad', 'smoothies']
  },
  {
    id: 'watermelon-black-diamond',
    name: 'Watermelon - Black Diamond',
    scientificName: 'Citrullus lanatus',
    category: 'cucurbit',
    spacing: 48,
    rowSpacing: 72,
    daysToGermination: 7,
    daysToHarvest: 90,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Black Diamond watermelon. Large picnic size, sweet and juicy.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '10-12 feet',
    family: 'Cucurbitaceae',
    varieties: ['Black Diamond'],
    uses: ['fresh', 'dessert', 'fruit salad', 'smoothies']
  },
  {
    id: 'watermelon-royal-majesty',
    name: 'Watermelon - Royal Majesty',
    scientificName: 'Citrullus lanatus',
    category: 'cucurbit',
    spacing: 48,
    rowSpacing: 72,
    daysToGermination: 7,
    daysToHarvest: 90,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Royal Majesty watermelon. Large picnic size, sweet and juicy.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '10-12 feet',
    family: 'Cucurbitaceae',
    varieties: ['Royal Majesty'],
    uses: ['fresh', 'dessert', 'fruit salad', 'smoothies']
  },
  {
    id: 'watermelon-sangria',
    name: 'Watermelon - Sangria',
    scientificName: 'Citrullus lanatus',
    category: 'cucurbit',
    spacing: 48,
    rowSpacing: 72,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Sangria watermelon. Standard size, reliable producer.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '10-12 feet',
    family: 'Cucurbitaceae',
    varieties: ['Sangria'],
    uses: ['fresh', 'dessert', 'fruit salad', 'smoothies']
  },
  {
    id: 'watermelon-shiny-boy',
    name: 'Watermelon - Shiny Boy',
    scientificName: 'Citrullus lanatus',
    category: 'cucurbit',
    spacing: 48,
    rowSpacing: 72,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Shiny Boy watermelon. Standard size, reliable producer.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '10-12 feet',
    family: 'Cucurbitaceae',
    varieties: ['Shiny Boy'],
    uses: ['fresh', 'dessert', 'fruit salad', 'smoothies']
  },
  {
    id: 'watermelon-summer-sweet-5244',
    name: 'Watermelon - Summer Sweet 5244',
    scientificName: 'Citrullus lanatus',
    category: 'cucurbit',
    spacing: 48,
    rowSpacing: 72,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Summer Sweet 5244 watermelon. Standard size, reliable producer.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '10-12 feet',
    family: 'Cucurbitaceae',
    varieties: ['Summer Sweet 5244'],
    uses: ['fresh', 'dessert', 'fruit salad', 'smoothies']
  },
  {
    id: 'watermelon-tiger-baby',
    name: 'Watermelon - Tiger Baby',
    scientificName: 'Citrullus lanatus',
    category: 'cucurbit',
    spacing: 48,
    rowSpacing: 72,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Tiger Baby watermelon. Standard size, reliable producer.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '10-12 feet',
    family: 'Cucurbitaceae',
    varieties: ['Tiger Baby'],
    uses: ['fresh', 'dessert', 'fruit salad', 'smoothies']
  },
  {
    id: 'watermelon-triple-crown',
    name: 'Watermelon - Triple Crown',
    scientificName: 'Citrullus lanatus',
    category: 'cucurbit',
    spacing: 48,
    rowSpacing: 72,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Triple Crown watermelon. Standard size, reliable producer.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '10-12 feet',
    family: 'Cucurbitaceae',
    varieties: ['Triple Crown'],
    uses: ['fresh', 'dessert', 'fruit salad', 'smoothies']
  },
  {
    id: 'watermelon-yellow-crimson',
    name: 'Watermelon - Yellow Crimson',
    scientificName: 'Citrullus lanatus',
    category: 'cucurbit',
    spacing: 48,
    rowSpacing: 72,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Yellow Crimson watermelon. Standard size, reliable producer.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '10-12 feet',
    family: 'Cucurbitaceae',
    varieties: ['Yellow Crimson'],
    uses: ['fresh', 'dessert', 'fruit salad', 'smoothies']
  },
  {
    id: 'watermelon-orangeglo',
    name: 'Watermelon - Orangeglo',
    scientificName: 'Citrullus lanatus',
    category: 'cucurbit',
    spacing: 48,
    rowSpacing: 72,
    daysToGermination: 7,
    daysToHarvest: 90,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Orangeglo watermelon. Large picnic size, sweet and juicy.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '10-12 feet',
    family: 'Cucurbitaceae',
    varieties: ['Orangeglo'],
    uses: ['fresh', 'dessert', 'fruit salad', 'smoothies']
  },
  {
    id: 'watermelon-moon-and-stars-red',
    name: 'Watermelon - Moon and Stars Red',
    scientificName: 'Citrullus lanatus',
    category: 'cucurbit',
    spacing: 48,
    rowSpacing: 72,
    daysToGermination: 7,
    daysToHarvest: 90,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Moon and Stars Red watermelon. Large picnic size, sweet and juicy.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '10-12 feet',
    family: 'Cucurbitaceae',
    varieties: ['Moon and Stars Red'],
    uses: ['fresh', 'dessert', 'fruit salad', 'smoothies']
  },
  {
    id: 'watermelon-moon-and-stars-yellow',
    name: 'Watermelon - Moon and Stars Yellow',
    scientificName: 'Citrullus lanatus',
    category: 'cucurbit',
    spacing: 48,
    rowSpacing: 72,
    daysToGermination: 7,
    daysToHarvest: 90,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Moon and Stars Yellow watermelon. Large picnic size, sweet and juicy.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '10-12 feet',
    family: 'Cucurbitaceae',
    varieties: ['Moon and Stars Yellow'],
    uses: ['fresh', 'dessert', 'fruit salad', 'smoothies']
  },
  {
    id: 'watermelon-cream-of-saskatchewan',
    name: 'Watermelon - Cream of Saskatchewan',
    scientificName: 'Citrullus lanatus',
    category: 'cucurbit',
    spacing: 48,
    rowSpacing: 72,
    daysToGermination: 7,
    daysToHarvest: 80,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Cream of Saskatchewan watermelon. Standard size, reliable producer.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '10-12 feet',
    family: 'Cucurbitaceae',
    varieties: ['Cream of Saskatchewan'],
    uses: ['fresh', 'dessert', 'fruit salad', 'smoothies']
  },
  {
    id: 'watermelon-golden-midget',
    name: 'Watermelon - Golden Midget',
    scientificName: 'Citrullus lanatus',
    category: 'cucurbit',
    spacing: 48,
    rowSpacing: 72,
    daysToGermination: 7,
    daysToHarvest: 70,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Golden Midget watermelon. Icebox size, perfect for small families.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '10-12 feet',
    family: 'Cucurbitaceae',
    varieties: ['Golden Midget'],
    uses: ['fresh', 'dessert', 'fruit salad', 'smoothies']
  },
  {
    id: 'watermelon-new-hampshire-midget',
    name: 'Watermelon - New Hampshire Midget',
    scientificName: 'Citrullus lanatus',
    category: 'cucurbit',
    spacing: 48,
    rowSpacing: 72,
    daysToGermination: 7,
    daysToHarvest: 70,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'New Hampshire Midget watermelon. Icebox size, perfect for small families.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '10-12 feet',
    family: 'Cucurbitaceae',
    varieties: ['New Hampshire Midget'],
    uses: ['fresh', 'dessert', 'fruit salad', 'smoothies']
  },
  {
    id: 'watermelon-mickey-lee',
    name: 'Watermelon - Mickey Lee',
    scientificName: 'Citrullus lanatus',
    category: 'cucurbit',
    spacing: 48,
    rowSpacing: 72,
    daysToGermination: 7,
    daysToHarvest: 80,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Mickey Lee watermelon. Standard size, reliable producer.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '10-12 feet',
    family: 'Cucurbitaceae',
    varieties: ['Mickey Lee'],
    uses: ['fresh', 'dessert', 'fruit salad', 'smoothies']
  },
  {
    id: 'watermelon-little-baby-flower',
    name: 'Watermelon - Little Baby Flower',
    scientificName: 'Citrullus lanatus',
    category: 'cucurbit',
    spacing: 48,
    rowSpacing: 72,
    daysToGermination: 7,
    daysToHarvest: 75,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Little Baby Flower watermelon. Standard size, reliable producer.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '10-12 feet',
    family: 'Cucurbitaceae',
    varieties: ['Little Baby Flower'],
    uses: ['fresh', 'dessert', 'fruit salad', 'smoothies']
  },
  {
    id: 'watermelon-garden-baby',
    name: 'Watermelon - Garden Baby',
    scientificName: 'Citrullus lanatus',
    category: 'cucurbit',
    spacing: 48,
    rowSpacing: 72,
    daysToGermination: 7,
    daysToHarvest: 75,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Garden Baby watermelon. Standard size, reliable producer.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '10-12 feet',
    family: 'Cucurbitaceae',
    varieties: ['Garden Baby'],
    uses: ['fresh', 'dessert', 'fruit salad', 'smoothies']
  },
  {
    id: 'watermelon-mini-love',
    name: 'Watermelon - Mini Love',
    scientificName: 'Citrullus lanatus',
    category: 'cucurbit',
    spacing: 48,
    rowSpacing: 72,
    daysToGermination: 7,
    daysToHarvest: 70,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Mini Love watermelon. Icebox size, perfect for small families.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '10-12 feet',
    family: 'Cucurbitaceae',
    varieties: ['Mini Love'],
    uses: ['fresh', 'dessert', 'fruit salad', 'smoothies']
  },
  {
    id: 'watermelon-solitaire',
    name: 'Watermelon - Solitaire',
    scientificName: 'Citrullus lanatus',
    category: 'cucurbit',
    spacing: 48,
    rowSpacing: 72,
    daysToGermination: 7,
    daysToHarvest: 80,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Solitaire watermelon. Standard size, reliable producer.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '10-12 feet',
    family: 'Cucurbitaceae',
    varieties: ['Solitaire'],
    uses: ['fresh', 'dessert', 'fruit salad', 'smoothies']
  },
  {
    id: 'honeydew-honey-dew-green-flesh',
    name: 'Honeydew - Honey Dew Green Flesh',
    scientificName: 'Cucumis melo',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 90,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Honey Dew Green Flesh honeydew. Sweet aromatic flesh, slips from vine when ripe.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Honey Dew Green Flesh'],
    uses: ['fresh', 'dessert', 'fruit salad', 'smoothies']
  },
  {
    id: 'honeydew-honey-orange',
    name: 'Honeydew - Honey Orange',
    scientificName: 'Cucumis melo',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 90,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Honey Orange honeydew. Sweet aromatic flesh, slips from vine when ripe.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Honey Orange'],
    uses: ['fresh', 'dessert', 'fruit salad', 'smoothies']
  },
  {
    id: 'honeydew-temptation',
    name: 'Honeydew - Temptation',
    scientificName: 'Cucumis melo',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 90,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Temptation honeydew. Sweet aromatic flesh, slips from vine when ripe.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Temptation'],
    uses: ['fresh', 'dessert', 'fruit salad', 'smoothies']
  },
  {
    id: 'honeydew-passport',
    name: 'Honeydew - Passport',
    scientificName: 'Cucumis melo',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 90,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Passport honeydew. Sweet aromatic flesh, slips from vine when ripe.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Passport'],
    uses: ['fresh', 'dessert', 'fruit salad', 'smoothies']
  }
,
  {
    id: 'cucumber-marketmore',
    name: 'Cucumber - Marketmore',
    scientificName: 'Cucumis sativus',
    category: 'cucurbit',
    spacing: 12,
    rowSpacing: 36,
    daysToGermination: 7,
    daysToHarvest: 55,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'bean', 'radish', 'marigold'],
    enemies: ['potato', 'aromatic herbs'],
    description: 'green slicing cucumber. Classic slicing cucumber for fresh eating.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '2-3 feet',
    family: 'Cucurbitaceae',
    varieties: ['Marketmore'],
    uses: ['fresh', 'salads', 'sandwiches']
  },
  {
    id: 'cucumber-straight-eight',
    name: 'Cucumber - Straight Eight',
    scientificName: 'Cucumis sativus',
    category: 'cucurbit',
    spacing: 12,
    rowSpacing: 36,
    daysToGermination: 7,
    daysToHarvest: 50,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'bean', 'radish', 'marigold'],
    enemies: ['potato', 'aromatic herbs'],
    description: 'white pickling cucumber. Perfect size and texture for pickling.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '2-3 feet',
    family: 'Cucurbitaceae',
    varieties: ['Straight Eight'],
    uses: ['pickling', 'fresh']
  },
  {
    id: 'cucumber-national-pickling',
    name: 'Cucumber - National Pickling',
    scientificName: 'Cucumis sativus',
    category: 'cucurbit',
    spacing: 18,
    rowSpacing: 36,
    daysToGermination: 7,
    daysToHarvest: 60,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'bean', 'radish', 'marigold'],
    enemies: ['potato', 'aromatic herbs'],
    description: 'yellow asian cucumber. Long slender fruits, burpless and sweet.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '2-3 feet',
    family: 'Cucurbitaceae',
    varieties: ['National Pickling'],
    uses: ['fresh', 'salads', 'sandwiches']
  },
  {
    id: 'cucumber-boston-pickling',
    name: 'Cucumber - Boston Pickling',
    scientificName: 'Cucumis sativus',
    category: 'cucurbit',
    spacing: 18,
    rowSpacing: 36,
    daysToGermination: 7,
    daysToHarvest: 55,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'bean', 'radish', 'marigold'],
    enemies: ['potato', 'aromatic herbs'],
    description: 'striped specialty cucumber. Unique shape or color for specialty markets.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '2-3 feet',
    family: 'Cucurbitaceae',
    varieties: ['Boston Pickling'],
    uses: ['fresh', 'salads', 'sandwiches']
  },
  {
    id: 'cucumber-diva',
    name: 'Cucumber - Diva',
    scientificName: 'Cucumis sativus',
    category: 'cucurbit',
    spacing: 12,
    rowSpacing: 36,
    daysToGermination: 7,
    daysToHarvest: 55,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'bean', 'radish', 'marigold'],
    enemies: ['potato', 'aromatic herbs'],
    description: 'green slicing cucumber. Classic slicing cucumber for fresh eating.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '2-3 feet',
    family: 'Cucurbitaceae',
    varieties: ['Diva'],
    uses: ['fresh', 'salads', 'sandwiches']
  },
  {
    id: 'cucumber-county-fair',
    name: 'Cucumber - County Fair',
    scientificName: 'Cucumis sativus',
    category: 'cucurbit',
    spacing: 12,
    rowSpacing: 36,
    daysToGermination: 7,
    daysToHarvest: 50,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'bean', 'radish', 'marigold'],
    enemies: ['potato', 'aromatic herbs'],
    description: 'white pickling cucumber. Perfect size and texture for pickling.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '2-3 feet',
    family: 'Cucurbitaceae',
    varieties: ['County Fair'],
    uses: ['pickling', 'fresh']
  },
  {
    id: 'cucumber-salad-bush',
    name: 'Cucumber - Salad Bush',
    scientificName: 'Cucumis sativus',
    category: 'cucurbit',
    spacing: 18,
    rowSpacing: 36,
    daysToGermination: 7,
    daysToHarvest: 60,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'bean', 'radish', 'marigold'],
    enemies: ['potato', 'aromatic herbs'],
    description: 'yellow asian cucumber. Long slender fruits, burpless and sweet.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '2-3 feet',
    family: 'Cucurbitaceae',
    varieties: ['Salad Bush'],
    uses: ['fresh', 'salads', 'sandwiches']
  },
  {
    id: 'cucumber-spacemaster',
    name: 'Cucumber - Spacemaster',
    scientificName: 'Cucumis sativus',
    category: 'cucurbit',
    spacing: 18,
    rowSpacing: 36,
    daysToGermination: 7,
    daysToHarvest: 55,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'bean', 'radish', 'marigold'],
    enemies: ['potato', 'aromatic herbs'],
    description: 'striped specialty cucumber. Unique shape or color for specialty markets.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '2-3 feet',
    family: 'Cucurbitaceae',
    varieties: ['Spacemaster'],
    uses: ['fresh', 'salads', 'sandwiches']
  },
  {
    id: 'cucumber-bush-champion',
    name: 'Cucumber - Bush Champion',
    scientificName: 'Cucumis sativus',
    category: 'cucurbit',
    spacing: 12,
    rowSpacing: 36,
    daysToGermination: 7,
    daysToHarvest: 55,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'bean', 'radish', 'marigold'],
    enemies: ['potato', 'aromatic herbs'],
    description: 'green slicing cucumber. Classic slicing cucumber for fresh eating.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '2-3 feet',
    family: 'Cucurbitaceae',
    varieties: ['Bush Champion'],
    uses: ['fresh', 'salads', 'sandwiches']
  },
  {
    id: 'cucumber-picklebush',
    name: 'Cucumber - Picklebush',
    scientificName: 'Cucumis sativus',
    category: 'cucurbit',
    spacing: 12,
    rowSpacing: 36,
    daysToGermination: 7,
    daysToHarvest: 50,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'bean', 'radish', 'marigold'],
    enemies: ['potato', 'aromatic herbs'],
    description: 'white pickling cucumber. Perfect size and texture for pickling.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '2-3 feet',
    family: 'Cucurbitaceae',
    varieties: ['Picklebush'],
    uses: ['pickling', 'fresh']
  },
  {
    id: 'cucumber-homemade-pickles',
    name: 'Cucumber - Homemade Pickles',
    scientificName: 'Cucumis sativus',
    category: 'cucurbit',
    spacing: 18,
    rowSpacing: 36,
    daysToGermination: 7,
    daysToHarvest: 60,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'bean', 'radish', 'marigold'],
    enemies: ['potato', 'aromatic herbs'],
    description: 'yellow asian cucumber. Long slender fruits, burpless and sweet.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '2-3 feet',
    family: 'Cucurbitaceae',
    varieties: ['Homemade Pickles'],
    uses: ['fresh', 'salads', 'sandwiches']
  },
  {
    id: 'cucumber-chicago-pickling',
    name: 'Cucumber - Chicago Pickling',
    scientificName: 'Cucumis sativus',
    category: 'cucurbit',
    spacing: 18,
    rowSpacing: 36,
    daysToGermination: 7,
    daysToHarvest: 55,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'bean', 'radish', 'marigold'],
    enemies: ['potato', 'aromatic herbs'],
    description: 'striped specialty cucumber. Unique shape or color for specialty markets.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '2-3 feet',
    family: 'Cucurbitaceae',
    varieties: ['Chicago Pickling'],
    uses: ['fresh', 'salads', 'sandwiches']
  },
  {
    id: 'cucumber-little-leaf',
    name: 'Cucumber - Little Leaf',
    scientificName: 'Cucumis sativus',
    category: 'cucurbit',
    spacing: 12,
    rowSpacing: 36,
    daysToGermination: 7,
    daysToHarvest: 55,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'bean', 'radish', 'marigold'],
    enemies: ['potato', 'aromatic herbs'],
    description: 'green slicing cucumber. Classic slicing cucumber for fresh eating.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '2-3 feet',
    family: 'Cucurbitaceae',
    varieties: ['Little Leaf'],
    uses: ['fresh', 'salads', 'sandwiches']
  },
  {
    id: 'cucumber-socrates',
    name: 'Cucumber - Socrates',
    scientificName: 'Cucumis sativus',
    category: 'cucurbit',
    spacing: 12,
    rowSpacing: 36,
    daysToGermination: 7,
    daysToHarvest: 50,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'bean', 'radish', 'marigold'],
    enemies: ['potato', 'aromatic herbs'],
    description: 'white pickling cucumber. Perfect size and texture for pickling.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '2-3 feet',
    family: 'Cucurbitaceae',
    varieties: ['Socrates'],
    uses: ['pickling', 'fresh']
  },
  {
    id: 'cucumber-corinto',
    name: 'Cucumber - Corinto',
    scientificName: 'Cucumis sativus',
    category: 'cucurbit',
    spacing: 18,
    rowSpacing: 36,
    daysToGermination: 7,
    daysToHarvest: 60,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'bean', 'radish', 'marigold'],
    enemies: ['potato', 'aromatic herbs'],
    description: 'yellow asian cucumber. Long slender fruits, burpless and sweet.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '2-3 feet',
    family: 'Cucurbitaceae',
    varieties: ['Corinto'],
    uses: ['fresh', 'salads', 'sandwiches']
  },
  {
    id: 'cucumber-excelsior',
    name: 'Cucumber - Excelsior',
    scientificName: 'Cucumis sativus',
    category: 'cucurbit',
    spacing: 18,
    rowSpacing: 36,
    daysToGermination: 7,
    daysToHarvest: 55,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'bean', 'radish', 'marigold'],
    enemies: ['potato', 'aromatic herbs'],
    description: 'striped specialty cucumber. Unique shape or color for specialty markets.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '2-3 feet',
    family: 'Cucurbitaceae',
    varieties: ['Excelsior'],
    uses: ['fresh', 'salads', 'sandwiches']
  },
  {
    id: 'cucumber-fanfare',
    name: 'Cucumber - Fanfare',
    scientificName: 'Cucumis sativus',
    category: 'cucurbit',
    spacing: 12,
    rowSpacing: 36,
    daysToGermination: 7,
    daysToHarvest: 55,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'bean', 'radish', 'marigold'],
    enemies: ['potato', 'aromatic herbs'],
    description: 'green slicing cucumber. Classic slicing cucumber for fresh eating.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '2-3 feet',
    family: 'Cucurbitaceae',
    varieties: ['Fanfare'],
    uses: ['fresh', 'salads', 'sandwiches']
  },
  {
    id: 'cucumber-greensleeves',
    name: 'Cucumber - Greensleeves',
    scientificName: 'Cucumis sativus',
    category: 'cucurbit',
    spacing: 12,
    rowSpacing: 36,
    daysToGermination: 7,
    daysToHarvest: 50,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'bean', 'radish', 'marigold'],
    enemies: ['potato', 'aromatic herbs'],
    description: 'white pickling cucumber. Perfect size and texture for pickling.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '2-3 feet',
    family: 'Cucurbitaceae',
    varieties: ['Greensleeves'],
    uses: ['pickling', 'fresh']
  },
  {
    id: 'cucumber-harmony',
    name: 'Cucumber - Harmony',
    scientificName: 'Cucumis sativus',
    category: 'cucurbit',
    spacing: 18,
    rowSpacing: 36,
    daysToGermination: 7,
    daysToHarvest: 60,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'bean', 'radish', 'marigold'],
    enemies: ['potato', 'aromatic herbs'],
    description: 'yellow asian cucumber. Long slender fruits, burpless and sweet.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '2-3 feet',
    family: 'Cucurbitaceae',
    varieties: ['Harmony'],
    uses: ['fresh', 'salads', 'sandwiches']
  },
  {
    id: 'cucumber-jackson',
    name: 'Cucumber - Jackson',
    scientificName: 'Cucumis sativus',
    category: 'cucurbit',
    spacing: 18,
    rowSpacing: 36,
    daysToGermination: 7,
    daysToHarvest: 55,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'bean', 'radish', 'marigold'],
    enemies: ['potato', 'aromatic herbs'],
    description: 'striped specialty cucumber. Unique shape or color for specialty markets.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '2-3 feet',
    family: 'Cucurbitaceae',
    varieties: ['Jackson'],
    uses: ['fresh', 'salads', 'sandwiches']
  },
  {
    id: 'cucumber-jawell',
    name: 'Cucumber - Jawell',
    scientificName: 'Cucumis sativus',
    category: 'cucurbit',
    spacing: 12,
    rowSpacing: 36,
    daysToGermination: 7,
    daysToHarvest: 55,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'bean', 'radish', 'marigold'],
    enemies: ['potato', 'aromatic herbs'],
    description: 'green slicing cucumber. Classic slicing cucumber for fresh eating.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '2-3 feet',
    family: 'Cucurbitaceae',
    varieties: ['Jawell'],
    uses: ['fresh', 'salads', 'sandwiches']
  },
  {
    id: 'cucumber-katrina',
    name: 'Cucumber - Katrina',
    scientificName: 'Cucumis sativus',
    category: 'cucurbit',
    spacing: 12,
    rowSpacing: 36,
    daysToGermination: 7,
    daysToHarvest: 50,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'bean', 'radish', 'marigold'],
    enemies: ['potato', 'aromatic herbs'],
    description: 'white pickling cucumber. Perfect size and texture for pickling.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '2-3 feet',
    family: 'Cucurbitaceae',
    varieties: ['Katrina'],
    uses: ['pickling', 'fresh']
  },
  {
    id: 'cucumber-lemon',
    name: 'Cucumber - Lemon',
    scientificName: 'Cucumis sativus',
    category: 'cucurbit',
    spacing: 18,
    rowSpacing: 36,
    daysToGermination: 7,
    daysToHarvest: 60,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'bean', 'radish', 'marigold'],
    enemies: ['potato', 'aromatic herbs'],
    description: 'yellow asian cucumber. Long slender fruits, burpless and sweet.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '2-3 feet',
    family: 'Cucurbitaceae',
    varieties: ['Lemon'],
    uses: ['fresh', 'salads', 'sandwiches']
  },
  {
    id: 'cucumber-manny',
    name: 'Cucumber - Manny',
    scientificName: 'Cucumis sativus',
    category: 'cucurbit',
    spacing: 18,
    rowSpacing: 36,
    daysToGermination: 7,
    daysToHarvest: 55,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'bean', 'radish', 'marigold'],
    enemies: ['potato', 'aromatic herbs'],
    description: 'striped specialty cucumber. Unique shape or color for specialty markets.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '2-3 feet',
    family: 'Cucurbitaceae',
    varieties: ['Manny'],
    uses: ['fresh', 'salads', 'sandwiches']
  },
  {
    id: 'cucumber-orient-express',
    name: 'Cucumber - Orient Express',
    scientificName: 'Cucumis sativus',
    category: 'cucurbit',
    spacing: 12,
    rowSpacing: 36,
    daysToGermination: 7,
    daysToHarvest: 55,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'bean', 'radish', 'marigold'],
    enemies: ['potato', 'aromatic herbs'],
    description: 'green slicing cucumber. Classic slicing cucumber for fresh eating.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '2-3 feet',
    family: 'Cucurbitaceae',
    varieties: ['Orient Express'],
    uses: ['fresh', 'salads', 'sandwiches']
  },
  {
    id: 'cucumber-poinsett-76',
    name: 'Cucumber - Poinsett 76',
    scientificName: 'Cucumis sativus',
    category: 'cucurbit',
    spacing: 12,
    rowSpacing: 36,
    daysToGermination: 7,
    daysToHarvest: 50,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'bean', 'radish', 'marigold'],
    enemies: ['potato', 'aromatic herbs'],
    description: 'white pickling cucumber. Perfect size and texture for pickling.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '2-3 feet',
    family: 'Cucurbitaceae',
    varieties: ['Poinsett 76'],
    uses: ['pickling', 'fresh']
  },
  {
    id: 'cucumber-saladin',
    name: 'Cucumber - Saladin',
    scientificName: 'Cucumis sativus',
    category: 'cucurbit',
    spacing: 18,
    rowSpacing: 36,
    daysToGermination: 7,
    daysToHarvest: 60,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'bean', 'radish', 'marigold'],
    enemies: ['potato', 'aromatic herbs'],
    description: 'yellow asian cucumber. Long slender fruits, burpless and sweet.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '2-3 feet',
    family: 'Cucurbitaceae',
    varieties: ['Saladin'],
    uses: ['fresh', 'salads', 'sandwiches']
  },
  {
    id: 'cucumber-suyo-long',
    name: 'Cucumber - Suyo Long',
    scientificName: 'Cucumis sativus',
    category: 'cucurbit',
    spacing: 18,
    rowSpacing: 36,
    daysToGermination: 7,
    daysToHarvest: 55,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'bean', 'radish', 'marigold'],
    enemies: ['potato', 'aromatic herbs'],
    description: 'striped specialty cucumber. Unique shape or color for specialty markets.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '2-3 feet',
    family: 'Cucurbitaceae',
    varieties: ['Suyo Long'],
    uses: ['fresh', 'salads', 'sandwiches']
  },
  {
    id: 'cucumber-tasty-green',
    name: 'Cucumber - Tasty Green',
    scientificName: 'Cucumis sativus',
    category: 'cucurbit',
    spacing: 12,
    rowSpacing: 36,
    daysToGermination: 7,
    daysToHarvest: 55,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'bean', 'radish', 'marigold'],
    enemies: ['potato', 'aromatic herbs'],
    description: 'green slicing cucumber. Classic slicing cucumber for fresh eating.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '2-3 feet',
    family: 'Cucurbitaceae',
    varieties: ['Tasty Green'],
    uses: ['fresh', 'salads', 'sandwiches']
  },
  {
    id: 'cucumber-tendergreen-burpless',
    name: 'Cucumber - Tendergreen Burpless',
    scientificName: 'Cucumis sativus',
    category: 'cucurbit',
    spacing: 12,
    rowSpacing: 36,
    daysToGermination: 7,
    daysToHarvest: 50,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'bean', 'radish', 'marigold'],
    enemies: ['potato', 'aromatic herbs'],
    description: 'white pickling cucumber. Perfect size and texture for pickling.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '2-3 feet',
    family: 'Cucurbitaceae',
    varieties: ['Tendergreen Burpless'],
    uses: ['pickling', 'fresh']
  },
  {
    id: 'cucumber-tyria',
    name: 'Cucumber - Tyria',
    scientificName: 'Cucumis sativus',
    category: 'cucurbit',
    spacing: 18,
    rowSpacing: 36,
    daysToGermination: 7,
    daysToHarvest: 60,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'bean', 'radish', 'marigold'],
    enemies: ['potato', 'aromatic herbs'],
    description: 'yellow asian cucumber. Long slender fruits, burpless and sweet.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '2-3 feet',
    family: 'Cucurbitaceae',
    varieties: ['Tyria'],
    uses: ['fresh', 'salads', 'sandwiches']
  },
  {
    id: 'cucumber-unagi',
    name: 'Cucumber - Unagi',
    scientificName: 'Cucumis sativus',
    category: 'cucurbit',
    spacing: 18,
    rowSpacing: 36,
    daysToGermination: 7,
    daysToHarvest: 55,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'bean', 'radish', 'marigold'],
    enemies: ['potato', 'aromatic herbs'],
    description: 'striped specialty cucumber. Unique shape or color for specialty markets.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '2-3 feet',
    family: 'Cucurbitaceae',
    varieties: ['Unagi'],
    uses: ['fresh', 'salads', 'sandwiches']
  },
  {
    id: 'cucumber-vlasstar',
    name: 'Cucumber - Vlasstar',
    scientificName: 'Cucumis sativus',
    category: 'cucurbit',
    spacing: 12,
    rowSpacing: 36,
    daysToGermination: 7,
    daysToHarvest: 55,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'bean', 'radish', 'marigold'],
    enemies: ['potato', 'aromatic herbs'],
    description: 'green slicing cucumber. Classic slicing cucumber for fresh eating.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '2-3 feet',
    family: 'Cucurbitaceae',
    varieties: ['Vlasstar'],
    uses: ['fresh', 'salads', 'sandwiches']
  },
  {
    id: 'cucumber-wautoma',
    name: 'Cucumber - Wautoma',
    scientificName: 'Cucumis sativus',
    category: 'cucurbit',
    spacing: 12,
    rowSpacing: 36,
    daysToGermination: 7,
    daysToHarvest: 50,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'bean', 'radish', 'marigold'],
    enemies: ['potato', 'aromatic herbs'],
    description: 'white pickling cucumber. Perfect size and texture for pickling.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '2-3 feet',
    family: 'Cucurbitaceae',
    varieties: ['Wautoma'],
    uses: ['pickling', 'fresh']
  },
  {
    id: 'cucumber-white-wonder',
    name: 'Cucumber - White Wonder',
    scientificName: 'Cucumis sativus',
    category: 'cucurbit',
    spacing: 18,
    rowSpacing: 36,
    daysToGermination: 7,
    daysToHarvest: 60,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'bean', 'radish', 'marigold'],
    enemies: ['potato', 'aromatic herbs'],
    description: 'yellow asian cucumber. Long slender fruits, burpless and sweet.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '2-3 feet',
    family: 'Cucurbitaceae',
    varieties: ['White Wonder'],
    uses: ['fresh', 'salads', 'sandwiches']
  },
  {
    id: 'cucumber-yamato',
    name: 'Cucumber - Yamato',
    scientificName: 'Cucumis sativus',
    category: 'cucurbit',
    spacing: 18,
    rowSpacing: 36,
    daysToGermination: 7,
    daysToHarvest: 55,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'bean', 'radish', 'marigold'],
    enemies: ['potato', 'aromatic herbs'],
    description: 'striped specialty cucumber. Unique shape or color for specialty markets.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '2-3 feet',
    family: 'Cucurbitaceae',
    varieties: ['Yamato'],
    uses: ['fresh', 'salads', 'sandwiches']
  },
  {
    id: 'cucumber-zapotec',
    name: 'Cucumber - Zapotec',
    scientificName: 'Cucumis sativus',
    category: 'cucurbit',
    spacing: 12,
    rowSpacing: 36,
    daysToGermination: 7,
    daysToHarvest: 55,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'bean', 'radish', 'marigold'],
    enemies: ['potato', 'aromatic herbs'],
    description: 'green slicing cucumber. Classic slicing cucumber for fresh eating.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '2-3 feet',
    family: 'Cucurbitaceae',
    varieties: ['Zapotec'],
    uses: ['fresh', 'salads', 'sandwiches']
  },
  {
    id: 'cucumber-armenian',
    name: 'Cucumber - Armenian',
    scientificName: 'Cucumis sativus',
    category: 'cucurbit',
    spacing: 12,
    rowSpacing: 36,
    daysToGermination: 7,
    daysToHarvest: 50,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'bean', 'radish', 'marigold'],
    enemies: ['potato', 'aromatic herbs'],
    description: 'white pickling cucumber. Perfect size and texture for pickling.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '2-3 feet',
    family: 'Cucurbitaceae',
    varieties: ['Armenian'],
    uses: ['pickling', 'fresh']
  },
  {
    id: 'cucumber-english-telegraph',
    name: 'Cucumber - English Telegraph',
    scientificName: 'Cucumis sativus',
    category: 'cucurbit',
    spacing: 18,
    rowSpacing: 36,
    daysToGermination: 7,
    daysToHarvest: 60,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'bean', 'radish', 'marigold'],
    enemies: ['potato', 'aromatic herbs'],
    description: 'yellow asian cucumber. Long slender fruits, burpless and sweet.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '2-3 feet',
    family: 'Cucurbitaceae',
    varieties: ['English Telegraph'],
    uses: ['fresh', 'salads', 'sandwiches']
  },
  {
    id: 'cucumber-persian',
    name: 'Cucumber - Persian',
    scientificName: 'Cucumis sativus',
    category: 'cucurbit',
    spacing: 18,
    rowSpacing: 36,
    daysToGermination: 7,
    daysToHarvest: 55,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'bean', 'radish', 'marigold'],
    enemies: ['potato', 'aromatic herbs'],
    description: 'striped specialty cucumber. Unique shape or color for specialty markets.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '2-3 feet',
    family: 'Cucurbitaceae',
    varieties: ['Persian'],
    uses: ['fresh', 'salads', 'sandwiches']
  },
  {
    id: 'cucumber-beit-alpha',
    name: 'Cucumber - Beit Alpha',
    scientificName: 'Cucumis sativus',
    category: 'cucurbit',
    spacing: 12,
    rowSpacing: 36,
    daysToGermination: 7,
    daysToHarvest: 55,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'bean', 'radish', 'marigold'],
    enemies: ['potato', 'aromatic herbs'],
    description: 'green slicing cucumber. Classic slicing cucumber for fresh eating.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '2-3 feet',
    family: 'Cucurbitaceae',
    varieties: ['Beit Alpha'],
    uses: ['fresh', 'salads', 'sandwiches']
  },
  {
    id: 'cucumber-japanese-climbing',
    name: 'Cucumber - Japanese Climbing',
    scientificName: 'Cucumis sativus',
    category: 'cucurbit',
    spacing: 12,
    rowSpacing: 36,
    daysToGermination: 7,
    daysToHarvest: 50,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'bean', 'radish', 'marigold'],
    enemies: ['potato', 'aromatic herbs'],
    description: 'white pickling cucumber. Perfect size and texture for pickling.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '2-3 feet',
    family: 'Cucurbitaceae',
    varieties: ['Japanese Climbing'],
    uses: ['pickling', 'fresh']
  },
  {
    id: 'cucumber-west-indian-gherkin',
    name: 'Cucumber - West Indian Gherkin',
    scientificName: 'Cucumis sativus',
    category: 'cucurbit',
    spacing: 18,
    rowSpacing: 36,
    daysToGermination: 7,
    daysToHarvest: 60,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'bean', 'radish', 'marigold'],
    enemies: ['potato', 'aromatic herbs'],
    description: 'yellow asian cucumber. Long slender fruits, burpless and sweet.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '2-3 feet',
    family: 'Cucurbitaceae',
    varieties: ['West Indian Gherkin'],
    uses: ['fresh', 'salads', 'sandwiches']
  },
  {
    id: 'cucumber-mexican-sour-gherkin',
    name: 'Cucumber - Mexican Sour Gherkin',
    scientificName: 'Cucumis sativus',
    category: 'cucurbit',
    spacing: 18,
    rowSpacing: 36,
    daysToGermination: 7,
    daysToHarvest: 55,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'bean', 'radish', 'marigold'],
    enemies: ['potato', 'aromatic herbs'],
    description: 'striped specialty cucumber. Unique shape or color for specialty markets.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '2-3 feet',
    family: 'Cucurbitaceae',
    varieties: ['Mexican Sour Gherkin'],
    uses: ['fresh', 'salads', 'sandwiches']
  },
  {
    id: 'cucumber-crystal-apple',
    name: 'Cucumber - Crystal Apple',
    scientificName: 'Cucumis sativus',
    category: 'cucurbit',
    spacing: 12,
    rowSpacing: 36,
    daysToGermination: 7,
    daysToHarvest: 55,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'bean', 'radish', 'marigold'],
    enemies: ['potato', 'aromatic herbs'],
    description: 'green slicing cucumber. Classic slicing cucumber for fresh eating.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '2-3 feet',
    family: 'Cucurbitaceae',
    varieties: ['Crystal Apple'],
    uses: ['fresh', 'salads', 'sandwiches']
  },
  {
    id: 'cucumber-richmond-green-apple',
    name: 'Cucumber - Richmond Green Apple',
    scientificName: 'Cucumis sativus',
    category: 'cucurbit',
    spacing: 12,
    rowSpacing: 36,
    daysToGermination: 7,
    daysToHarvest: 50,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'bean', 'radish', 'marigold'],
    enemies: ['potato', 'aromatic herbs'],
    description: 'white pickling cucumber. Perfect size and texture for pickling.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '2-3 feet',
    family: 'Cucurbitaceae',
    varieties: ['Richmond Green Apple'],
    uses: ['pickling', 'fresh']
  },
  {
    id: 'cucumber-poona-kheera',
    name: 'Cucumber - Poona Kheera',
    scientificName: 'Cucumis sativus',
    category: 'cucurbit',
    spacing: 18,
    rowSpacing: 36,
    daysToGermination: 7,
    daysToHarvest: 60,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'bean', 'radish', 'marigold'],
    enemies: ['potato', 'aromatic herbs'],
    description: 'yellow asian cucumber. Long slender fruits, burpless and sweet.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '2-3 feet',
    family: 'Cucurbitaceae',
    varieties: ['Poona Kheera'],
    uses: ['fresh', 'salads', 'sandwiches']
  },
  {
    id: 'cucumber-dasher-ii',
    name: 'Cucumber - Dasher II',
    scientificName: 'Cucumis sativus',
    category: 'cucurbit',
    spacing: 18,
    rowSpacing: 36,
    daysToGermination: 7,
    daysToHarvest: 55,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'bean', 'radish', 'marigold'],
    enemies: ['potato', 'aromatic herbs'],
    description: 'striped specialty cucumber. Unique shape or color for specialty markets.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '2-3 feet',
    family: 'Cucurbitaceae',
    varieties: ['Dasher II'],
    uses: ['fresh', 'salads', 'sandwiches']
  },
  {
    id: 'cucumber-indio',
    name: 'Cucumber - Indio',
    scientificName: 'Cucumis sativus',
    category: 'cucurbit',
    spacing: 12,
    rowSpacing: 36,
    daysToGermination: 7,
    daysToHarvest: 55,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'bean', 'radish', 'marigold'],
    enemies: ['potato', 'aromatic herbs'],
    description: 'green slicing cucumber. Classic slicing cucumber for fresh eating.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '2-3 feet',
    family: 'Cucurbitaceae',
    varieties: ['Indio'],
    uses: ['fresh', 'salads', 'sandwiches']
  },
  {
    id: 'cucumber-thunder',
    name: 'Cucumber - Thunder',
    scientificName: 'Cucumis sativus',
    category: 'cucurbit',
    spacing: 12,
    rowSpacing: 36,
    daysToGermination: 7,
    daysToHarvest: 50,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'bean', 'radish', 'marigold'],
    enemies: ['potato', 'aromatic herbs'],
    description: 'white pickling cucumber. Perfect size and texture for pickling.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '2-3 feet',
    family: 'Cucurbitaceae',
    varieties: ['Thunder'],
    uses: ['pickling', 'fresh']
  },
  {
    id: 'cucumber-general-lee',
    name: 'Cucumber - General Lee',
    scientificName: 'Cucumis sativus',
    category: 'cucurbit',
    spacing: 18,
    rowSpacing: 36,
    daysToGermination: 7,
    daysToHarvest: 60,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'bean', 'radish', 'marigold'],
    enemies: ['potato', 'aromatic herbs'],
    description: 'yellow asian cucumber. Long slender fruits, burpless and sweet.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '2-3 feet',
    family: 'Cucurbitaceae',
    varieties: ['General Lee'],
    uses: ['fresh', 'salads', 'sandwiches']
  },
  {
    id: 'cucumber-speedway',
    name: 'Cucumber - Speedway',
    scientificName: 'Cucumis sativus',
    category: 'cucurbit',
    spacing: 18,
    rowSpacing: 36,
    daysToGermination: 7,
    daysToHarvest: 55,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'bean', 'radish', 'marigold'],
    enemies: ['potato', 'aromatic herbs'],
    description: 'striped specialty cucumber. Unique shape or color for specialty markets.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '2-3 feet',
    family: 'Cucurbitaceae',
    varieties: ['Speedway'],
    uses: ['fresh', 'salads', 'sandwiches']
  },
  {
    id: 'cucumber-turbo',
    name: 'Cucumber - Turbo',
    scientificName: 'Cucumis sativus',
    category: 'cucurbit',
    spacing: 12,
    rowSpacing: 36,
    daysToGermination: 7,
    daysToHarvest: 55,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'bean', 'radish', 'marigold'],
    enemies: ['potato', 'aromatic herbs'],
    description: 'green slicing cucumber. Classic slicing cucumber for fresh eating.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '2-3 feet',
    family: 'Cucurbitaceae',
    varieties: ['Turbo'],
    uses: ['fresh', 'salads', 'sandwiches']
  },
  {
    id: 'cucumber-rocky',
    name: 'Cucumber - Rocky',
    scientificName: 'Cucumis sativus',
    category: 'cucurbit',
    spacing: 12,
    rowSpacing: 36,
    daysToGermination: 7,
    daysToHarvest: 50,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'bean', 'radish', 'marigold'],
    enemies: ['potato', 'aromatic herbs'],
    description: 'white pickling cucumber. Perfect size and texture for pickling.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '2-3 feet',
    family: 'Cucurbitaceae',
    varieties: ['Rocky'],
    uses: ['pickling', 'fresh']
  },
  {
    id: 'cucumber-sprint',
    name: 'Cucumber - Sprint',
    scientificName: 'Cucumis sativus',
    category: 'cucurbit',
    spacing: 18,
    rowSpacing: 36,
    daysToGermination: 7,
    daysToHarvest: 60,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'bean', 'radish', 'marigold'],
    enemies: ['potato', 'aromatic herbs'],
    description: 'yellow asian cucumber. Long slender fruits, burpless and sweet.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '2-3 feet',
    family: 'Cucurbitaceae',
    varieties: ['Sprint'],
    uses: ['fresh', 'salads', 'sandwiches']
  },
  {
    id: 'cucumber-intimidator',
    name: 'Cucumber - Intimidator',
    scientificName: 'Cucumis sativus',
    category: 'cucurbit',
    spacing: 18,
    rowSpacing: 36,
    daysToGermination: 7,
    daysToHarvest: 55,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'bean', 'radish', 'marigold'],
    enemies: ['potato', 'aromatic herbs'],
    description: 'striped specialty cucumber. Unique shape or color for specialty markets.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '2-3 feet',
    family: 'Cucurbitaceae',
    varieties: ['Intimidator'],
    uses: ['fresh', 'salads', 'sandwiches']
  },
  {
    id: 'cucumber-revenue',
    name: 'Cucumber - Revenue',
    scientificName: 'Cucumis sativus',
    category: 'cucurbit',
    spacing: 12,
    rowSpacing: 36,
    daysToGermination: 7,
    daysToHarvest: 55,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'bean', 'radish', 'marigold'],
    enemies: ['potato', 'aromatic herbs'],
    description: 'green slicing cucumber. Classic slicing cucumber for fresh eating.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '2-3 feet',
    family: 'Cucurbitaceae',
    varieties: ['Revenue'],
    uses: ['fresh', 'salads', 'sandwiches']
  },
  {
    id: 'cucumber-sv4719cs',
    name: 'Cucumber - SV4719CS',
    scientificName: 'Cucumis sativus',
    category: 'cucurbit',
    spacing: 12,
    rowSpacing: 36,
    daysToGermination: 7,
    daysToHarvest: 50,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'bean', 'radish', 'marigold'],
    enemies: ['potato', 'aromatic herbs'],
    description: 'white pickling cucumber. Perfect size and texture for pickling.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '2-3 feet',
    family: 'Cucurbitaceae',
    varieties: ['SV4719CS'],
    uses: ['pickling', 'fresh']
  },
  {
    id: 'cucumber-sv4098cv',
    name: 'Cucumber - SV4098CV',
    scientificName: 'Cucumis sativus',
    category: 'cucurbit',
    spacing: 18,
    rowSpacing: 36,
    daysToGermination: 7,
    daysToHarvest: 60,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'bean', 'radish', 'marigold'],
    enemies: ['potato', 'aromatic herbs'],
    description: 'yellow asian cucumber. Long slender fruits, burpless and sweet.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '2-3 feet',
    family: 'Cucurbitaceae',
    varieties: ['SV4098CV'],
    uses: ['fresh', 'salads', 'sandwiches']
  },
  {
    id: 'cucumber-sv4719cs',
    name: 'Cucumber - SV4719CS',
    scientificName: 'Cucumis sativus',
    category: 'cucurbit',
    spacing: 18,
    rowSpacing: 36,
    daysToGermination: 7,
    daysToHarvest: 55,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'bean', 'radish', 'marigold'],
    enemies: ['potato', 'aromatic herbs'],
    description: 'striped specialty cucumber. Unique shape or color for specialty markets.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '2-3 feet',
    family: 'Cucurbitaceae',
    varieties: ['SV4719CS'],
    uses: ['fresh', 'salads', 'sandwiches']
  },
  {
    id: 'cucumber-sv4719cs',
    name: 'Cucumber - SV4719CS',
    scientificName: 'Cucumis sativus',
    category: 'cucurbit',
    spacing: 12,
    rowSpacing: 36,
    daysToGermination: 7,
    daysToHarvest: 55,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'bean', 'radish', 'marigold'],
    enemies: ['potato', 'aromatic herbs'],
    description: 'green slicing cucumber. Classic slicing cucumber for fresh eating.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '2-3 feet',
    family: 'Cucurbitaceae',
    varieties: ['SV4719CS'],
    uses: ['fresh', 'salads', 'sandwiches']
  },
  {
    id: 'cucumber-sv4098cv',
    name: 'Cucumber - SV4098CV',
    scientificName: 'Cucumis sativus',
    category: 'cucurbit',
    spacing: 12,
    rowSpacing: 36,
    daysToGermination: 7,
    daysToHarvest: 50,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'bean', 'radish', 'marigold'],
    enemies: ['potato', 'aromatic herbs'],
    description: 'white pickling cucumber. Perfect size and texture for pickling.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '2-3 feet',
    family: 'Cucurbitaceae',
    varieties: ['SV4098CV'],
    uses: ['pickling', 'fresh']
  },
  {
    id: 'cucumber-sv4719cs',
    name: 'Cucumber - SV4719CS',
    scientificName: 'Cucumis sativus',
    category: 'cucurbit',
    spacing: 18,
    rowSpacing: 36,
    daysToGermination: 7,
    daysToHarvest: 60,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'bean', 'radish', 'marigold'],
    enemies: ['potato', 'aromatic herbs'],
    description: 'yellow asian cucumber. Long slender fruits, burpless and sweet.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '2-3 feet',
    family: 'Cucurbitaceae',
    varieties: ['SV4719CS'],
    uses: ['fresh', 'salads', 'sandwiches']
  },
  {
    id: 'cucumber-sv4098cv',
    name: 'Cucumber - SV4098CV',
    scientificName: 'Cucumis sativus',
    category: 'cucurbit',
    spacing: 18,
    rowSpacing: 36,
    daysToGermination: 7,
    daysToHarvest: 55,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'bean', 'radish', 'marigold'],
    enemies: ['potato', 'aromatic herbs'],
    description: 'striped specialty cucumber. Unique shape or color for specialty markets.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '2-3 feet',
    family: 'Cucurbitaceae',
    varieties: ['SV4098CV'],
    uses: ['fresh', 'salads', 'sandwiches']
  },
  {
    id: 'cucumber-sv4719cs',
    name: 'Cucumber - SV4719CS',
    scientificName: 'Cucumis sativus',
    category: 'cucurbit',
    spacing: 12,
    rowSpacing: 36,
    daysToGermination: 7,
    daysToHarvest: 55,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'bean', 'radish', 'marigold'],
    enemies: ['potato', 'aromatic herbs'],
    description: 'green slicing cucumber. Classic slicing cucumber for fresh eating.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '2-3 feet',
    family: 'Cucurbitaceae',
    varieties: ['SV4719CS'],
    uses: ['fresh', 'salads', 'sandwiches']
  },
  {
    id: 'cucumber-sv4098cv',
    name: 'Cucumber - SV4098CV',
    scientificName: 'Cucumis sativus',
    category: 'cucurbit',
    spacing: 12,
    rowSpacing: 36,
    daysToGermination: 7,
    daysToHarvest: 50,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'bean', 'radish', 'marigold'],
    enemies: ['potato', 'aromatic herbs'],
    description: 'white pickling cucumber. Perfect size and texture for pickling.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '2-3 feet',
    family: 'Cucurbitaceae',
    varieties: ['SV4098CV'],
    uses: ['pickling', 'fresh']
  },
  {
    id: 'cucumber-sv4719cs',
    name: 'Cucumber - SV4719CS',
    scientificName: 'Cucumis sativus',
    category: 'cucurbit',
    spacing: 18,
    rowSpacing: 36,
    daysToGermination: 7,
    daysToHarvest: 60,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'bean', 'radish', 'marigold'],
    enemies: ['potato', 'aromatic herbs'],
    description: 'yellow asian cucumber. Long slender fruits, burpless and sweet.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '2-3 feet',
    family: 'Cucurbitaceae',
    varieties: ['SV4719CS'],
    uses: ['fresh', 'salads', 'sandwiches']
  },
  {
    id: 'cucumber-marketmore-2',
    name: 'Cucumber - Marketmore 2',
    scientificName: 'Cucumis sativus',
    category: 'cucurbit',
    spacing: 18,
    rowSpacing: 36,
    daysToGermination: 7,
    daysToHarvest: 55,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'bean', 'radish', 'marigold'],
    enemies: ['potato', 'aromatic herbs'],
    description: 'striped specialty cucumber. Unique shape or color for specialty markets.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '2-3 feet',
    family: 'Cucurbitaceae',
    varieties: ['Marketmore 2'],
    uses: ['fresh', 'salads', 'sandwiches']
  },
  {
    id: 'cucumber-straight-eight-2',
    name: 'Cucumber - Straight Eight 2',
    scientificName: 'Cucumis sativus',
    category: 'cucurbit',
    spacing: 12,
    rowSpacing: 36,
    daysToGermination: 7,
    daysToHarvest: 55,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'bean', 'radish', 'marigold'],
    enemies: ['potato', 'aromatic herbs'],
    description: 'green slicing cucumber. Classic slicing cucumber for fresh eating.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '2-3 feet',
    family: 'Cucurbitaceae',
    varieties: ['Straight Eight 2'],
    uses: ['fresh', 'salads', 'sandwiches']
  },
  {
    id: 'cucumber-national-pickling-2',
    name: 'Cucumber - National Pickling 2',
    scientificName: 'Cucumis sativus',
    category: 'cucurbit',
    spacing: 12,
    rowSpacing: 36,
    daysToGermination: 7,
    daysToHarvest: 50,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'bean', 'radish', 'marigold'],
    enemies: ['potato', 'aromatic herbs'],
    description: 'white pickling cucumber. Perfect size and texture for pickling.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '2-3 feet',
    family: 'Cucurbitaceae',
    varieties: ['National Pickling 2'],
    uses: ['pickling', 'fresh']
  },
  {
    id: 'cucumber-boston-pickling-2',
    name: 'Cucumber - Boston Pickling 2',
    scientificName: 'Cucumis sativus',
    category: 'cucurbit',
    spacing: 18,
    rowSpacing: 36,
    daysToGermination: 7,
    daysToHarvest: 60,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'bean', 'radish', 'marigold'],
    enemies: ['potato', 'aromatic herbs'],
    description: 'yellow asian cucumber. Long slender fruits, burpless and sweet.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '2-3 feet',
    family: 'Cucurbitaceae',
    varieties: ['Boston Pickling 2'],
    uses: ['fresh', 'salads', 'sandwiches']
  },
  {
    id: 'cucumber-diva-2',
    name: 'Cucumber - Diva 2',
    scientificName: 'Cucumis sativus',
    category: 'cucurbit',
    spacing: 18,
    rowSpacing: 36,
    daysToGermination: 7,
    daysToHarvest: 55,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'bean', 'radish', 'marigold'],
    enemies: ['potato', 'aromatic herbs'],
    description: 'striped specialty cucumber. Unique shape or color for specialty markets.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '2-3 feet',
    family: 'Cucurbitaceae',
    varieties: ['Diva 2'],
    uses: ['fresh', 'salads', 'sandwiches']
  },
  {
    id: 'cucumber-county-fair-2',
    name: 'Cucumber - County Fair 2',
    scientificName: 'Cucumis sativus',
    category: 'cucurbit',
    spacing: 12,
    rowSpacing: 36,
    daysToGermination: 7,
    daysToHarvest: 55,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'bean', 'radish', 'marigold'],
    enemies: ['potato', 'aromatic herbs'],
    description: 'green slicing cucumber. Classic slicing cucumber for fresh eating.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '2-3 feet',
    family: 'Cucurbitaceae',
    varieties: ['County Fair 2'],
    uses: ['fresh', 'salads', 'sandwiches']
  },
  {
    id: 'cucumber-salad-bush-2',
    name: 'Cucumber - Salad Bush 2',
    scientificName: 'Cucumis sativus',
    category: 'cucurbit',
    spacing: 12,
    rowSpacing: 36,
    daysToGermination: 7,
    daysToHarvest: 50,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'bean', 'radish', 'marigold'],
    enemies: ['potato', 'aromatic herbs'],
    description: 'white pickling cucumber. Perfect size and texture for pickling.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '2-3 feet',
    family: 'Cucurbitaceae',
    varieties: ['Salad Bush 2'],
    uses: ['pickling', 'fresh']
  },
  {
    id: 'cucumber-spacemaster-2',
    name: 'Cucumber - Spacemaster 2',
    scientificName: 'Cucumis sativus',
    category: 'cucurbit',
    spacing: 18,
    rowSpacing: 36,
    daysToGermination: 7,
    daysToHarvest: 60,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'bean', 'radish', 'marigold'],
    enemies: ['potato', 'aromatic herbs'],
    description: 'yellow asian cucumber. Long slender fruits, burpless and sweet.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '2-3 feet',
    family: 'Cucurbitaceae',
    varieties: ['Spacemaster 2'],
    uses: ['fresh', 'salads', 'sandwiches']
  },
  {
    id: 'cucumber-bush-champion-2',
    name: 'Cucumber - Bush Champion 2',
    scientificName: 'Cucumis sativus',
    category: 'cucurbit',
    spacing: 18,
    rowSpacing: 36,
    daysToGermination: 7,
    daysToHarvest: 55,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'bean', 'radish', 'marigold'],
    enemies: ['potato', 'aromatic herbs'],
    description: 'striped specialty cucumber. Unique shape or color for specialty markets.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '2-3 feet',
    family: 'Cucurbitaceae',
    varieties: ['Bush Champion 2'],
    uses: ['fresh', 'salads', 'sandwiches']
  },
  {
    id: 'cucumber-picklebush-2',
    name: 'Cucumber - Picklebush 2',
    scientificName: 'Cucumis sativus',
    category: 'cucurbit',
    spacing: 12,
    rowSpacing: 36,
    daysToGermination: 7,
    daysToHarvest: 55,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'bean', 'radish', 'marigold'],
    enemies: ['potato', 'aromatic herbs'],
    description: 'green slicing cucumber. Classic slicing cucumber for fresh eating.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '2-3 feet',
    family: 'Cucurbitaceae',
    varieties: ['Picklebush 2'],
    uses: ['fresh', 'salads', 'sandwiches']
  },
  {
    id: 'cucumber-homemade-pickles-2',
    name: 'Cucumber - Homemade Pickles 2',
    scientificName: 'Cucumis sativus',
    category: 'cucurbit',
    spacing: 12,
    rowSpacing: 36,
    daysToGermination: 7,
    daysToHarvest: 50,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'bean', 'radish', 'marigold'],
    enemies: ['potato', 'aromatic herbs'],
    description: 'white pickling cucumber. Perfect size and texture for pickling.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '2-3 feet',
    family: 'Cucurbitaceae',
    varieties: ['Homemade Pickles 2'],
    uses: ['pickling', 'fresh']
  },
  {
    id: 'cucumber-chicago-pickling-2',
    name: 'Cucumber - Chicago Pickling 2',
    scientificName: 'Cucumis sativus',
    category: 'cucurbit',
    spacing: 18,
    rowSpacing: 36,
    daysToGermination: 7,
    daysToHarvest: 60,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'bean', 'radish', 'marigold'],
    enemies: ['potato', 'aromatic herbs'],
    description: 'yellow asian cucumber. Long slender fruits, burpless and sweet.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '2-3 feet',
    family: 'Cucurbitaceae',
    varieties: ['Chicago Pickling 2'],
    uses: ['fresh', 'salads', 'sandwiches']
  },
  {
    id: 'cucumber-little-leaf-2',
    name: 'Cucumber - Little Leaf 2',
    scientificName: 'Cucumis sativus',
    category: 'cucurbit',
    spacing: 18,
    rowSpacing: 36,
    daysToGermination: 7,
    daysToHarvest: 55,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'bean', 'radish', 'marigold'],
    enemies: ['potato', 'aromatic herbs'],
    description: 'striped specialty cucumber. Unique shape or color for specialty markets.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '2-3 feet',
    family: 'Cucurbitaceae',
    varieties: ['Little Leaf 2'],
    uses: ['fresh', 'salads', 'sandwiches']
  },
  {
    id: 'cucumber-socrates-2',
    name: 'Cucumber - Socrates 2',
    scientificName: 'Cucumis sativus',
    category: 'cucurbit',
    spacing: 12,
    rowSpacing: 36,
    daysToGermination: 7,
    daysToHarvest: 55,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'bean', 'radish', 'marigold'],
    enemies: ['potato', 'aromatic herbs'],
    description: 'green slicing cucumber. Classic slicing cucumber for fresh eating.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '2-3 feet',
    family: 'Cucurbitaceae',
    varieties: ['Socrates 2'],
    uses: ['fresh', 'salads', 'sandwiches']
  },
  {
    id: 'cucumber-corinto-2',
    name: 'Cucumber - Corinto 2',
    scientificName: 'Cucumis sativus',
    category: 'cucurbit',
    spacing: 12,
    rowSpacing: 36,
    daysToGermination: 7,
    daysToHarvest: 50,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'bean', 'radish', 'marigold'],
    enemies: ['potato', 'aromatic herbs'],
    description: 'white pickling cucumber. Perfect size and texture for pickling.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '2-3 feet',
    family: 'Cucurbitaceae',
    varieties: ['Corinto 2'],
    uses: ['pickling', 'fresh']
  },
  {
    id: 'cucumber-excelsior-2',
    name: 'Cucumber - Excelsior 2',
    scientificName: 'Cucumis sativus',
    category: 'cucurbit',
    spacing: 18,
    rowSpacing: 36,
    daysToGermination: 7,
    daysToHarvest: 60,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'bean', 'radish', 'marigold'],
    enemies: ['potato', 'aromatic herbs'],
    description: 'yellow asian cucumber. Long slender fruits, burpless and sweet.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '2-3 feet',
    family: 'Cucurbitaceae',
    varieties: ['Excelsior 2'],
    uses: ['fresh', 'salads', 'sandwiches']
  },
  {
    id: 'cucumber-fanfare-2',
    name: 'Cucumber - Fanfare 2',
    scientificName: 'Cucumis sativus',
    category: 'cucurbit',
    spacing: 18,
    rowSpacing: 36,
    daysToGermination: 7,
    daysToHarvest: 55,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'bean', 'radish', 'marigold'],
    enemies: ['potato', 'aromatic herbs'],
    description: 'striped specialty cucumber. Unique shape or color for specialty markets.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '2-3 feet',
    family: 'Cucurbitaceae',
    varieties: ['Fanfare 2'],
    uses: ['fresh', 'salads', 'sandwiches']
  },
  {
    id: 'cucumber-greensleeves-2',
    name: 'Cucumber - Greensleeves 2',
    scientificName: 'Cucumis sativus',
    category: 'cucurbit',
    spacing: 12,
    rowSpacing: 36,
    daysToGermination: 7,
    daysToHarvest: 55,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'bean', 'radish', 'marigold'],
    enemies: ['potato', 'aromatic herbs'],
    description: 'green slicing cucumber. Classic slicing cucumber for fresh eating.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '2-3 feet',
    family: 'Cucurbitaceae',
    varieties: ['Greensleeves 2'],
    uses: ['fresh', 'salads', 'sandwiches']
  },
  {
    id: 'cucumber-harmony-2',
    name: 'Cucumber - Harmony 2',
    scientificName: 'Cucumis sativus',
    category: 'cucurbit',
    spacing: 12,
    rowSpacing: 36,
    daysToGermination: 7,
    daysToHarvest: 50,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'bean', 'radish', 'marigold'],
    enemies: ['potato', 'aromatic herbs'],
    description: 'white pickling cucumber. Perfect size and texture for pickling.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '2-3 feet',
    family: 'Cucurbitaceae',
    varieties: ['Harmony 2'],
    uses: ['pickling', 'fresh']
  },
  {
    id: 'cucumber-jackson-2',
    name: 'Cucumber - Jackson 2',
    scientificName: 'Cucumis sativus',
    category: 'cucurbit',
    spacing: 18,
    rowSpacing: 36,
    daysToGermination: 7,
    daysToHarvest: 60,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'bean', 'radish', 'marigold'],
    enemies: ['potato', 'aromatic herbs'],
    description: 'yellow asian cucumber. Long slender fruits, burpless and sweet.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '2-3 feet',
    family: 'Cucurbitaceae',
    varieties: ['Jackson 2'],
    uses: ['fresh', 'salads', 'sandwiches']
  },
  {
    id: 'cucumber-jawell-2',
    name: 'Cucumber - Jawell 2',
    scientificName: 'Cucumis sativus',
    category: 'cucurbit',
    spacing: 18,
    rowSpacing: 36,
    daysToGermination: 7,
    daysToHarvest: 55,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'bean', 'radish', 'marigold'],
    enemies: ['potato', 'aromatic herbs'],
    description: 'striped specialty cucumber. Unique shape or color for specialty markets.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '2-3 feet',
    family: 'Cucurbitaceae',
    varieties: ['Jawell 2'],
    uses: ['fresh', 'salads', 'sandwiches']
  },
  {
    id: 'cucumber-katrina-2',
    name: 'Cucumber - Katrina 2',
    scientificName: 'Cucumis sativus',
    category: 'cucurbit',
    spacing: 12,
    rowSpacing: 36,
    daysToGermination: 7,
    daysToHarvest: 55,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'bean', 'radish', 'marigold'],
    enemies: ['potato', 'aromatic herbs'],
    description: 'green slicing cucumber. Classic slicing cucumber for fresh eating.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '2-3 feet',
    family: 'Cucurbitaceae',
    varieties: ['Katrina 2'],
    uses: ['fresh', 'salads', 'sandwiches']
  },
  {
    id: 'cucumber-lemon-2',
    name: 'Cucumber - Lemon 2',
    scientificName: 'Cucumis sativus',
    category: 'cucurbit',
    spacing: 12,
    rowSpacing: 36,
    daysToGermination: 7,
    daysToHarvest: 50,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'bean', 'radish', 'marigold'],
    enemies: ['potato', 'aromatic herbs'],
    description: 'white pickling cucumber. Perfect size and texture for pickling.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '2-3 feet',
    family: 'Cucurbitaceae',
    varieties: ['Lemon 2'],
    uses: ['pickling', 'fresh']
  },
  {
    id: 'cucumber-manny-2',
    name: 'Cucumber - Manny 2',
    scientificName: 'Cucumis sativus',
    category: 'cucurbit',
    spacing: 18,
    rowSpacing: 36,
    daysToGermination: 7,
    daysToHarvest: 60,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'bean', 'radish', 'marigold'],
    enemies: ['potato', 'aromatic herbs'],
    description: 'yellow asian cucumber. Long slender fruits, burpless and sweet.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '2-3 feet',
    family: 'Cucurbitaceae',
    varieties: ['Manny 2'],
    uses: ['fresh', 'salads', 'sandwiches']
  },
  {
    id: 'cucumber-orient-express-2',
    name: 'Cucumber - Orient Express 2',
    scientificName: 'Cucumis sativus',
    category: 'cucurbit',
    spacing: 18,
    rowSpacing: 36,
    daysToGermination: 7,
    daysToHarvest: 55,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'bean', 'radish', 'marigold'],
    enemies: ['potato', 'aromatic herbs'],
    description: 'striped specialty cucumber. Unique shape or color for specialty markets.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '2-3 feet',
    family: 'Cucurbitaceae',
    varieties: ['Orient Express 2'],
    uses: ['fresh', 'salads', 'sandwiches']
  },
  {
    id: 'cucumber-poinsett-76-2',
    name: 'Cucumber - Poinsett 76 2',
    scientificName: 'Cucumis sativus',
    category: 'cucurbit',
    spacing: 12,
    rowSpacing: 36,
    daysToGermination: 7,
    daysToHarvest: 55,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'bean', 'radish', 'marigold'],
    enemies: ['potato', 'aromatic herbs'],
    description: 'green slicing cucumber. Classic slicing cucumber for fresh eating.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '2-3 feet',
    family: 'Cucurbitaceae',
    varieties: ['Poinsett 76 2'],
    uses: ['fresh', 'salads', 'sandwiches']
  },
  {
    id: 'cucumber-saladin-2',
    name: 'Cucumber - Saladin 2',
    scientificName: 'Cucumis sativus',
    category: 'cucurbit',
    spacing: 12,
    rowSpacing: 36,
    daysToGermination: 7,
    daysToHarvest: 50,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'bean', 'radish', 'marigold'],
    enemies: ['potato', 'aromatic herbs'],
    description: 'white pickling cucumber. Perfect size and texture for pickling.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '2-3 feet',
    family: 'Cucurbitaceae',
    varieties: ['Saladin 2'],
    uses: ['pickling', 'fresh']
  },
  {
    id: 'cucumber-suyo-long-2',
    name: 'Cucumber - Suyo Long 2',
    scientificName: 'Cucumis sativus',
    category: 'cucurbit',
    spacing: 18,
    rowSpacing: 36,
    daysToGermination: 7,
    daysToHarvest: 60,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'bean', 'radish', 'marigold'],
    enemies: ['potato', 'aromatic herbs'],
    description: 'yellow asian cucumber. Long slender fruits, burpless and sweet.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '2-3 feet',
    family: 'Cucurbitaceae',
    varieties: ['Suyo Long 2'],
    uses: ['fresh', 'salads', 'sandwiches']
  },
  {
    id: 'cucumber-tasty-green-2',
    name: 'Cucumber - Tasty Green 2',
    scientificName: 'Cucumis sativus',
    category: 'cucurbit',
    spacing: 18,
    rowSpacing: 36,
    daysToGermination: 7,
    daysToHarvest: 55,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'bean', 'radish', 'marigold'],
    enemies: ['potato', 'aromatic herbs'],
    description: 'striped specialty cucumber. Unique shape or color for specialty markets.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '2-3 feet',
    family: 'Cucurbitaceae',
    varieties: ['Tasty Green 2'],
    uses: ['fresh', 'salads', 'sandwiches']
  },
  {
    id: 'cucumber-tendergreen-burpless-2',
    name: 'Cucumber - Tendergreen Burpless 2',
    scientificName: 'Cucumis sativus',
    category: 'cucurbit',
    spacing: 12,
    rowSpacing: 36,
    daysToGermination: 7,
    daysToHarvest: 55,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'bean', 'radish', 'marigold'],
    enemies: ['potato', 'aromatic herbs'],
    description: 'green slicing cucumber. Classic slicing cucumber for fresh eating.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '2-3 feet',
    family: 'Cucurbitaceae',
    varieties: ['Tendergreen Burpless 2'],
    uses: ['fresh', 'salads', 'sandwiches']
  },
  {
    id: 'cucumber-tyria-2',
    name: 'Cucumber - Tyria 2',
    scientificName: 'Cucumis sativus',
    category: 'cucurbit',
    spacing: 12,
    rowSpacing: 36,
    daysToGermination: 7,
    daysToHarvest: 50,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'bean', 'radish', 'marigold'],
    enemies: ['potato', 'aromatic herbs'],
    description: 'white pickling cucumber. Perfect size and texture for pickling.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '2-3 feet',
    family: 'Cucurbitaceae',
    varieties: ['Tyria 2'],
    uses: ['pickling', 'fresh']
  },
  {
    id: 'cucumber-unagi-2',
    name: 'Cucumber - Unagi 2',
    scientificName: 'Cucumis sativus',
    category: 'cucurbit',
    spacing: 18,
    rowSpacing: 36,
    daysToGermination: 7,
    daysToHarvest: 60,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'bean', 'radish', 'marigold'],
    enemies: ['potato', 'aromatic herbs'],
    description: 'yellow asian cucumber. Long slender fruits, burpless and sweet.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '2-3 feet',
    family: 'Cucurbitaceae',
    varieties: ['Unagi 2'],
    uses: ['fresh', 'salads', 'sandwiches']
  },
  {
    id: 'cucumber-vlasstar-2',
    name: 'Cucumber - Vlasstar 2',
    scientificName: 'Cucumis sativus',
    category: 'cucurbit',
    spacing: 18,
    rowSpacing: 36,
    daysToGermination: 7,
    daysToHarvest: 55,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'bean', 'radish', 'marigold'],
    enemies: ['potato', 'aromatic herbs'],
    description: 'striped specialty cucumber. Unique shape or color for specialty markets.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '2-3 feet',
    family: 'Cucurbitaceae',
    varieties: ['Vlasstar 2'],
    uses: ['fresh', 'salads', 'sandwiches']
  },
  {
    id: 'cucumber-wautoma-2',
    name: 'Cucumber - Wautoma 2',
    scientificName: 'Cucumis sativus',
    category: 'cucurbit',
    spacing: 12,
    rowSpacing: 36,
    daysToGermination: 7,
    daysToHarvest: 55,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'bean', 'radish', 'marigold'],
    enemies: ['potato', 'aromatic herbs'],
    description: 'green slicing cucumber. Classic slicing cucumber for fresh eating.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '2-3 feet',
    family: 'Cucurbitaceae',
    varieties: ['Wautoma 2'],
    uses: ['fresh', 'salads', 'sandwiches']
  },
  {
    id: 'cucumber-white-wonder-2',
    name: 'Cucumber - White Wonder 2',
    scientificName: 'Cucumis sativus',
    category: 'cucurbit',
    spacing: 12,
    rowSpacing: 36,
    daysToGermination: 7,
    daysToHarvest: 50,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'bean', 'radish', 'marigold'],
    enemies: ['potato', 'aromatic herbs'],
    description: 'white pickling cucumber. Perfect size and texture for pickling.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '2-3 feet',
    family: 'Cucurbitaceae',
    varieties: ['White Wonder 2'],
    uses: ['pickling', 'fresh']
  },
  {
    id: 'cucumber-yamato-2',
    name: 'Cucumber - Yamato 2',
    scientificName: 'Cucumis sativus',
    category: 'cucurbit',
    spacing: 18,
    rowSpacing: 36,
    daysToGermination: 7,
    daysToHarvest: 60,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'bean', 'radish', 'marigold'],
    enemies: ['potato', 'aromatic herbs'],
    description: 'yellow asian cucumber. Long slender fruits, burpless and sweet.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '2-3 feet',
    family: 'Cucurbitaceae',
    varieties: ['Yamato 2'],
    uses: ['fresh', 'salads', 'sandwiches']
  },
  {
    id: 'cucumber-zapotec-2',
    name: 'Cucumber - Zapotec 2',
    scientificName: 'Cucumis sativus',
    category: 'cucurbit',
    spacing: 18,
    rowSpacing: 36,
    daysToGermination: 7,
    daysToHarvest: 55,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'bean', 'radish', 'marigold'],
    enemies: ['potato', 'aromatic herbs'],
    description: 'striped specialty cucumber. Unique shape or color for specialty markets.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '2-3 feet',
    family: 'Cucurbitaceae',
    varieties: ['Zapotec 2'],
    uses: ['fresh', 'salads', 'sandwiches']
  },
  {
    id: 'cucumber-armenian-2',
    name: 'Cucumber - Armenian 2',
    scientificName: 'Cucumis sativus',
    category: 'cucurbit',
    spacing: 12,
    rowSpacing: 36,
    daysToGermination: 7,
    daysToHarvest: 55,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'bean', 'radish', 'marigold'],
    enemies: ['potato', 'aromatic herbs'],
    description: 'green slicing cucumber. Classic slicing cucumber for fresh eating.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '2-3 feet',
    family: 'Cucurbitaceae',
    varieties: ['Armenian 2'],
    uses: ['fresh', 'salads', 'sandwiches']
  },
  {
    id: 'cucumber-english-telegraph-2',
    name: 'Cucumber - English Telegraph 2',
    scientificName: 'Cucumis sativus',
    category: 'cucurbit',
    spacing: 12,
    rowSpacing: 36,
    daysToGermination: 7,
    daysToHarvest: 50,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'bean', 'radish', 'marigold'],
    enemies: ['potato', 'aromatic herbs'],
    description: 'white pickling cucumber. Perfect size and texture for pickling.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '2-3 feet',
    family: 'Cucurbitaceae',
    varieties: ['English Telegraph 2'],
    uses: ['pickling', 'fresh']
  },
  {
    id: 'cucumber-persian-2',
    name: 'Cucumber - Persian 2',
    scientificName: 'Cucumis sativus',
    category: 'cucurbit',
    spacing: 18,
    rowSpacing: 36,
    daysToGermination: 7,
    daysToHarvest: 60,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'bean', 'radish', 'marigold'],
    enemies: ['potato', 'aromatic herbs'],
    description: 'yellow asian cucumber. Long slender fruits, burpless and sweet.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '2-3 feet',
    family: 'Cucurbitaceae',
    varieties: ['Persian 2'],
    uses: ['fresh', 'salads', 'sandwiches']
  },
  {
    id: 'cucumber-beit-alpha-2',
    name: 'Cucumber - Beit Alpha 2',
    scientificName: 'Cucumis sativus',
    category: 'cucurbit',
    spacing: 18,
    rowSpacing: 36,
    daysToGermination: 7,
    daysToHarvest: 55,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'bean', 'radish', 'marigold'],
    enemies: ['potato', 'aromatic herbs'],
    description: 'striped specialty cucumber. Unique shape or color for specialty markets.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '2-3 feet',
    family: 'Cucurbitaceae',
    varieties: ['Beit Alpha 2'],
    uses: ['fresh', 'salads', 'sandwiches']
  },
  {
    id: 'cucumber-japanese-climbing-2',
    name: 'Cucumber - Japanese Climbing 2',
    scientificName: 'Cucumis sativus',
    category: 'cucurbit',
    spacing: 12,
    rowSpacing: 36,
    daysToGermination: 7,
    daysToHarvest: 55,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'bean', 'radish', 'marigold'],
    enemies: ['potato', 'aromatic herbs'],
    description: 'green slicing cucumber. Classic slicing cucumber for fresh eating.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '2-3 feet',
    family: 'Cucurbitaceae',
    varieties: ['Japanese Climbing 2'],
    uses: ['fresh', 'salads', 'sandwiches']
  },
  {
    id: 'cucumber-west-indian-gherkin-2',
    name: 'Cucumber - West Indian Gherkin 2',
    scientificName: 'Cucumis sativus',
    category: 'cucurbit',
    spacing: 12,
    rowSpacing: 36,
    daysToGermination: 7,
    daysToHarvest: 50,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'bean', 'radish', 'marigold'],
    enemies: ['potato', 'aromatic herbs'],
    description: 'white pickling cucumber. Perfect size and texture for pickling.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '2-3 feet',
    family: 'Cucurbitaceae',
    varieties: ['West Indian Gherkin 2'],
    uses: ['pickling', 'fresh']
  },
  {
    id: 'cucumber-mexican-sour-gherkin-2',
    name: 'Cucumber - Mexican Sour Gherkin 2',
    scientificName: 'Cucumis sativus',
    category: 'cucurbit',
    spacing: 18,
    rowSpacing: 36,
    daysToGermination: 7,
    daysToHarvest: 60,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'bean', 'radish', 'marigold'],
    enemies: ['potato', 'aromatic herbs'],
    description: 'yellow asian cucumber. Long slender fruits, burpless and sweet.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '2-3 feet',
    family: 'Cucurbitaceae',
    varieties: ['Mexican Sour Gherkin 2'],
    uses: ['fresh', 'salads', 'sandwiches']
  },
  {
    id: 'cucumber-crystal-apple-2',
    name: 'Cucumber - Crystal Apple 2',
    scientificName: 'Cucumis sativus',
    category: 'cucurbit',
    spacing: 18,
    rowSpacing: 36,
    daysToGermination: 7,
    daysToHarvest: 55,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'bean', 'radish', 'marigold'],
    enemies: ['potato', 'aromatic herbs'],
    description: 'striped specialty cucumber. Unique shape or color for specialty markets.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '2-3 feet',
    family: 'Cucurbitaceae',
    varieties: ['Crystal Apple 2'],
    uses: ['fresh', 'salads', 'sandwiches']
  },
  {
    id: 'cucumber-richmond-green-apple-2',
    name: 'Cucumber - Richmond Green Apple 2',
    scientificName: 'Cucumis sativus',
    category: 'cucurbit',
    spacing: 12,
    rowSpacing: 36,
    daysToGermination: 7,
    daysToHarvest: 55,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'bean', 'radish', 'marigold'],
    enemies: ['potato', 'aromatic herbs'],
    description: 'green slicing cucumber. Classic slicing cucumber for fresh eating.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '2-3 feet',
    family: 'Cucurbitaceae',
    varieties: ['Richmond Green Apple 2'],
    uses: ['fresh', 'salads', 'sandwiches']
  },
  {
    id: 'cucumber-poona-kheera-2',
    name: 'Cucumber - Poona Kheera 2',
    scientificName: 'Cucumis sativus',
    category: 'cucurbit',
    spacing: 12,
    rowSpacing: 36,
    daysToGermination: 7,
    daysToHarvest: 50,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'bean', 'radish', 'marigold'],
    enemies: ['potato', 'aromatic herbs'],
    description: 'white pickling cucumber. Perfect size and texture for pickling.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '2-3 feet',
    family: 'Cucurbitaceae',
    varieties: ['Poona Kheera 2'],
    uses: ['pickling', 'fresh']
  },
  {
    id: 'cucumber-dasher-ii-2',
    name: 'Cucumber - Dasher II 2',
    scientificName: 'Cucumis sativus',
    category: 'cucurbit',
    spacing: 18,
    rowSpacing: 36,
    daysToGermination: 7,
    daysToHarvest: 60,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'bean', 'radish', 'marigold'],
    enemies: ['potato', 'aromatic herbs'],
    description: 'yellow asian cucumber. Long slender fruits, burpless and sweet.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '2-3 feet',
    family: 'Cucurbitaceae',
    varieties: ['Dasher II 2'],
    uses: ['fresh', 'salads', 'sandwiches']
  },
  {
    id: 'cucumber-indio-2',
    name: 'Cucumber - Indio 2',
    scientificName: 'Cucumis sativus',
    category: 'cucurbit',
    spacing: 18,
    rowSpacing: 36,
    daysToGermination: 7,
    daysToHarvest: 55,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'bean', 'radish', 'marigold'],
    enemies: ['potato', 'aromatic herbs'],
    description: 'striped specialty cucumber. Unique shape or color for specialty markets.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '2-3 feet',
    family: 'Cucurbitaceae',
    varieties: ['Indio 2'],
    uses: ['fresh', 'salads', 'sandwiches']
  },
  {
    id: 'cucumber-thunder-2',
    name: 'Cucumber - Thunder 2',
    scientificName: 'Cucumis sativus',
    category: 'cucurbit',
    spacing: 12,
    rowSpacing: 36,
    daysToGermination: 7,
    daysToHarvest: 55,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'bean', 'radish', 'marigold'],
    enemies: ['potato', 'aromatic herbs'],
    description: 'green slicing cucumber. Classic slicing cucumber for fresh eating.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '2-3 feet',
    family: 'Cucurbitaceae',
    varieties: ['Thunder 2'],
    uses: ['fresh', 'salads', 'sandwiches']
  },
  {
    id: 'cucumber-general-lee-2',
    name: 'Cucumber - General Lee 2',
    scientificName: 'Cucumis sativus',
    category: 'cucurbit',
    spacing: 12,
    rowSpacing: 36,
    daysToGermination: 7,
    daysToHarvest: 50,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'bean', 'radish', 'marigold'],
    enemies: ['potato', 'aromatic herbs'],
    description: 'white pickling cucumber. Perfect size and texture for pickling.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '2-3 feet',
    family: 'Cucurbitaceae',
    varieties: ['General Lee 2'],
    uses: ['pickling', 'fresh']
  },
  {
    id: 'cucumber-speedway-2',
    name: 'Cucumber - Speedway 2',
    scientificName: 'Cucumis sativus',
    category: 'cucurbit',
    spacing: 18,
    rowSpacing: 36,
    daysToGermination: 7,
    daysToHarvest: 60,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'bean', 'radish', 'marigold'],
    enemies: ['potato', 'aromatic herbs'],
    description: 'yellow asian cucumber. Long slender fruits, burpless and sweet.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '2-3 feet',
    family: 'Cucurbitaceae',
    varieties: ['Speedway 2'],
    uses: ['fresh', 'salads', 'sandwiches']
  },
  {
    id: 'cucumber-turbo-2',
    name: 'Cucumber - Turbo 2',
    scientificName: 'Cucumis sativus',
    category: 'cucurbit',
    spacing: 18,
    rowSpacing: 36,
    daysToGermination: 7,
    daysToHarvest: 55,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'bean', 'radish', 'marigold'],
    enemies: ['potato', 'aromatic herbs'],
    description: 'striped specialty cucumber. Unique shape or color for specialty markets.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '2-3 feet',
    family: 'Cucurbitaceae',
    varieties: ['Turbo 2'],
    uses: ['fresh', 'salads', 'sandwiches']
  },
  {
    id: 'cucumber-rocky-2',
    name: 'Cucumber - Rocky 2',
    scientificName: 'Cucumis sativus',
    category: 'cucurbit',
    spacing: 12,
    rowSpacing: 36,
    daysToGermination: 7,
    daysToHarvest: 55,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'bean', 'radish', 'marigold'],
    enemies: ['potato', 'aromatic herbs'],
    description: 'green slicing cucumber. Classic slicing cucumber for fresh eating.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '2-3 feet',
    family: 'Cucurbitaceae',
    varieties: ['Rocky 2'],
    uses: ['fresh', 'salads', 'sandwiches']
  },
  {
    id: 'cucumber-sprint-2',
    name: 'Cucumber - Sprint 2',
    scientificName: 'Cucumis sativus',
    category: 'cucurbit',
    spacing: 12,
    rowSpacing: 36,
    daysToGermination: 7,
    daysToHarvest: 50,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'bean', 'radish', 'marigold'],
    enemies: ['potato', 'aromatic herbs'],
    description: 'white pickling cucumber. Perfect size and texture for pickling.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '2-3 feet',
    family: 'Cucurbitaceae',
    varieties: ['Sprint 2'],
    uses: ['pickling', 'fresh']
  },
  {
    id: 'cucumber-intimidator-2',
    name: 'Cucumber - Intimidator 2',
    scientificName: 'Cucumis sativus',
    category: 'cucurbit',
    spacing: 18,
    rowSpacing: 36,
    daysToGermination: 7,
    daysToHarvest: 60,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'bean', 'radish', 'marigold'],
    enemies: ['potato', 'aromatic herbs'],
    description: 'yellow asian cucumber. Long slender fruits, burpless and sweet.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '2-3 feet',
    family: 'Cucurbitaceae',
    varieties: ['Intimidator 2'],
    uses: ['fresh', 'salads', 'sandwiches']
  },
  {
    id: 'cucumber-revenue-2',
    name: 'Cucumber - Revenue 2',
    scientificName: 'Cucumis sativus',
    category: 'cucurbit',
    spacing: 18,
    rowSpacing: 36,
    daysToGermination: 7,
    daysToHarvest: 55,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'bean', 'radish', 'marigold'],
    enemies: ['potato', 'aromatic herbs'],
    description: 'striped specialty cucumber. Unique shape or color for specialty markets.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '2-3 feet',
    family: 'Cucurbitaceae',
    varieties: ['Revenue 2'],
    uses: ['fresh', 'salads', 'sandwiches']
  },
  {
    id: 'cucumber-sv4719cs-2',
    name: 'Cucumber - SV4719CS 2',
    scientificName: 'Cucumis sativus',
    category: 'cucurbit',
    spacing: 12,
    rowSpacing: 36,
    daysToGermination: 7,
    daysToHarvest: 55,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'bean', 'radish', 'marigold'],
    enemies: ['potato', 'aromatic herbs'],
    description: 'green slicing cucumber. Classic slicing cucumber for fresh eating.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '2-3 feet',
    family: 'Cucurbitaceae',
    varieties: ['SV4719CS 2'],
    uses: ['fresh', 'salads', 'sandwiches']
  },
  {
    id: 'cucumber-sv4098cv-2',
    name: 'Cucumber - SV4098CV 2',
    scientificName: 'Cucumis sativus',
    category: 'cucurbit',
    spacing: 12,
    rowSpacing: 36,
    daysToGermination: 7,
    daysToHarvest: 50,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'bean', 'radish', 'marigold'],
    enemies: ['potato', 'aromatic herbs'],
    description: 'white pickling cucumber. Perfect size and texture for pickling.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '2-3 feet',
    family: 'Cucurbitaceae',
    varieties: ['SV4098CV 2'],
    uses: ['pickling', 'fresh']
  },
  {
    id: 'cucumber-sv4719cs-2',
    name: 'Cucumber - SV4719CS 2',
    scientificName: 'Cucumis sativus',
    category: 'cucurbit',
    spacing: 18,
    rowSpacing: 36,
    daysToGermination: 7,
    daysToHarvest: 60,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'bean', 'radish', 'marigold'],
    enemies: ['potato', 'aromatic herbs'],
    description: 'yellow asian cucumber. Long slender fruits, burpless and sweet.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '2-3 feet',
    family: 'Cucurbitaceae',
    varieties: ['SV4719CS 2'],
    uses: ['fresh', 'salads', 'sandwiches']
  },
  {
    id: 'cucumber-sv4719cs-2',
    name: 'Cucumber - SV4719CS 2',
    scientificName: 'Cucumis sativus',
    category: 'cucurbit',
    spacing: 18,
    rowSpacing: 36,
    daysToGermination: 7,
    daysToHarvest: 55,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'bean', 'radish', 'marigold'],
    enemies: ['potato', 'aromatic herbs'],
    description: 'striped specialty cucumber. Unique shape or color for specialty markets.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '2-3 feet',
    family: 'Cucurbitaceae',
    varieties: ['SV4719CS 2'],
    uses: ['fresh', 'salads', 'sandwiches']
  },
  {
    id: 'cucumber-sv4098cv-2',
    name: 'Cucumber - SV4098CV 2',
    scientificName: 'Cucumis sativus',
    category: 'cucurbit',
    spacing: 12,
    rowSpacing: 36,
    daysToGermination: 7,
    daysToHarvest: 55,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'bean', 'radish', 'marigold'],
    enemies: ['potato', 'aromatic herbs'],
    description: 'green slicing cucumber. Classic slicing cucumber for fresh eating.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '2-3 feet',
    family: 'Cucurbitaceae',
    varieties: ['SV4098CV 2'],
    uses: ['fresh', 'salads', 'sandwiches']
  },
  {
    id: 'cucumber-sv4719cs-2',
    name: 'Cucumber - SV4719CS 2',
    scientificName: 'Cucumis sativus',
    category: 'cucurbit',
    spacing: 12,
    rowSpacing: 36,
    daysToGermination: 7,
    daysToHarvest: 50,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'bean', 'radish', 'marigold'],
    enemies: ['potato', 'aromatic herbs'],
    description: 'white pickling cucumber. Perfect size and texture for pickling.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '2-3 feet',
    family: 'Cucurbitaceae',
    varieties: ['SV4719CS 2'],
    uses: ['pickling', 'fresh']
  },
  {
    id: 'cucumber-sv4098cv-2',
    name: 'Cucumber - SV4098CV 2',
    scientificName: 'Cucumis sativus',
    category: 'cucurbit',
    spacing: 18,
    rowSpacing: 36,
    daysToGermination: 7,
    daysToHarvest: 60,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'bean', 'radish', 'marigold'],
    enemies: ['potato', 'aromatic herbs'],
    description: 'yellow asian cucumber. Long slender fruits, burpless and sweet.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '2-3 feet',
    family: 'Cucurbitaceae',
    varieties: ['SV4098CV 2'],
    uses: ['fresh', 'salads', 'sandwiches']
  },
  {
    id: 'cucumber-sv4719cs-2',
    name: 'Cucumber - SV4719CS 2',
    scientificName: 'Cucumis sativus',
    category: 'cucurbit',
    spacing: 18,
    rowSpacing: 36,
    daysToGermination: 7,
    daysToHarvest: 55,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'bean', 'radish', 'marigold'],
    enemies: ['potato', 'aromatic herbs'],
    description: 'striped specialty cucumber. Unique shape or color for specialty markets.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '2-3 feet',
    family: 'Cucurbitaceae',
    varieties: ['SV4719CS 2'],
    uses: ['fresh', 'salads', 'sandwiches']
  },
  {
    id: 'cucumber-sv4098cv-2',
    name: 'Cucumber - SV4098CV 2',
    scientificName: 'Cucumis sativus',
    category: 'cucurbit',
    spacing: 12,
    rowSpacing: 36,
    daysToGermination: 7,
    daysToHarvest: 55,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'bean', 'radish', 'marigold'],
    enemies: ['potato', 'aromatic herbs'],
    description: 'green slicing cucumber. Classic slicing cucumber for fresh eating.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '2-3 feet',
    family: 'Cucurbitaceae',
    varieties: ['SV4098CV 2'],
    uses: ['fresh', 'salads', 'sandwiches']
  },
  {
    id: 'cucumber-sv4719cs-2',
    name: 'Cucumber - SV4719CS 2',
    scientificName: 'Cucumis sativus',
    category: 'cucurbit',
    spacing: 12,
    rowSpacing: 36,
    daysToGermination: 7,
    daysToHarvest: 50,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'bean', 'radish', 'marigold'],
    enemies: ['potato', 'aromatic herbs'],
    description: 'white pickling cucumber. Perfect size and texture for pickling.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '2-3 feet',
    family: 'Cucurbitaceae',
    varieties: ['SV4719CS 2'],
    uses: ['pickling', 'fresh']
  },
  {
    id: 'cucumber-marketmore-3',
    name: 'Cucumber - Marketmore 3',
    scientificName: 'Cucumis sativus',
    category: 'cucurbit',
    spacing: 18,
    rowSpacing: 36,
    daysToGermination: 7,
    daysToHarvest: 60,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'bean', 'radish', 'marigold'],
    enemies: ['potato', 'aromatic herbs'],
    description: 'yellow asian cucumber. Long slender fruits, burpless and sweet.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '2-3 feet',
    family: 'Cucurbitaceae',
    varieties: ['Marketmore 3'],
    uses: ['fresh', 'salads', 'sandwiches']
  },
  {
    id: 'cucumber-straight-eight-3',
    name: 'Cucumber - Straight Eight 3',
    scientificName: 'Cucumis sativus',
    category: 'cucurbit',
    spacing: 18,
    rowSpacing: 36,
    daysToGermination: 7,
    daysToHarvest: 55,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'bean', 'radish', 'marigold'],
    enemies: ['potato', 'aromatic herbs'],
    description: 'striped specialty cucumber. Unique shape or color for specialty markets.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '2-3 feet',
    family: 'Cucurbitaceae',
    varieties: ['Straight Eight 3'],
    uses: ['fresh', 'salads', 'sandwiches']
  },
  {
    id: 'cucumber-national-pickling-3',
    name: 'Cucumber - National Pickling 3',
    scientificName: 'Cucumis sativus',
    category: 'cucurbit',
    spacing: 12,
    rowSpacing: 36,
    daysToGermination: 7,
    daysToHarvest: 55,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'bean', 'radish', 'marigold'],
    enemies: ['potato', 'aromatic herbs'],
    description: 'green slicing cucumber. Classic slicing cucumber for fresh eating.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '2-3 feet',
    family: 'Cucurbitaceae',
    varieties: ['National Pickling 3'],
    uses: ['fresh', 'salads', 'sandwiches']
  },
  {
    id: 'cucumber-boston-pickling-3',
    name: 'Cucumber - Boston Pickling 3',
    scientificName: 'Cucumis sativus',
    category: 'cucurbit',
    spacing: 12,
    rowSpacing: 36,
    daysToGermination: 7,
    daysToHarvest: 50,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'bean', 'radish', 'marigold'],
    enemies: ['potato', 'aromatic herbs'],
    description: 'white pickling cucumber. Perfect size and texture for pickling.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '2-3 feet',
    family: 'Cucurbitaceae',
    varieties: ['Boston Pickling 3'],
    uses: ['pickling', 'fresh']
  },
  {
    id: 'cucumber-diva-3',
    name: 'Cucumber - Diva 3',
    scientificName: 'Cucumis sativus',
    category: 'cucurbit',
    spacing: 18,
    rowSpacing: 36,
    daysToGermination: 7,
    daysToHarvest: 60,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'bean', 'radish', 'marigold'],
    enemies: ['potato', 'aromatic herbs'],
    description: 'yellow asian cucumber. Long slender fruits, burpless and sweet.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '2-3 feet',
    family: 'Cucurbitaceae',
    varieties: ['Diva 3'],
    uses: ['fresh', 'salads', 'sandwiches']
  },
  {
    id: 'cucumber-county-fair-3',
    name: 'Cucumber - County Fair 3',
    scientificName: 'Cucumis sativus',
    category: 'cucurbit',
    spacing: 18,
    rowSpacing: 36,
    daysToGermination: 7,
    daysToHarvest: 55,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'bean', 'radish', 'marigold'],
    enemies: ['potato', 'aromatic herbs'],
    description: 'striped specialty cucumber. Unique shape or color for specialty markets.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '2-3 feet',
    family: 'Cucurbitaceae',
    varieties: ['County Fair 3'],
    uses: ['fresh', 'salads', 'sandwiches']
  },
  {
    id: 'cucumber-salad-bush-3',
    name: 'Cucumber - Salad Bush 3',
    scientificName: 'Cucumis sativus',
    category: 'cucurbit',
    spacing: 12,
    rowSpacing: 36,
    daysToGermination: 7,
    daysToHarvest: 55,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'bean', 'radish', 'marigold'],
    enemies: ['potato', 'aromatic herbs'],
    description: 'green slicing cucumber. Classic slicing cucumber for fresh eating.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '2-3 feet',
    family: 'Cucurbitaceae',
    varieties: ['Salad Bush 3'],
    uses: ['fresh', 'salads', 'sandwiches']
  },
  {
    id: 'cucumber-spacemaster-3',
    name: 'Cucumber - Spacemaster 3',
    scientificName: 'Cucumis sativus',
    category: 'cucurbit',
    spacing: 12,
    rowSpacing: 36,
    daysToGermination: 7,
    daysToHarvest: 50,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'bean', 'radish', 'marigold'],
    enemies: ['potato', 'aromatic herbs'],
    description: 'white pickling cucumber. Perfect size and texture for pickling.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '2-3 feet',
    family: 'Cucurbitaceae',
    varieties: ['Spacemaster 3'],
    uses: ['pickling', 'fresh']
  },
  {
    id: 'cucumber-bush-champion-3',
    name: 'Cucumber - Bush Champion 3',
    scientificName: 'Cucumis sativus',
    category: 'cucurbit',
    spacing: 18,
    rowSpacing: 36,
    daysToGermination: 7,
    daysToHarvest: 60,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'bean', 'radish', 'marigold'],
    enemies: ['potato', 'aromatic herbs'],
    description: 'yellow asian cucumber. Long slender fruits, burpless and sweet.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '2-3 feet',
    family: 'Cucurbitaceae',
    varieties: ['Bush Champion 3'],
    uses: ['fresh', 'salads', 'sandwiches']
  },
  {
    id: 'cucumber-picklebush-3',
    name: 'Cucumber - Picklebush 3',
    scientificName: 'Cucumis sativus',
    category: 'cucurbit',
    spacing: 18,
    rowSpacing: 36,
    daysToGermination: 7,
    daysToHarvest: 55,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'bean', 'radish', 'marigold'],
    enemies: ['potato', 'aromatic herbs'],
    description: 'striped specialty cucumber. Unique shape or color for specialty markets.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '2-3 feet',
    family: 'Cucurbitaceae',
    varieties: ['Picklebush 3'],
    uses: ['fresh', 'salads', 'sandwiches']
  },
  {
    id: 'cucumber-homemade-pickles-3',
    name: 'Cucumber - Homemade Pickles 3',
    scientificName: 'Cucumis sativus',
    category: 'cucurbit',
    spacing: 12,
    rowSpacing: 36,
    daysToGermination: 7,
    daysToHarvest: 55,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'bean', 'radish', 'marigold'],
    enemies: ['potato', 'aromatic herbs'],
    description: 'green slicing cucumber. Classic slicing cucumber for fresh eating.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '2-3 feet',
    family: 'Cucurbitaceae',
    varieties: ['Homemade Pickles 3'],
    uses: ['fresh', 'salads', 'sandwiches']
  },
  {
    id: 'cucumber-chicago-pickling-3',
    name: 'Cucumber - Chicago Pickling 3',
    scientificName: 'Cucumis sativus',
    category: 'cucurbit',
    spacing: 12,
    rowSpacing: 36,
    daysToGermination: 7,
    daysToHarvest: 50,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'bean', 'radish', 'marigold'],
    enemies: ['potato', 'aromatic herbs'],
    description: 'white pickling cucumber. Perfect size and texture for pickling.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '2-3 feet',
    family: 'Cucurbitaceae',
    varieties: ['Chicago Pickling 3'],
    uses: ['pickling', 'fresh']
  },
  {
    id: 'cucumber-little-leaf-3',
    name: 'Cucumber - Little Leaf 3',
    scientificName: 'Cucumis sativus',
    category: 'cucurbit',
    spacing: 18,
    rowSpacing: 36,
    daysToGermination: 7,
    daysToHarvest: 60,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'bean', 'radish', 'marigold'],
    enemies: ['potato', 'aromatic herbs'],
    description: 'yellow asian cucumber. Long slender fruits, burpless and sweet.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '2-3 feet',
    family: 'Cucurbitaceae',
    varieties: ['Little Leaf 3'],
    uses: ['fresh', 'salads', 'sandwiches']
  },
  {
    id: 'cucumber-socrates-3',
    name: 'Cucumber - Socrates 3',
    scientificName: 'Cucumis sativus',
    category: 'cucurbit',
    spacing: 18,
    rowSpacing: 36,
    daysToGermination: 7,
    daysToHarvest: 55,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'bean', 'radish', 'marigold'],
    enemies: ['potato', 'aromatic herbs'],
    description: 'striped specialty cucumber. Unique shape or color for specialty markets.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '2-3 feet',
    family: 'Cucurbitaceae',
    varieties: ['Socrates 3'],
    uses: ['fresh', 'salads', 'sandwiches']
  },
  {
    id: 'cucumber-corinto-3',
    name: 'Cucumber - Corinto 3',
    scientificName: 'Cucumis sativus',
    category: 'cucurbit',
    spacing: 12,
    rowSpacing: 36,
    daysToGermination: 7,
    daysToHarvest: 55,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'bean', 'radish', 'marigold'],
    enemies: ['potato', 'aromatic herbs'],
    description: 'green slicing cucumber. Classic slicing cucumber for fresh eating.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '2-3 feet',
    family: 'Cucurbitaceae',
    varieties: ['Corinto 3'],
    uses: ['fresh', 'salads', 'sandwiches']
  },
  {
    id: 'cucumber-excelsior-3',
    name: 'Cucumber - Excelsior 3',
    scientificName: 'Cucumis sativus',
    category: 'cucurbit',
    spacing: 12,
    rowSpacing: 36,
    daysToGermination: 7,
    daysToHarvest: 50,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'bean', 'radish', 'marigold'],
    enemies: ['potato', 'aromatic herbs'],
    description: 'white pickling cucumber. Perfect size and texture for pickling.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '2-3 feet',
    family: 'Cucurbitaceae',
    varieties: ['Excelsior 3'],
    uses: ['pickling', 'fresh']
  },
  {
    id: 'cucumber-fanfare-3',
    name: 'Cucumber - Fanfare 3',
    scientificName: 'Cucumis sativus',
    category: 'cucurbit',
    spacing: 18,
    rowSpacing: 36,
    daysToGermination: 7,
    daysToHarvest: 60,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'bean', 'radish', 'marigold'],
    enemies: ['potato', 'aromatic herbs'],
    description: 'yellow asian cucumber. Long slender fruits, burpless and sweet.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '2-3 feet',
    family: 'Cucurbitaceae',
    varieties: ['Fanfare 3'],
    uses: ['fresh', 'salads', 'sandwiches']
  },
  {
    id: 'cucumber-greensleeves-3',
    name: 'Cucumber - Greensleeves 3',
    scientificName: 'Cucumis sativus',
    category: 'cucurbit',
    spacing: 18,
    rowSpacing: 36,
    daysToGermination: 7,
    daysToHarvest: 55,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'bean', 'radish', 'marigold'],
    enemies: ['potato', 'aromatic herbs'],
    description: 'striped specialty cucumber. Unique shape or color for specialty markets.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '2-3 feet',
    family: 'Cucurbitaceae',
    varieties: ['Greensleeves 3'],
    uses: ['fresh', 'salads', 'sandwiches']
  },
  {
    id: 'cucumber-harmony-3',
    name: 'Cucumber - Harmony 3',
    scientificName: 'Cucumis sativus',
    category: 'cucurbit',
    spacing: 12,
    rowSpacing: 36,
    daysToGermination: 7,
    daysToHarvest: 55,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'bean', 'radish', 'marigold'],
    enemies: ['potato', 'aromatic herbs'],
    description: 'green slicing cucumber. Classic slicing cucumber for fresh eating.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '2-3 feet',
    family: 'Cucurbitaceae',
    varieties: ['Harmony 3'],
    uses: ['fresh', 'salads', 'sandwiches']
  },
  {
    id: 'cucumber-jackson-3',
    name: 'Cucumber - Jackson 3',
    scientificName: 'Cucumis sativus',
    category: 'cucurbit',
    spacing: 12,
    rowSpacing: 36,
    daysToGermination: 7,
    daysToHarvest: 50,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'bean', 'radish', 'marigold'],
    enemies: ['potato', 'aromatic herbs'],
    description: 'white pickling cucumber. Perfect size and texture for pickling.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '2-3 feet',
    family: 'Cucurbitaceae',
    varieties: ['Jackson 3'],
    uses: ['pickling', 'fresh']
  },
  {
    id: 'cucumber-jawell-3',
    name: 'Cucumber - Jawell 3',
    scientificName: 'Cucumis sativus',
    category: 'cucurbit',
    spacing: 18,
    rowSpacing: 36,
    daysToGermination: 7,
    daysToHarvest: 60,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'bean', 'radish', 'marigold'],
    enemies: ['potato', 'aromatic herbs'],
    description: 'yellow asian cucumber. Long slender fruits, burpless and sweet.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '2-3 feet',
    family: 'Cucurbitaceae',
    varieties: ['Jawell 3'],
    uses: ['fresh', 'salads', 'sandwiches']
  },
  {
    id: 'cucumber-katrina-3',
    name: 'Cucumber - Katrina 3',
    scientificName: 'Cucumis sativus',
    category: 'cucurbit',
    spacing: 18,
    rowSpacing: 36,
    daysToGermination: 7,
    daysToHarvest: 55,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'bean', 'radish', 'marigold'],
    enemies: ['potato', 'aromatic herbs'],
    description: 'striped specialty cucumber. Unique shape or color for specialty markets.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '2-3 feet',
    family: 'Cucurbitaceae',
    varieties: ['Katrina 3'],
    uses: ['fresh', 'salads', 'sandwiches']
  },
  {
    id: 'cucumber-lemon-3',
    name: 'Cucumber - Lemon 3',
    scientificName: 'Cucumis sativus',
    category: 'cucurbit',
    spacing: 12,
    rowSpacing: 36,
    daysToGermination: 7,
    daysToHarvest: 55,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'bean', 'radish', 'marigold'],
    enemies: ['potato', 'aromatic herbs'],
    description: 'green slicing cucumber. Classic slicing cucumber for fresh eating.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '2-3 feet',
    family: 'Cucurbitaceae',
    varieties: ['Lemon 3'],
    uses: ['fresh', 'salads', 'sandwiches']
  },
  {
    id: 'cucumber-manny-3',
    name: 'Cucumber - Manny 3',
    scientificName: 'Cucumis sativus',
    category: 'cucurbit',
    spacing: 12,
    rowSpacing: 36,
    daysToGermination: 7,
    daysToHarvest: 50,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'bean', 'radish', 'marigold'],
    enemies: ['potato', 'aromatic herbs'],
    description: 'white pickling cucumber. Perfect size and texture for pickling.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '2-3 feet',
    family: 'Cucurbitaceae',
    varieties: ['Manny 3'],
    uses: ['pickling', 'fresh']
  },
  {
    id: 'cucumber-orient-express-3',
    name: 'Cucumber - Orient Express 3',
    scientificName: 'Cucumis sativus',
    category: 'cucurbit',
    spacing: 18,
    rowSpacing: 36,
    daysToGermination: 7,
    daysToHarvest: 60,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'bean', 'radish', 'marigold'],
    enemies: ['potato', 'aromatic herbs'],
    description: 'yellow asian cucumber. Long slender fruits, burpless and sweet.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '2-3 feet',
    family: 'Cucurbitaceae',
    varieties: ['Orient Express 3'],
    uses: ['fresh', 'salads', 'sandwiches']
  },
  {
    id: 'cucumber-poinsett-76-3',
    name: 'Cucumber - Poinsett 76 3',
    scientificName: 'Cucumis sativus',
    category: 'cucurbit',
    spacing: 18,
    rowSpacing: 36,
    daysToGermination: 7,
    daysToHarvest: 55,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'bean', 'radish', 'marigold'],
    enemies: ['potato', 'aromatic herbs'],
    description: 'striped specialty cucumber. Unique shape or color for specialty markets.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '2-3 feet',
    family: 'Cucurbitaceae',
    varieties: ['Poinsett 76 3'],
    uses: ['fresh', 'salads', 'sandwiches']
  },
  {
    id: 'cucumber-saladin-3',
    name: 'Cucumber - Saladin 3',
    scientificName: 'Cucumis sativus',
    category: 'cucurbit',
    spacing: 12,
    rowSpacing: 36,
    daysToGermination: 7,
    daysToHarvest: 55,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'bean', 'radish', 'marigold'],
    enemies: ['potato', 'aromatic herbs'],
    description: 'green slicing cucumber. Classic slicing cucumber for fresh eating.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '2-3 feet',
    family: 'Cucurbitaceae',
    varieties: ['Saladin 3'],
    uses: ['fresh', 'salads', 'sandwiches']
  },
  {
    id: 'cucumber-suyo-long-3',
    name: 'Cucumber - Suyo Long 3',
    scientificName: 'Cucumis sativus',
    category: 'cucurbit',
    spacing: 12,
    rowSpacing: 36,
    daysToGermination: 7,
    daysToHarvest: 50,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'bean', 'radish', 'marigold'],
    enemies: ['potato', 'aromatic herbs'],
    description: 'white pickling cucumber. Perfect size and texture for pickling.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '2-3 feet',
    family: 'Cucurbitaceae',
    varieties: ['Suyo Long 3'],
    uses: ['pickling', 'fresh']
  },
  {
    id: 'cucumber-tasty-green-3',
    name: 'Cucumber - Tasty Green 3',
    scientificName: 'Cucumis sativus',
    category: 'cucurbit',
    spacing: 18,
    rowSpacing: 36,
    daysToGermination: 7,
    daysToHarvest: 60,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'bean', 'radish', 'marigold'],
    enemies: ['potato', 'aromatic herbs'],
    description: 'yellow asian cucumber. Long slender fruits, burpless and sweet.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '2-3 feet',
    family: 'Cucurbitaceae',
    varieties: ['Tasty Green 3'],
    uses: ['fresh', 'salads', 'sandwiches']
  },
  {
    id: 'cucumber-tendergreen-burpless-3',
    name: 'Cucumber - Tendergreen Burpless 3',
    scientificName: 'Cucumis sativus',
    category: 'cucurbit',
    spacing: 18,
    rowSpacing: 36,
    daysToGermination: 7,
    daysToHarvest: 55,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'bean', 'radish', 'marigold'],
    enemies: ['potato', 'aromatic herbs'],
    description: 'striped specialty cucumber. Unique shape or color for specialty markets.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '2-3 feet',
    family: 'Cucurbitaceae',
    varieties: ['Tendergreen Burpless 3'],
    uses: ['fresh', 'salads', 'sandwiches']
  },
  {
    id: 'cucumber-tyria-3',
    name: 'Cucumber - Tyria 3',
    scientificName: 'Cucumis sativus',
    category: 'cucurbit',
    spacing: 12,
    rowSpacing: 36,
    daysToGermination: 7,
    daysToHarvest: 55,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'bean', 'radish', 'marigold'],
    enemies: ['potato', 'aromatic herbs'],
    description: 'green slicing cucumber. Classic slicing cucumber for fresh eating.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '2-3 feet',
    family: 'Cucurbitaceae',
    varieties: ['Tyria 3'],
    uses: ['fresh', 'salads', 'sandwiches']
  },
  {
    id: 'cucumber-unagi-3',
    name: 'Cucumber - Unagi 3',
    scientificName: 'Cucumis sativus',
    category: 'cucurbit',
    spacing: 12,
    rowSpacing: 36,
    daysToGermination: 7,
    daysToHarvest: 50,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'bean', 'radish', 'marigold'],
    enemies: ['potato', 'aromatic herbs'],
    description: 'white pickling cucumber. Perfect size and texture for pickling.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '2-3 feet',
    family: 'Cucurbitaceae',
    varieties: ['Unagi 3'],
    uses: ['pickling', 'fresh']
  },
  {
    id: 'cucumber-vlasstar-3',
    name: 'Cucumber - Vlasstar 3',
    scientificName: 'Cucumis sativus',
    category: 'cucurbit',
    spacing: 18,
    rowSpacing: 36,
    daysToGermination: 7,
    daysToHarvest: 60,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'bean', 'radish', 'marigold'],
    enemies: ['potato', 'aromatic herbs'],
    description: 'yellow asian cucumber. Long slender fruits, burpless and sweet.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '2-3 feet',
    family: 'Cucurbitaceae',
    varieties: ['Vlasstar 3'],
    uses: ['fresh', 'salads', 'sandwiches']
  },
  {
    id: 'cucumber-wautoma-3',
    name: 'Cucumber - Wautoma 3',
    scientificName: 'Cucumis sativus',
    category: 'cucurbit',
    spacing: 18,
    rowSpacing: 36,
    daysToGermination: 7,
    daysToHarvest: 55,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'bean', 'radish', 'marigold'],
    enemies: ['potato', 'aromatic herbs'],
    description: 'striped specialty cucumber. Unique shape or color for specialty markets.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '2-3 feet',
    family: 'Cucurbitaceae',
    varieties: ['Wautoma 3'],
    uses: ['fresh', 'salads', 'sandwiches']
  },
  {
    id: 'cucumber-white-wonder-3',
    name: 'Cucumber - White Wonder 3',
    scientificName: 'Cucumis sativus',
    category: 'cucurbit',
    spacing: 12,
    rowSpacing: 36,
    daysToGermination: 7,
    daysToHarvest: 55,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'bean', 'radish', 'marigold'],
    enemies: ['potato', 'aromatic herbs'],
    description: 'green slicing cucumber. Classic slicing cucumber for fresh eating.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '2-3 feet',
    family: 'Cucurbitaceae',
    varieties: ['White Wonder 3'],
    uses: ['fresh', 'salads', 'sandwiches']
  },
  {
    id: 'cucumber-yamato-3',
    name: 'Cucumber - Yamato 3',
    scientificName: 'Cucumis sativus',
    category: 'cucurbit',
    spacing: 12,
    rowSpacing: 36,
    daysToGermination: 7,
    daysToHarvest: 50,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'bean', 'radish', 'marigold'],
    enemies: ['potato', 'aromatic herbs'],
    description: 'white pickling cucumber. Perfect size and texture for pickling.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '2-3 feet',
    family: 'Cucurbitaceae',
    varieties: ['Yamato 3'],
    uses: ['pickling', 'fresh']
  },
  {
    id: 'cucumber-zapotec-3',
    name: 'Cucumber - Zapotec 3',
    scientificName: 'Cucumis sativus',
    category: 'cucurbit',
    spacing: 18,
    rowSpacing: 36,
    daysToGermination: 7,
    daysToHarvest: 60,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'bean', 'radish', 'marigold'],
    enemies: ['potato', 'aromatic herbs'],
    description: 'yellow asian cucumber. Long slender fruits, burpless and sweet.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '2-3 feet',
    family: 'Cucurbitaceae',
    varieties: ['Zapotec 3'],
    uses: ['fresh', 'salads', 'sandwiches']
  },
  {
    id: 'cucumber-armenian-3',
    name: 'Cucumber - Armenian 3',
    scientificName: 'Cucumis sativus',
    category: 'cucurbit',
    spacing: 18,
    rowSpacing: 36,
    daysToGermination: 7,
    daysToHarvest: 55,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'bean', 'radish', 'marigold'],
    enemies: ['potato', 'aromatic herbs'],
    description: 'striped specialty cucumber. Unique shape or color for specialty markets.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '2-3 feet',
    family: 'Cucurbitaceae',
    varieties: ['Armenian 3'],
    uses: ['fresh', 'salads', 'sandwiches']
  },
  {
    id: 'cucumber-english-telegraph-3',
    name: 'Cucumber - English Telegraph 3',
    scientificName: 'Cucumis sativus',
    category: 'cucurbit',
    spacing: 12,
    rowSpacing: 36,
    daysToGermination: 7,
    daysToHarvest: 55,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'bean', 'radish', 'marigold'],
    enemies: ['potato', 'aromatic herbs'],
    description: 'green slicing cucumber. Classic slicing cucumber for fresh eating.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '2-3 feet',
    family: 'Cucurbitaceae',
    varieties: ['English Telegraph 3'],
    uses: ['fresh', 'salads', 'sandwiches']
  },
  {
    id: 'cucumber-persian-3',
    name: 'Cucumber - Persian 3',
    scientificName: 'Cucumis sativus',
    category: 'cucurbit',
    spacing: 12,
    rowSpacing: 36,
    daysToGermination: 7,
    daysToHarvest: 50,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'bean', 'radish', 'marigold'],
    enemies: ['potato', 'aromatic herbs'],
    description: 'white pickling cucumber. Perfect size and texture for pickling.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '2-3 feet',
    family: 'Cucurbitaceae',
    varieties: ['Persian 3'],
    uses: ['pickling', 'fresh']
  },
  {
    id: 'cucumber-beit-alpha-3',
    name: 'Cucumber - Beit Alpha 3',
    scientificName: 'Cucumis sativus',
    category: 'cucurbit',
    spacing: 18,
    rowSpacing: 36,
    daysToGermination: 7,
    daysToHarvest: 60,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'bean', 'radish', 'marigold'],
    enemies: ['potato', 'aromatic herbs'],
    description: 'yellow asian cucumber. Long slender fruits, burpless and sweet.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '2-3 feet',
    family: 'Cucurbitaceae',
    varieties: ['Beit Alpha 3'],
    uses: ['fresh', 'salads', 'sandwiches']
  },
  {
    id: 'cucumber-japanese-climbing-3',
    name: 'Cucumber - Japanese Climbing 3',
    scientificName: 'Cucumis sativus',
    category: 'cucurbit',
    spacing: 18,
    rowSpacing: 36,
    daysToGermination: 7,
    daysToHarvest: 55,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'bean', 'radish', 'marigold'],
    enemies: ['potato', 'aromatic herbs'],
    description: 'striped specialty cucumber. Unique shape or color for specialty markets.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '2-3 feet',
    family: 'Cucurbitaceae',
    varieties: ['Japanese Climbing 3'],
    uses: ['fresh', 'salads', 'sandwiches']
  },
  {
    id: 'cucumber-west-indian-gherkin-3',
    name: 'Cucumber - West Indian Gherkin 3',
    scientificName: 'Cucumis sativus',
    category: 'cucurbit',
    spacing: 12,
    rowSpacing: 36,
    daysToGermination: 7,
    daysToHarvest: 55,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'bean', 'radish', 'marigold'],
    enemies: ['potato', 'aromatic herbs'],
    description: 'green slicing cucumber. Classic slicing cucumber for fresh eating.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '2-3 feet',
    family: 'Cucurbitaceae',
    varieties: ['West Indian Gherkin 3'],
    uses: ['fresh', 'salads', 'sandwiches']
  },
  {
    id: 'cucumber-mexican-sour-gherkin-3',
    name: 'Cucumber - Mexican Sour Gherkin 3',
    scientificName: 'Cucumis sativus',
    category: 'cucurbit',
    spacing: 12,
    rowSpacing: 36,
    daysToGermination: 7,
    daysToHarvest: 50,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'bean', 'radish', 'marigold'],
    enemies: ['potato', 'aromatic herbs'],
    description: 'white pickling cucumber. Perfect size and texture for pickling.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '2-3 feet',
    family: 'Cucurbitaceae',
    varieties: ['Mexican Sour Gherkin 3'],
    uses: ['pickling', 'fresh']
  },
  {
    id: 'cucumber-crystal-apple-3',
    name: 'Cucumber - Crystal Apple 3',
    scientificName: 'Cucumis sativus',
    category: 'cucurbit',
    spacing: 18,
    rowSpacing: 36,
    daysToGermination: 7,
    daysToHarvest: 60,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'bean', 'radish', 'marigold'],
    enemies: ['potato', 'aromatic herbs'],
    description: 'yellow asian cucumber. Long slender fruits, burpless and sweet.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '2-3 feet',
    family: 'Cucurbitaceae',
    varieties: ['Crystal Apple 3'],
    uses: ['fresh', 'salads', 'sandwiches']
  },
  {
    id: 'cucumber-richmond-green-apple-3',
    name: 'Cucumber - Richmond Green Apple 3',
    scientificName: 'Cucumis sativus',
    category: 'cucurbit',
    spacing: 18,
    rowSpacing: 36,
    daysToGermination: 7,
    daysToHarvest: 55,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'bean', 'radish', 'marigold'],
    enemies: ['potato', 'aromatic herbs'],
    description: 'striped specialty cucumber. Unique shape or color for specialty markets.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '2-3 feet',
    family: 'Cucurbitaceae',
    varieties: ['Richmond Green Apple 3'],
    uses: ['fresh', 'salads', 'sandwiches']
  },
  {
    id: 'cucumber-poona-kheera-3',
    name: 'Cucumber - Poona Kheera 3',
    scientificName: 'Cucumis sativus',
    category: 'cucurbit',
    spacing: 12,
    rowSpacing: 36,
    daysToGermination: 7,
    daysToHarvest: 55,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'bean', 'radish', 'marigold'],
    enemies: ['potato', 'aromatic herbs'],
    description: 'green slicing cucumber. Classic slicing cucumber for fresh eating.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '2-3 feet',
    family: 'Cucurbitaceae',
    varieties: ['Poona Kheera 3'],
    uses: ['fresh', 'salads', 'sandwiches']
  },
  {
    id: 'cucumber-dasher-ii-3',
    name: 'Cucumber - Dasher II 3',
    scientificName: 'Cucumis sativus',
    category: 'cucurbit',
    spacing: 12,
    rowSpacing: 36,
    daysToGermination: 7,
    daysToHarvest: 50,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'bean', 'radish', 'marigold'],
    enemies: ['potato', 'aromatic herbs'],
    description: 'white pickling cucumber. Perfect size and texture for pickling.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '2-3 feet',
    family: 'Cucurbitaceae',
    varieties: ['Dasher II 3'],
    uses: ['pickling', 'fresh']
  },
  {
    id: 'cucumber-indio-3',
    name: 'Cucumber - Indio 3',
    scientificName: 'Cucumis sativus',
    category: 'cucurbit',
    spacing: 18,
    rowSpacing: 36,
    daysToGermination: 7,
    daysToHarvest: 60,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'bean', 'radish', 'marigold'],
    enemies: ['potato', 'aromatic herbs'],
    description: 'yellow asian cucumber. Long slender fruits, burpless and sweet.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '2-3 feet',
    family: 'Cucurbitaceae',
    varieties: ['Indio 3'],
    uses: ['fresh', 'salads', 'sandwiches']
  },
  {
    id: 'cucumber-thunder-3',
    name: 'Cucumber - Thunder 3',
    scientificName: 'Cucumis sativus',
    category: 'cucurbit',
    spacing: 18,
    rowSpacing: 36,
    daysToGermination: 7,
    daysToHarvest: 55,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'bean', 'radish', 'marigold'],
    enemies: ['potato', 'aromatic herbs'],
    description: 'striped specialty cucumber. Unique shape or color for specialty markets.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '2-3 feet',
    family: 'Cucurbitaceae',
    varieties: ['Thunder 3'],
    uses: ['fresh', 'salads', 'sandwiches']
  },
  {
    id: 'cucumber-general-lee-3',
    name: 'Cucumber - General Lee 3',
    scientificName: 'Cucumis sativus',
    category: 'cucurbit',
    spacing: 12,
    rowSpacing: 36,
    daysToGermination: 7,
    daysToHarvest: 55,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'bean', 'radish', 'marigold'],
    enemies: ['potato', 'aromatic herbs'],
    description: 'green slicing cucumber. Classic slicing cucumber for fresh eating.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '2-3 feet',
    family: 'Cucurbitaceae',
    varieties: ['General Lee 3'],
    uses: ['fresh', 'salads', 'sandwiches']
  },
  {
    id: 'cucumber-speedway-3',
    name: 'Cucumber - Speedway 3',
    scientificName: 'Cucumis sativus',
    category: 'cucurbit',
    spacing: 12,
    rowSpacing: 36,
    daysToGermination: 7,
    daysToHarvest: 50,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'bean', 'radish', 'marigold'],
    enemies: ['potato', 'aromatic herbs'],
    description: 'white pickling cucumber. Perfect size and texture for pickling.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '2-3 feet',
    family: 'Cucurbitaceae',
    varieties: ['Speedway 3'],
    uses: ['pickling', 'fresh']
  },
  {
    id: 'cucumber-turbo-3',
    name: 'Cucumber - Turbo 3',
    scientificName: 'Cucumis sativus',
    category: 'cucurbit',
    spacing: 18,
    rowSpacing: 36,
    daysToGermination: 7,
    daysToHarvest: 60,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'bean', 'radish', 'marigold'],
    enemies: ['potato', 'aromatic herbs'],
    description: 'yellow asian cucumber. Long slender fruits, burpless and sweet.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '2-3 feet',
    family: 'Cucurbitaceae',
    varieties: ['Turbo 3'],
    uses: ['fresh', 'salads', 'sandwiches']
  },
  {
    id: 'cucumber-rocky-3',
    name: 'Cucumber - Rocky 3',
    scientificName: 'Cucumis sativus',
    category: 'cucurbit',
    spacing: 18,
    rowSpacing: 36,
    daysToGermination: 7,
    daysToHarvest: 55,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'bean', 'radish', 'marigold'],
    enemies: ['potato', 'aromatic herbs'],
    description: 'striped specialty cucumber. Unique shape or color for specialty markets.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '2-3 feet',
    family: 'Cucurbitaceae',
    varieties: ['Rocky 3'],
    uses: ['fresh', 'salads', 'sandwiches']
  },
  {
    id: 'cucumber-sprint-3',
    name: 'Cucumber - Sprint 3',
    scientificName: 'Cucumis sativus',
    category: 'cucurbit',
    spacing: 12,
    rowSpacing: 36,
    daysToGermination: 7,
    daysToHarvest: 55,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'bean', 'radish', 'marigold'],
    enemies: ['potato', 'aromatic herbs'],
    description: 'green slicing cucumber. Classic slicing cucumber for fresh eating.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '2-3 feet',
    family: 'Cucurbitaceae',
    varieties: ['Sprint 3'],
    uses: ['fresh', 'salads', 'sandwiches']
  },
  {
    id: 'cucumber-intimidator-3',
    name: 'Cucumber - Intimidator 3',
    scientificName: 'Cucumis sativus',
    category: 'cucurbit',
    spacing: 12,
    rowSpacing: 36,
    daysToGermination: 7,
    daysToHarvest: 50,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'bean', 'radish', 'marigold'],
    enemies: ['potato', 'aromatic herbs'],
    description: 'white pickling cucumber. Perfect size and texture for pickling.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '2-3 feet',
    family: 'Cucurbitaceae',
    varieties: ['Intimidator 3'],
    uses: ['pickling', 'fresh']
  },
  {
    id: 'cucumber-revenue-3',
    name: 'Cucumber - Revenue 3',
    scientificName: 'Cucumis sativus',
    category: 'cucurbit',
    spacing: 18,
    rowSpacing: 36,
    daysToGermination: 7,
    daysToHarvest: 60,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'bean', 'radish', 'marigold'],
    enemies: ['potato', 'aromatic herbs'],
    description: 'yellow asian cucumber. Long slender fruits, burpless and sweet.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '2-3 feet',
    family: 'Cucurbitaceae',
    varieties: ['Revenue 3'],
    uses: ['fresh', 'salads', 'sandwiches']
  },
  {
    id: 'cucumber-sv4719cs-3',
    name: 'Cucumber - SV4719CS 3',
    scientificName: 'Cucumis sativus',
    category: 'cucurbit',
    spacing: 18,
    rowSpacing: 36,
    daysToGermination: 7,
    daysToHarvest: 55,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'bean', 'radish', 'marigold'],
    enemies: ['potato', 'aromatic herbs'],
    description: 'striped specialty cucumber. Unique shape or color for specialty markets.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '2-3 feet',
    family: 'Cucurbitaceae',
    varieties: ['SV4719CS 3'],
    uses: ['fresh', 'salads', 'sandwiches']
  },
  {
    id: 'cucumber-sv4098cv-3',
    name: 'Cucumber - SV4098CV 3',
    scientificName: 'Cucumis sativus',
    category: 'cucurbit',
    spacing: 12,
    rowSpacing: 36,
    daysToGermination: 7,
    daysToHarvest: 55,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'bean', 'radish', 'marigold'],
    enemies: ['potato', 'aromatic herbs'],
    description: 'green slicing cucumber. Classic slicing cucumber for fresh eating.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '2-3 feet',
    family: 'Cucurbitaceae',
    varieties: ['SV4098CV 3'],
    uses: ['fresh', 'salads', 'sandwiches']
  },
  {
    id: 'cucumber-sv4719cs-3',
    name: 'Cucumber - SV4719CS 3',
    scientificName: 'Cucumis sativus',
    category: 'cucurbit',
    spacing: 12,
    rowSpacing: 36,
    daysToGermination: 7,
    daysToHarvest: 50,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'bean', 'radish', 'marigold'],
    enemies: ['potato', 'aromatic herbs'],
    description: 'white pickling cucumber. Perfect size and texture for pickling.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '2-3 feet',
    family: 'Cucurbitaceae',
    varieties: ['SV4719CS 3'],
    uses: ['pickling', 'fresh']
  },
  {
    id: 'cucumber-sv4719cs-3',
    name: 'Cucumber - SV4719CS 3',
    scientificName: 'Cucumis sativus',
    category: 'cucurbit',
    spacing: 18,
    rowSpacing: 36,
    daysToGermination: 7,
    daysToHarvest: 60,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'bean', 'radish', 'marigold'],
    enemies: ['potato', 'aromatic herbs'],
    description: 'yellow asian cucumber. Long slender fruits, burpless and sweet.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '2-3 feet',
    family: 'Cucurbitaceae',
    varieties: ['SV4719CS 3'],
    uses: ['fresh', 'salads', 'sandwiches']
  },
  {
    id: 'cucumber-sv4098cv-3',
    name: 'Cucumber - SV4098CV 3',
    scientificName: 'Cucumis sativus',
    category: 'cucurbit',
    spacing: 18,
    rowSpacing: 36,
    daysToGermination: 7,
    daysToHarvest: 55,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'bean', 'radish', 'marigold'],
    enemies: ['potato', 'aromatic herbs'],
    description: 'striped specialty cucumber. Unique shape or color for specialty markets.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '2-3 feet',
    family: 'Cucurbitaceae',
    varieties: ['SV4098CV 3'],
    uses: ['fresh', 'salads', 'sandwiches']
  },
  {
    id: 'cucumber-sv4719cs-3',
    name: 'Cucumber - SV4719CS 3',
    scientificName: 'Cucumis sativus',
    category: 'cucurbit',
    spacing: 12,
    rowSpacing: 36,
    daysToGermination: 7,
    daysToHarvest: 55,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'bean', 'radish', 'marigold'],
    enemies: ['potato', 'aromatic herbs'],
    description: 'green slicing cucumber. Classic slicing cucumber for fresh eating.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '2-3 feet',
    family: 'Cucurbitaceae',
    varieties: ['SV4719CS 3'],
    uses: ['fresh', 'salads', 'sandwiches']
  },
  {
    id: 'cucumber-sv4098cv-3',
    name: 'Cucumber - SV4098CV 3',
    scientificName: 'Cucumis sativus',
    category: 'cucurbit',
    spacing: 12,
    rowSpacing: 36,
    daysToGermination: 7,
    daysToHarvest: 50,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'bean', 'radish', 'marigold'],
    enemies: ['potato', 'aromatic herbs'],
    description: 'white pickling cucumber. Perfect size and texture for pickling.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '2-3 feet',
    family: 'Cucurbitaceae',
    varieties: ['SV4098CV 3'],
    uses: ['pickling', 'fresh']
  },
  {
    id: 'cucumber-sv4719cs-3',
    name: 'Cucumber - SV4719CS 3',
    scientificName: 'Cucumis sativus',
    category: 'cucurbit',
    spacing: 18,
    rowSpacing: 36,
    daysToGermination: 7,
    daysToHarvest: 60,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'bean', 'radish', 'marigold'],
    enemies: ['potato', 'aromatic herbs'],
    description: 'yellow asian cucumber. Long slender fruits, burpless and sweet.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '2-3 feet',
    family: 'Cucurbitaceae',
    varieties: ['SV4719CS 3'],
    uses: ['fresh', 'salads', 'sandwiches']
  },
  {
    id: 'cucumber-sv4098cv-3',
    name: 'Cucumber - SV4098CV 3',
    scientificName: 'Cucumis sativus',
    category: 'cucurbit',
    spacing: 18,
    rowSpacing: 36,
    daysToGermination: 7,
    daysToHarvest: 55,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'bean', 'radish', 'marigold'],
    enemies: ['potato', 'aromatic herbs'],
    description: 'striped specialty cucumber. Unique shape or color for specialty markets.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '2-3 feet',
    family: 'Cucurbitaceae',
    varieties: ['SV4098CV 3'],
    uses: ['fresh', 'salads', 'sandwiches']
  }
,
  {
    id: 'cantaloupe-hales-best',
    name: 'Cantaloupe - Hales Best',
    scientificName: 'Cucumis melo var. cantalupensis',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Hales Best cantaloupe. Classic muskmelon with netted skin.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Hales Best'],
    uses: ['fresh', 'fruit salad', 'dessert']
  },
  {
    id: 'honeydew-ambrosia',
    name: 'Honeydew - Ambrosia',
    scientificName: 'Cucumis melo var. inodorus',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Ambrosia honeydew. Smooth pale skin, sweet green flesh.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Ambrosia'],
    uses: ['fresh', 'fruit salad', 'dessert']
  },
  {
    id: 'crenshaw-athena',
    name: 'Crenshaw - Athena',
    scientificName: 'Cucumis melo var. inodorus',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Athena crenshaw. Hybrid with salmon-pink flesh.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Athena'],
    uses: ['fresh', 'fruit salad', 'dessert']
  },
  {
    id: 'casaba-sarahs-choice',
    name: 'Casaba - Sarahs Choice',
    scientificName: 'Cucumis melo var. inodorus',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Sarahs Choice casaba. Wrinkled yellow skin, white flesh.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Sarahs Choice'],
    uses: ['fresh', 'fruit salad', 'dessert']
  },
  {
    id: 'persian-sugar-cube',
    name: 'Persian - Sugar Cube',
    scientificName: 'Cucumis melo var. reticulatus',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Sugar Cube persian. Oval with netted skin, very sweet.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Sugar Cube'],
    uses: ['fresh', 'fruit salad', 'dessert']
  },
  {
    id: 'canary-minnesota-midget',
    name: 'Canary - Minnesota Midget',
    scientificName: 'Cucumis melo var. inodorus',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Minnesota Midget canary. Bright yellow, mild and sweet.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Minnesota Midget'],
    uses: ['fresh', 'fruit salad', 'dessert']
  },
  {
    id: 'galia-hearts-of-gold',
    name: 'Galia - Hearts of Gold',
    scientificName: 'Cucumis melo var. reticulatus',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Hearts of Gold galia. Netted green skin, spicy-sweet.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Hearts of Gold'],
    uses: ['fresh', 'fruit salad', 'dessert']
  },
  {
    id: 'piel-de sapo-pmr-45',
    name: 'Piel de sapo - PMR 45',
    scientificName: 'Cucumis melo var. inodorus',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'PMR 45 piel de sapo. Toad skin, white sweet flesh.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['PMR 45'],
    uses: ['fresh', 'fruit salad', 'dessert']
  },
  {
    id: 'bitter-melon-savor',
    name: 'Bitter melon - Savor',
    scientificName: 'Momordica charantia',
    category: 'cucurbit',
    spacing: 48,
    rowSpacing: 72,
    daysToGermination: 7,
    daysToHarvest: 70,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Savor bitter melon. Bumpy green, used in Asian cuisine.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '10-12 feet',
    family: 'Cucurbitaceae',
    varieties: ['Savor'],
    uses: ['stir fry', 'curry', 'medicinal']
  },
  {
    id: 'winter-melon-tasty-bites',
    name: 'Winter melon - Tasty Bites',
    scientificName: 'Benincasa hispida',
    category: 'cucurbit',
    spacing: 48,
    rowSpacing: 72,
    daysToGermination: 7,
    daysToHarvest: 110,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Tasty Bites winter melon. Large waxy melon for soup and stew.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '10-12 feet',
    family: 'Benincaseae',
    varieties: ['Tasty Bites'],
    uses: ['soup', 'stew', 'braising']
  },
  {
    id: 'cantaloupe-green-flesh',
    name: 'Cantaloupe - Green Flesh',
    scientificName: 'Cucumis melo var. cantalupensis',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Green Flesh cantaloupe. Classic muskmelon with netted skin.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Green Flesh'],
    uses: ['fresh', 'fruit salad', 'dessert']
  },
  {
    id: 'honeydew-orange-flesh',
    name: 'Honeydew - Orange Flesh',
    scientificName: 'Cucumis melo var. inodorus',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Orange Flesh honeydew. Smooth pale skin, sweet green flesh.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Orange Flesh'],
    uses: ['fresh', 'fruit salad', 'dessert']
  },
  {
    id: 'crenshaw-honey-dew',
    name: 'Crenshaw - Honey Dew',
    scientificName: 'Cucumis melo var. inodorus',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Honey Dew crenshaw. Hybrid with salmon-pink flesh.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Honey Dew'],
    uses: ['fresh', 'fruit salad', 'dessert']
  },
  {
    id: 'casaba-honey-orange',
    name: 'Casaba - Honey Orange',
    scientificName: 'Cucumis melo var. inodorus',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Honey Orange casaba. Wrinkled yellow skin, white flesh.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Honey Orange'],
    uses: ['fresh', 'fruit salad', 'dessert']
  },
  {
    id: 'persian-temptation',
    name: 'Persian - Temptation',
    scientificName: 'Cucumis melo var. reticulatus',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Temptation persian. Oval with netted skin, very sweet.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Temptation'],
    uses: ['fresh', 'fruit salad', 'dessert']
  },
  {
    id: 'canary-passport',
    name: 'Canary - Passport',
    scientificName: 'Cucumis melo var. inodorus',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Passport canary. Bright yellow, mild and sweet.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Passport'],
    uses: ['fresh', 'fruit salad', 'dessert']
  },
  {
    id: 'galia-earli-dew',
    name: 'Galia - Earli-Dew',
    scientificName: 'Cucumis melo var. reticulatus',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Earli-Dew galia. Netted green skin, spicy-sweet.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Earli-Dew'],
    uses: ['fresh', 'fruit salad', 'dessert']
  },
  {
    id: 'piel-de sapo-honey-white',
    name: 'Piel de sapo - Honey White',
    scientificName: 'Cucumis melo var. inodorus',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Honey White piel de sapo. Toad skin, white sweet flesh.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Honey White'],
    uses: ['fresh', 'fruit salad', 'dessert']
  },
  {
    id: 'bitter-melon-honey-yellow',
    name: 'Bitter melon - Honey Yellow',
    scientificName: 'Momordica charantia',
    category: 'cucurbit',
    spacing: 48,
    rowSpacing: 72,
    daysToGermination: 7,
    daysToHarvest: 70,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Honey Yellow bitter melon. Bumpy green, used in Asian cuisine.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '10-12 feet',
    family: 'Cucurbitaceae',
    varieties: ['Honey Yellow'],
    uses: ['stir fry', 'curry', 'medicinal']
  },
  {
    id: 'winter-melon-honey-gold',
    name: 'Winter melon - Honey Gold',
    scientificName: 'Benincasa hispida',
    category: 'cucurbit',
    spacing: 48,
    rowSpacing: 72,
    daysToGermination: 7,
    daysToHarvest: 110,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Honey Gold winter melon. Large waxy melon for soup and stew.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '10-12 feet',
    family: 'Benincaseae',
    varieties: ['Honey Gold'],
    uses: ['soup', 'stew', 'braising']
  },
  {
    id: 'cantaloupe-early-crenshaw',
    name: 'Cantaloupe - Early Crenshaw',
    scientificName: 'Cucumis melo var. cantalupensis',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Early Crenshaw cantaloupe. Classic muskmelon with netted skin.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Early Crenshaw'],
    uses: ['fresh', 'fruit salad', 'dessert']
  },
  {
    id: 'honeydew-crimson-sweet',
    name: 'Honeydew - Crimson Sweet',
    scientificName: 'Cucumis melo var. inodorus',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Crimson Sweet honeydew. Smooth pale skin, sweet green flesh.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Crimson Sweet'],
    uses: ['fresh', 'fruit salad', 'dessert']
  },
  {
    id: 'crenshaw-large',
    name: 'Crenshaw - Large',
    scientificName: 'Cucumis melo var. inodorus',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Large crenshaw. Hybrid with salmon-pink flesh.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Large'],
    uses: ['fresh', 'fruit salad', 'dessert']
  },
  {
    id: 'casaba-imperial',
    name: 'Casaba - Imperial',
    scientificName: 'Cucumis melo var. inodorus',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Imperial casaba. Wrinkled yellow skin, white flesh.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Imperial'],
    uses: ['fresh', 'fruit salad', 'dessert']
  },
  {
    id: 'persian-hybrid',
    name: 'Persian - Hybrid',
    scientificName: 'Cucumis melo var. reticulatus',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Hybrid persian. Oval with netted skin, very sweet.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Hybrid'],
    uses: ['fresh', 'fruit salad', 'dessert']
  },
  {
    id: 'canary-golden-beauty',
    name: 'Canary - Golden Beauty',
    scientificName: 'Cucumis melo var. inodorus',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Golden Beauty canary. Bright yellow, mild and sweet.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Golden Beauty'],
    uses: ['fresh', 'fruit salad', 'dessert']
  },
  {
    id: 'galia-snowball',
    name: 'Galia - Snowball',
    scientificName: 'Cucumis melo var. reticulatus',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Snowball galia. Netted green skin, spicy-sweet.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Snowball'],
    uses: ['fresh', 'fruit salad', 'dessert']
  },
  {
    id: 'piel-de sapo-casaba',
    name: 'Piel de sapo - Casaba',
    scientificName: 'Cucumis melo var. inodorus',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Casaba piel de sapo. Toad skin, white sweet flesh.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Casaba'],
    uses: ['fresh', 'fruit salad', 'dessert']
  },
  {
    id: 'bitter-melon-winter',
    name: 'Bitter melon - Winter',
    scientificName: 'Momordica charantia',
    category: 'cucurbit',
    spacing: 48,
    rowSpacing: 72,
    daysToGermination: 7,
    daysToHarvest: 70,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Winter bitter melon. Bumpy green, used in Asian cuisine.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '10-12 feet',
    family: 'Cucurbitaceae',
    varieties: ['Winter'],
    uses: ['stir fry', 'curry', 'medicinal']
  },
  {
    id: 'winter-melon-santa-claus',
    name: 'Winter melon - Santa Claus',
    scientificName: 'Benincasa hispida',
    category: 'cucurbit',
    spacing: 48,
    rowSpacing: 72,
    daysToGermination: 7,
    daysToHarvest: 110,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Santa Claus winter melon. Large waxy melon for soup and stew.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '10-12 feet',
    family: 'Benincaseae',
    varieties: ['Santa Claus'],
    uses: ['soup', 'stew', 'braising']
  },
  {
    id: 'cantaloupe-piel-de-sapo',
    name: 'Cantaloupe - Piel de Sapo',
    scientificName: 'Cucumis melo var. cantalupensis',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Piel de Sapo cantaloupe. Classic muskmelon with netted skin.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Piel de Sapo'],
    uses: ['fresh', 'fruit salad', 'dessert']
  },
  {
    id: 'honeydew-toad-skin',
    name: 'Honeydew - Toad Skin',
    scientificName: 'Cucumis melo var. inodorus',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Toad Skin honeydew. Smooth pale skin, sweet green flesh.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Toad Skin'],
    uses: ['fresh', 'fruit salad', 'dessert']
  },
  {
    id: 'crenshaw-santa-claus',
    name: 'Crenshaw - Santa Claus',
    scientificName: 'Cucumis melo var. inodorus',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Santa Claus crenshaw. Hybrid with salmon-pink flesh.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Santa Claus'],
    uses: ['fresh', 'fruit salad', 'dessert']
  },
  {
    id: 'casaba-christmas',
    name: 'Casaba - Christmas',
    scientificName: 'Cucumis melo var. inodorus',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Christmas casaba. Wrinkled yellow skin, white flesh.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Christmas'],
    uses: ['fresh', 'fruit salad', 'dessert']
  },
  {
    id: 'persian-canary',
    name: 'Persian - Canary',
    scientificName: 'Cucumis melo var. reticulatus',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Canary persian. Oval with netted skin, very sweet.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Canary'],
    uses: ['fresh', 'fruit salad', 'dessert']
  },
  {
    id: 'canary-amarillo',
    name: 'Canary - Amarillo',
    scientificName: 'Cucumis melo var. inodorus',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Amarillo canary. Bright yellow, mild and sweet.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Amarillo'],
    uses: ['fresh', 'fruit salad', 'dessert']
  },
  {
    id: 'galia-juan-canary',
    name: 'Galia - Juan Canary',
    scientificName: 'Cucumis melo var. reticulatus',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Juan Canary galia. Netted green skin, spicy-sweet.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Juan Canary'],
    uses: ['fresh', 'fruit salad', 'dessert']
  },
  {
    id: 'piel-de sapo-yellow',
    name: 'Piel de sapo - Yellow',
    scientificName: 'Cucumis melo var. inodorus',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Yellow piel de sapo. Toad skin, white sweet flesh.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Yellow'],
    uses: ['fresh', 'fruit salad', 'dessert']
  },
  {
    id: 'bitter-melon-galia',
    name: 'Bitter melon - Galia',
    scientificName: 'Momordica charantia',
    category: 'cucurbit',
    spacing: 48,
    rowSpacing: 72,
    daysToGermination: 7,
    daysToHarvest: 70,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Galia bitter melon. Bumpy green, used in Asian cuisine.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '10-12 feet',
    family: 'Cucurbitaceae',
    varieties: ['Galia'],
    uses: ['stir fry', 'curry', 'medicinal']
  },
  {
    id: 'winter-melon-greek',
    name: 'Winter melon - Greek',
    scientificName: 'Benincasa hispida',
    category: 'cucurbit',
    spacing: 48,
    rowSpacing: 72,
    daysToGermination: 7,
    daysToHarvest: 110,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Greek winter melon. Large waxy melon for soup and stew.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '10-12 feet',
    family: 'Benincaseae',
    varieties: ['Greek'],
    uses: ['soup', 'stew', 'braising']
  },
  {
    id: 'cantaloupe-arava',
    name: 'Cantaloupe - Arava',
    scientificName: 'Cucumis melo var. cantalupensis',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Arava cantaloupe. Classic muskmelon with netted skin.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Arava'],
    uses: ['fresh', 'fruit salad', 'dessert']
  },
  {
    id: 'honeydew-diplomat',
    name: 'Honeydew - Diplomat',
    scientificName: 'Cucumis melo var. inodorus',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Diplomat honeydew. Smooth pale skin, sweet green flesh.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Diplomat'],
    uses: ['fresh', 'fruit salad', 'dessert']
  },
  {
    id: 'crenshaw-gallicum',
    name: 'Crenshaw - Gallicum',
    scientificName: 'Cucumis melo var. inodorus',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Gallicum crenshaw. Hybrid with salmon-pink flesh.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Gallicum'],
    uses: ['fresh', 'fruit salad', 'dessert']
  },
  {
    id: 'casaba-madonna',
    name: 'Casaba - Madonna',
    scientificName: 'Cucumis melo var. inodorus',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Madonna casaba. Wrinkled yellow skin, white flesh.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Madonna'],
    uses: ['fresh', 'fruit salad', 'dessert']
  },
  {
    id: 'persian-magnum',
    name: 'Persian - Magnum',
    scientificName: 'Cucumis melo var. reticulatus',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Magnum persian. Oval with netted skin, very sweet.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Magnum'],
    uses: ['fresh', 'fruit salad', 'dessert']
  },
  {
    id: 'canary-armenian',
    name: 'Canary - Armenian',
    scientificName: 'Cucumis melo var. inodorus',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Armenian canary. Bright yellow, mild and sweet.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Armenian'],
    uses: ['fresh', 'fruit salad', 'dessert']
  },
  {
    id: 'galia-snake',
    name: 'Galia - Snake',
    scientificName: 'Cucumis melo var. reticulatus',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Snake galia. Netted green skin, spicy-sweet.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Snake'],
    uses: ['fresh', 'fruit salad', 'dessert']
  },
  {
    id: 'piel-de sapo-yard-long',
    name: 'Piel de sapo - Yard Long',
    scientificName: 'Cucumis melo var. inodorus',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Yard Long piel de sapo. Toad skin, white sweet flesh.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Yard Long'],
    uses: ['fresh', 'fruit salad', 'dessert']
  },
  {
    id: 'bitter-melon-bitter',
    name: 'Bitter melon - Bitter',
    scientificName: 'Momordica charantia',
    category: 'cucurbit',
    spacing: 48,
    rowSpacing: 72,
    daysToGermination: 7,
    daysToHarvest: 70,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Bitter bitter melon. Bumpy green, used in Asian cuisine.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '10-12 feet',
    family: 'Cucurbitaceae',
    varieties: ['Bitter'],
    uses: ['stir fry', 'curry', 'medicinal']
  },
  {
    id: 'winter-melon-karela',
    name: 'Winter melon - Karela',
    scientificName: 'Benincasa hispida',
    category: 'cucurbit',
    spacing: 48,
    rowSpacing: 72,
    daysToGermination: 7,
    daysToHarvest: 110,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Karela winter melon. Large waxy melon for soup and stew.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '10-12 feet',
    family: 'Benincaseae',
    varieties: ['Karela'],
    uses: ['soup', 'stew', 'braising']
  },
  {
    id: 'cantaloupe-chinese',
    name: 'Cantaloupe - Chinese',
    scientificName: 'Cucumis melo var. cantalupensis',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Chinese cantaloupe. Classic muskmelon with netted skin.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Chinese'],
    uses: ['fresh', 'fruit salad', 'dessert']
  },
  {
    id: 'honeydew-indian',
    name: 'Honeydew - Indian',
    scientificName: 'Cucumis melo var. inodorus',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Indian honeydew. Smooth pale skin, sweet green flesh.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Indian'],
    uses: ['fresh', 'fruit salad', 'dessert']
  },
  {
    id: 'crenshaw-thai',
    name: 'Crenshaw - Thai',
    scientificName: 'Cucumis melo var. inodorus',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Thai crenshaw. Hybrid with salmon-pink flesh.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Thai'],
    uses: ['fresh', 'fruit salad', 'dessert']
  },
  {
    id: 'casaba-vietnamese',
    name: 'Casaba - Vietnamese',
    scientificName: 'Cucumis melo var. inodorus',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Vietnamese casaba. Wrinkled yellow skin, white flesh.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Vietnamese'],
    uses: ['fresh', 'fruit salad', 'dessert']
  },
  {
    id: 'persian-japanese',
    name: 'Persian - Japanese',
    scientificName: 'Cucumis melo var. reticulatus',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Japanese persian. Oval with netted skin, very sweet.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Japanese'],
    uses: ['fresh', 'fruit salad', 'dessert']
  },
  {
    id: 'canary-winter-melon',
    name: 'Canary - Winter Melon',
    scientificName: 'Cucumis melo var. inodorus',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Winter Melon canary. Bright yellow, mild and sweet.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Winter Melon'],
    uses: ['fresh', 'fruit salad', 'dessert']
  },
  {
    id: 'galia-wax-gourd',
    name: 'Galia - Wax Gourd',
    scientificName: 'Cucumis melo var. reticulatus',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Wax Gourd galia. Netted green skin, spicy-sweet.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Wax Gourd'],
    uses: ['fresh', 'fruit salad', 'dessert']
  },
  {
    id: 'piel-de sapo-ash-gourd',
    name: 'Piel de sapo - Ash Gourd',
    scientificName: 'Cucumis melo var. inodorus',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Ash Gourd piel de sapo. Toad skin, white sweet flesh.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Ash Gourd'],
    uses: ['fresh', 'fruit salad', 'dessert']
  },
  {
    id: 'bitter-melon-chinese-watermelon',
    name: 'Bitter melon - Chinese Watermelon',
    scientificName: 'Momordica charantia',
    category: 'cucurbit',
    spacing: 48,
    rowSpacing: 72,
    daysToGermination: 7,
    daysToHarvest: 70,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Chinese Watermelon bitter melon. Bumpy green, used in Asian cuisine.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '10-12 feet',
    family: 'Cucurbitaceae',
    varieties: ['Chinese Watermelon'],
    uses: ['stir fry', 'curry', 'medicinal']
  },
  {
    id: 'winter-melon-dong-gua',
    name: 'Winter melon - Dong Gua',
    scientificName: 'Benincasa hispida',
    category: 'cucurbit',
    spacing: 48,
    rowSpacing: 72,
    daysToGermination: 7,
    daysToHarvest: 110,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Dong Gua winter melon. Large waxy melon for soup and stew.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '10-12 feet',
    family: 'Benincaseae',
    varieties: ['Dong Gua'],
    uses: ['soup', 'stew', 'braising']
  },
  {
    id: 'cantaloupe-sugar',
    name: 'Cantaloupe - Sugar',
    scientificName: 'Cucumis melo var. cantalupensis',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Sugar cantaloupe. Classic muskmelon with netted skin.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Sugar'],
    uses: ['fresh', 'fruit salad', 'dessert']
  },
  {
    id: 'honeydew-sweet',
    name: 'Honeydew - Sweet',
    scientificName: 'Cucumis melo var. inodorus',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Sweet honeydew. Smooth pale skin, sweet green flesh.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Sweet'],
    uses: ['fresh', 'fruit salad', 'dessert']
  },
  {
    id: 'crenshaw-super-sweet',
    name: 'Crenshaw - Super Sweet',
    scientificName: 'Cucumis melo var. inodorus',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Super Sweet crenshaw. Hybrid with salmon-pink flesh.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Super Sweet'],
    uses: ['fresh', 'fruit salad', 'dessert']
  },
  {
    id: 'casaba-extra-sweet',
    name: 'Casaba - Extra Sweet',
    scientificName: 'Cucumis melo var. inodorus',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Extra Sweet casaba. Wrinkled yellow skin, white flesh.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Extra Sweet'],
    uses: ['fresh', 'fruit salad', 'dessert']
  },
  {
    id: 'persian-ultra-sweet',
    name: 'Persian - Ultra Sweet',
    scientificName: 'Cucumis melo var. reticulatus',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Ultra Sweet persian. Oval with netted skin, very sweet.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Ultra Sweet'],
    uses: ['fresh', 'fruit salad', 'dessert']
  },
  {
    id: 'canary-early',
    name: 'Canary - Early',
    scientificName: 'Cucumis melo var. inodorus',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Early canary. Bright yellow, mild and sweet.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Early'],
    uses: ['fresh', 'fruit salad', 'dessert']
  },
  {
    id: 'galia-main-season',
    name: 'Galia - Main Season',
    scientificName: 'Cucumis melo var. reticulatus',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Main Season galia. Netted green skin, spicy-sweet.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Main Season'],
    uses: ['fresh', 'fruit salad', 'dessert']
  },
  {
    id: 'piel-de sapo-late',
    name: 'Piel de sapo - Late',
    scientificName: 'Cucumis melo var. inodorus',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Late piel de sapo. Toad skin, white sweet flesh.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Late'],
    uses: ['fresh', 'fruit salad', 'dessert']
  },
  {
    id: 'bitter-melon-all-season',
    name: 'Bitter melon - All Season',
    scientificName: 'Momordica charantia',
    category: 'cucurbit',
    spacing: 48,
    rowSpacing: 72,
    daysToGermination: 7,
    daysToHarvest: 70,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'All Season bitter melon. Bumpy green, used in Asian cuisine.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '10-12 feet',
    family: 'Cucurbitaceae',
    varieties: ['All Season'],
    uses: ['stir fry', 'curry', 'medicinal']
  },
  {
    id: 'winter-melon-fall',
    name: 'Winter melon - Fall',
    scientificName: 'Benincasa hispida',
    category: 'cucurbit',
    spacing: 48,
    rowSpacing: 72,
    daysToGermination: 7,
    daysToHarvest: 110,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Fall winter melon. Large waxy melon for soup and stew.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '10-12 feet',
    family: 'Benincaseae',
    varieties: ['Fall'],
    uses: ['soup', 'stew', 'braising']
  },
  {
    id: 'cantaloupe-spring',
    name: 'Cantaloupe - Spring',
    scientificName: 'Cucumis melo var. cantalupensis',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Spring cantaloupe. Classic muskmelon with netted skin.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Spring'],
    uses: ['fresh', 'fruit salad', 'dessert']
  },
  {
    id: 'honeydew-summer',
    name: 'Honeydew - Summer',
    scientificName: 'Cucumis melo var. inodorus',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Summer honeydew. Smooth pale skin, sweet green flesh.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Summer'],
    uses: ['fresh', 'fruit salad', 'dessert']
  },
  {
    id: 'crenshaw-winter',
    name: 'Crenshaw - Winter',
    scientificName: 'Cucumis melo var. inodorus',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Winter crenshaw. Hybrid with salmon-pink flesh.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Winter'],
    uses: ['fresh', 'fruit salad', 'dessert']
  },
  {
    id: 'casaba-greenhouse',
    name: 'Casaba - Greenhouse',
    scientificName: 'Cucumis melo var. inodorus',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Greenhouse casaba. Wrinkled yellow skin, white flesh.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Greenhouse'],
    uses: ['fresh', 'fruit salad', 'dessert']
  },
  {
    id: 'persian-field',
    name: 'Persian - Field',
    scientificName: 'Cucumis melo var. reticulatus',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Field persian. Oval with netted skin, very sweet.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Field'],
    uses: ['fresh', 'fruit salad', 'dessert']
  },
  {
    id: 'canary-drought-tolerant',
    name: 'Canary - Drought Tolerant',
    scientificName: 'Cucumis melo var. inodorus',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Drought Tolerant canary. Bright yellow, mild and sweet.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Drought Tolerant'],
    uses: ['fresh', 'fruit salad', 'dessert']
  },
  {
    id: 'galia-heat-resistant',
    name: 'Galia - Heat Resistant',
    scientificName: 'Cucumis melo var. reticulatus',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Heat Resistant galia. Netted green skin, spicy-sweet.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Heat Resistant'],
    uses: ['fresh', 'fruit salad', 'dessert']
  },
  {
    id: 'piel-de sapo-disease-resistant',
    name: 'Piel de sapo - Disease Resistant',
    scientificName: 'Cucumis melo var. inodorus',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Disease Resistant piel de sapo. Toad skin, white sweet flesh.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Disease Resistant'],
    uses: ['fresh', 'fruit salad', 'dessert']
  },
  {
    id: 'bitter-melon-virus-resistant',
    name: 'Bitter melon - Virus Resistant',
    scientificName: 'Momordica charantia',
    category: 'cucurbit',
    spacing: 48,
    rowSpacing: 72,
    daysToGermination: 7,
    daysToHarvest: 70,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Virus Resistant bitter melon. Bumpy green, used in Asian cuisine.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '10-12 feet',
    family: 'Cucurbitaceae',
    varieties: ['Virus Resistant'],
    uses: ['stir fry', 'curry', 'medicinal']
  },
  {
    id: 'winter-melon-fusarium-resistant',
    name: 'Winter melon - Fusarium Resistant',
    scientificName: 'Benincasa hispida',
    category: 'cucurbit',
    spacing: 48,
    rowSpacing: 72,
    daysToGermination: 7,
    daysToHarvest: 110,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Fusarium Resistant winter melon. Large waxy melon for soup and stew.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '10-12 feet',
    family: 'Benincaseae',
    varieties: ['Fusarium Resistant'],
    uses: ['soup', 'stew', 'braising']
  },
  {
    id: 'cantaloupe-small',
    name: 'Cantaloupe - Small',
    scientificName: 'Cucumis melo var. cantalupensis',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Small cantaloupe. Classic muskmelon with netted skin.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Small'],
    uses: ['fresh', 'fruit salad', 'dessert']
  },
  {
    id: 'honeydew-medium',
    name: 'Honeydew - Medium',
    scientificName: 'Cucumis melo var. inodorus',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Medium honeydew. Smooth pale skin, sweet green flesh.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Medium'],
    uses: ['fresh', 'fruit salad', 'dessert']
  },
  {
    id: 'crenshaw-large',
    name: 'Crenshaw - Large',
    scientificName: 'Cucumis melo var. inodorus',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Large crenshaw. Hybrid with salmon-pink flesh.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Large'],
    uses: ['fresh', 'fruit salad', 'dessert']
  },
  {
    id: 'casaba-jumbo',
    name: 'Casaba - Jumbo',
    scientificName: 'Cucumis melo var. inodorus',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Jumbo casaba. Wrinkled yellow skin, white flesh.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Jumbo'],
    uses: ['fresh', 'fruit salad', 'dessert']
  },
  {
    id: 'persian-giant',
    name: 'Persian - Giant',
    scientificName: 'Cucumis melo var. reticulatus',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Giant persian. Oval with netted skin, very sweet.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Giant'],
    uses: ['fresh', 'fruit salad', 'dessert']
  },
  {
    id: 'canary-round',
    name: 'Canary - Round',
    scientificName: 'Cucumis melo var. inodorus',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Round canary. Bright yellow, mild and sweet.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Round'],
    uses: ['fresh', 'fruit salad', 'dessert']
  },
  {
    id: 'galia-oval',
    name: 'Galia - Oval',
    scientificName: 'Cucumis melo var. reticulatus',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Oval galia. Netted green skin, spicy-sweet.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Oval'],
    uses: ['fresh', 'fruit salad', 'dessert']
  },
  {
    id: 'piel-de sapo-elongated',
    name: 'Piel de sapo - Elongated',
    scientificName: 'Cucumis melo var. inodorus',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Elongated piel de sapo. Toad skin, white sweet flesh.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Elongated'],
    uses: ['fresh', 'fruit salad', 'dessert']
  },
  {
    id: 'bitter-melon-slip',
    name: 'Bitter melon - Slip',
    scientificName: 'Momordica charantia',
    category: 'cucurbit',
    spacing: 48,
    rowSpacing: 72,
    daysToGermination: 7,
    daysToHarvest: 70,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Slip bitter melon. Bumpy green, used in Asian cuisine.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '10-12 feet',
    family: 'Cucurbitaceae',
    varieties: ['Slip'],
    uses: ['stir fry', 'curry', 'medicinal']
  },
  {
    id: 'winter-melon-non-slip',
    name: 'Winter melon - Non-Slip',
    scientificName: 'Benincasa hispida',
    category: 'cucurbit',
    spacing: 48,
    rowSpacing: 72,
    daysToGermination: 7,
    daysToHarvest: 110,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Non-Slip winter melon. Large waxy melon for soup and stew.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '10-12 feet',
    family: 'Benincaseae',
    varieties: ['Non-Slip'],
    uses: ['soup', 'stew', 'braising']
  },
  {
    id: 'cantaloupe-netted',
    name: 'Cantaloupe - Netted',
    scientificName: 'Cucumis melo var. cantalupensis',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Netted cantaloupe. Classic muskmelon with netted skin.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Netted'],
    uses: ['fresh', 'fruit salad', 'dessert']
  },
  {
    id: 'honeydew-smooth',
    name: 'Honeydew - Smooth',
    scientificName: 'Cucumis melo var. inodorus',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Smooth honeydew. Smooth pale skin, sweet green flesh.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Smooth'],
    uses: ['fresh', 'fruit salad', 'dessert']
  },
  {
    id: 'crenshaw-ribbed',
    name: 'Crenshaw - Ribbed',
    scientificName: 'Cucumis melo var. inodorus',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Ribbed crenshaw. Hybrid with salmon-pink flesh.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Ribbed'],
    uses: ['fresh', 'fruit salad', 'dessert']
  },
  {
    id: 'casaba-sutured',
    name: 'Casaba - Sutured',
    scientificName: 'Cucumis melo var. inodorus',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Sutured casaba. Wrinkled yellow skin, white flesh.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Sutured'],
    uses: ['fresh', 'fruit salad', 'dessert']
  },
  {
    id: 'persian-veined',
    name: 'Persian - Veined',
    scientificName: 'Cucumis melo var. reticulatus',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Veined persian. Oval with netted skin, very sweet.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Veined'],
    uses: ['fresh', 'fruit salad', 'dessert']
  },
  {
    id: 'canary-orange',
    name: 'Canary - Orange',
    scientificName: 'Cucumis melo var. inodorus',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Orange canary. Bright yellow, mild and sweet.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Orange'],
    uses: ['fresh', 'fruit salad', 'dessert']
  },
  {
    id: 'galia-green',
    name: 'Galia - Green',
    scientificName: 'Cucumis melo var. reticulatus',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Green galia. Netted green skin, spicy-sweet.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Green'],
    uses: ['fresh', 'fruit salad', 'dessert']
  },
  {
    id: 'piel-de sapo-white',
    name: 'Piel de sapo - White',
    scientificName: 'Cucumis melo var. inodorus',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'White piel de sapo. Toad skin, white sweet flesh.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['White'],
    uses: ['fresh', 'fruit salad', 'dessert']
  },
  {
    id: 'bitter-melon-yellow',
    name: 'Bitter melon - Yellow',
    scientificName: 'Momordica charantia',
    category: 'cucurbit',
    spacing: 48,
    rowSpacing: 72,
    daysToGermination: 7,
    daysToHarvest: 70,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Yellow bitter melon. Bumpy green, used in Asian cuisine.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '10-12 feet',
    family: 'Cucurbitaceae',
    varieties: ['Yellow'],
    uses: ['stir fry', 'curry', 'medicinal']
  },
  {
    id: 'winter-melon-gold',
    name: 'Winter melon - Gold',
    scientificName: 'Benincasa hispida',
    category: 'cucurbit',
    spacing: 48,
    rowSpacing: 72,
    daysToGermination: 7,
    daysToHarvest: 110,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Gold winter melon. Large waxy melon for soup and stew.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '10-12 feet',
    family: 'Benincaseae',
    varieties: ['Gold'],
    uses: ['soup', 'stew', 'braising']
  },
  {
    id: 'cantaloupe-red',
    name: 'Cantaloupe - Red',
    scientificName: 'Cucumis melo var. cantalupensis',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Red cantaloupe. Classic muskmelon with netted skin.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Red'],
    uses: ['fresh', 'fruit salad', 'dessert']
  },
  {
    id: 'honeydew-pink',
    name: 'Honeydew - Pink',
    scientificName: 'Cucumis melo var. inodorus',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Pink honeydew. Smooth pale skin, sweet green flesh.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Pink'],
    uses: ['fresh', 'fruit salad', 'dessert']
  },
  {
    id: 'crenshaw-salmon',
    name: 'Crenshaw - Salmon',
    scientificName: 'Cucumis melo var. inodorus',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Salmon crenshaw. Hybrid with salmon-pink flesh.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Salmon'],
    uses: ['fresh', 'fruit salad', 'dessert']
  },
  {
    id: 'casaba-apricot',
    name: 'Casaba - Apricot',
    scientificName: 'Cucumis melo var. inodorus',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Apricot casaba. Wrinkled yellow skin, white flesh.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Apricot'],
    uses: ['fresh', 'fruit salad', 'dessert']
  },
  {
    id: 'persian-cream',
    name: 'Persian - Cream',
    scientificName: 'Cucumis melo var. reticulatus',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Cream persian. Oval with netted skin, very sweet.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Cream'],
    uses: ['fresh', 'fruit salad', 'dessert']
  },
  {
    id: 'canary-organic',
    name: 'Canary - Organic',
    scientificName: 'Cucumis melo var. inodorus',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Organic canary. Bright yellow, mild and sweet.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Organic'],
    uses: ['fresh', 'fruit salad', 'dessert']
  },
  {
    id: 'galia-heirloom',
    name: 'Galia - Heirloom',
    scientificName: 'Cucumis melo var. reticulatus',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Heirloom galia. Netted green skin, spicy-sweet.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Heirloom'],
    uses: ['fresh', 'fruit salad', 'dessert']
  },
  {
    id: 'piel-de sapo-hybrid',
    name: 'Piel de sapo - Hybrid',
    scientificName: 'Cucumis melo var. inodorus',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Hybrid piel de sapo. Toad skin, white sweet flesh.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Hybrid'],
    uses: ['fresh', 'fruit salad', 'dessert']
  },
  {
    id: 'bitter-melon-f1',
    name: 'Bitter melon - F1',
    scientificName: 'Momordica charantia',
    category: 'cucurbit',
    spacing: 48,
    rowSpacing: 72,
    daysToGermination: 7,
    daysToHarvest: 70,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'F1 bitter melon. Bumpy green, used in Asian cuisine.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '10-12 feet',
    family: 'Cucurbitaceae',
    varieties: ['F1'],
    uses: ['stir fry', 'curry', 'medicinal']
  },
  {
    id: 'winter-melon-open-pollinated',
    name: 'Winter melon - Open Pollinated',
    scientificName: 'Benincasa hispida',
    category: 'cucurbit',
    spacing: 48,
    rowSpacing: 72,
    daysToGermination: 7,
    daysToHarvest: 110,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Open Pollinated winter melon. Large waxy melon for soup and stew.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '10-12 feet',
    family: 'Benincaseae',
    varieties: ['Open Pollinated'],
    uses: ['soup', 'stew', 'braising']
  },
  {
    id: 'cantaloupe-hales-best-2',
    name: 'Cantaloupe - Hales Best 2',
    scientificName: 'Cucumis melo var. cantalupensis',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Hales Best 2 cantaloupe. Classic muskmelon with netted skin.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Hales Best 2'],
    uses: ['fresh', 'fruit salad', 'dessert']
  },
  {
    id: 'honeydew-ambrosia-2',
    name: 'Honeydew - Ambrosia 2',
    scientificName: 'Cucumis melo var. inodorus',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Ambrosia 2 honeydew. Smooth pale skin, sweet green flesh.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Ambrosia 2'],
    uses: ['fresh', 'fruit salad', 'dessert']
  },
  {
    id: 'crenshaw-athena-2',
    name: 'Crenshaw - Athena 2',
    scientificName: 'Cucumis melo var. inodorus',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Athena 2 crenshaw. Hybrid with salmon-pink flesh.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Athena 2'],
    uses: ['fresh', 'fruit salad', 'dessert']
  },
  {
    id: 'casaba-sarahs-choice-2',
    name: 'Casaba - Sarahs Choice 2',
    scientificName: 'Cucumis melo var. inodorus',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Sarahs Choice 2 casaba. Wrinkled yellow skin, white flesh.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Sarahs Choice 2'],
    uses: ['fresh', 'fruit salad', 'dessert']
  },
  {
    id: 'persian-sugar-cube-2',
    name: 'Persian - Sugar Cube 2',
    scientificName: 'Cucumis melo var. reticulatus',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Sugar Cube 2 persian. Oval with netted skin, very sweet.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Sugar Cube 2'],
    uses: ['fresh', 'fruit salad', 'dessert']
  },
  {
    id: 'canary-minnesota-midget-2',
    name: 'Canary - Minnesota Midget 2',
    scientificName: 'Cucumis melo var. inodorus',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Minnesota Midget 2 canary. Bright yellow, mild and sweet.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Minnesota Midget 2'],
    uses: ['fresh', 'fruit salad', 'dessert']
  },
  {
    id: 'galia-hearts-of-gold-2',
    name: 'Galia - Hearts of Gold 2',
    scientificName: 'Cucumis melo var. reticulatus',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Hearts of Gold 2 galia. Netted green skin, spicy-sweet.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Hearts of Gold 2'],
    uses: ['fresh', 'fruit salad', 'dessert']
  },
  {
    id: 'piel-de sapo-pmr-45-2',
    name: 'Piel de sapo - PMR 45 2',
    scientificName: 'Cucumis melo var. inodorus',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'PMR 45 2 piel de sapo. Toad skin, white sweet flesh.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['PMR 45 2'],
    uses: ['fresh', 'fruit salad', 'dessert']
  },
  {
    id: 'bitter-melon-savor-2',
    name: 'Bitter melon - Savor 2',
    scientificName: 'Momordica charantia',
    category: 'cucurbit',
    spacing: 48,
    rowSpacing: 72,
    daysToGermination: 7,
    daysToHarvest: 70,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Savor 2 bitter melon. Bumpy green, used in Asian cuisine.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '10-12 feet',
    family: 'Cucurbitaceae',
    varieties: ['Savor 2'],
    uses: ['stir fry', 'curry', 'medicinal']
  },
  {
    id: 'winter-melon-tasty-bites-2',
    name: 'Winter melon - Tasty Bites 2',
    scientificName: 'Benincasa hispida',
    category: 'cucurbit',
    spacing: 48,
    rowSpacing: 72,
    daysToGermination: 7,
    daysToHarvest: 110,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Tasty Bites 2 winter melon. Large waxy melon for soup and stew.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '10-12 feet',
    family: 'Benincaseae',
    varieties: ['Tasty Bites 2'],
    uses: ['soup', 'stew', 'braising']
  },
  {
    id: 'cantaloupe-green-flesh-2',
    name: 'Cantaloupe - Green Flesh 2',
    scientificName: 'Cucumis melo var. cantalupensis',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Green Flesh 2 cantaloupe. Classic muskmelon with netted skin.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Green Flesh 2'],
    uses: ['fresh', 'fruit salad', 'dessert']
  },
  {
    id: 'honeydew-orange-flesh-2',
    name: 'Honeydew - Orange Flesh 2',
    scientificName: 'Cucumis melo var. inodorus',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Orange Flesh 2 honeydew. Smooth pale skin, sweet green flesh.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Orange Flesh 2'],
    uses: ['fresh', 'fruit salad', 'dessert']
  },
  {
    id: 'crenshaw-honey-dew-2',
    name: 'Crenshaw - Honey Dew 2',
    scientificName: 'Cucumis melo var. inodorus',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Honey Dew 2 crenshaw. Hybrid with salmon-pink flesh.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Honey Dew 2'],
    uses: ['fresh', 'fruit salad', 'dessert']
  },
  {
    id: 'casaba-honey-orange-2',
    name: 'Casaba - Honey Orange 2',
    scientificName: 'Cucumis melo var. inodorus',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Honey Orange 2 casaba. Wrinkled yellow skin, white flesh.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Honey Orange 2'],
    uses: ['fresh', 'fruit salad', 'dessert']
  },
  {
    id: 'persian-temptation-2',
    name: 'Persian - Temptation 2',
    scientificName: 'Cucumis melo var. reticulatus',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Temptation 2 persian. Oval with netted skin, very sweet.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Temptation 2'],
    uses: ['fresh', 'fruit salad', 'dessert']
  },
  {
    id: 'canary-passport-2',
    name: 'Canary - Passport 2',
    scientificName: 'Cucumis melo var. inodorus',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Passport 2 canary. Bright yellow, mild and sweet.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Passport 2'],
    uses: ['fresh', 'fruit salad', 'dessert']
  },
  {
    id: 'galia-earli-dew-2',
    name: 'Galia - Earli-Dew 2',
    scientificName: 'Cucumis melo var. reticulatus',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Earli-Dew 2 galia. Netted green skin, spicy-sweet.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Earli-Dew 2'],
    uses: ['fresh', 'fruit salad', 'dessert']
  },
  {
    id: 'piel-de sapo-honey-white-2',
    name: 'Piel de sapo - Honey White 2',
    scientificName: 'Cucumis melo var. inodorus',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Honey White 2 piel de sapo. Toad skin, white sweet flesh.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Honey White 2'],
    uses: ['fresh', 'fruit salad', 'dessert']
  },
  {
    id: 'bitter-melon-honey-yellow-2',
    name: 'Bitter melon - Honey Yellow 2',
    scientificName: 'Momordica charantia',
    category: 'cucurbit',
    spacing: 48,
    rowSpacing: 72,
    daysToGermination: 7,
    daysToHarvest: 70,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Honey Yellow 2 bitter melon. Bumpy green, used in Asian cuisine.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '10-12 feet',
    family: 'Cucurbitaceae',
    varieties: ['Honey Yellow 2'],
    uses: ['stir fry', 'curry', 'medicinal']
  },
  {
    id: 'winter-melon-honey-gold-2',
    name: 'Winter melon - Honey Gold 2',
    scientificName: 'Benincasa hispida',
    category: 'cucurbit',
    spacing: 48,
    rowSpacing: 72,
    daysToGermination: 7,
    daysToHarvest: 110,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Honey Gold 2 winter melon. Large waxy melon for soup and stew.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '10-12 feet',
    family: 'Benincaseae',
    varieties: ['Honey Gold 2'],
    uses: ['soup', 'stew', 'braising']
  },
  {
    id: 'cantaloupe-early-crenshaw-2',
    name: 'Cantaloupe - Early Crenshaw 2',
    scientificName: 'Cucumis melo var. cantalupensis',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Early Crenshaw 2 cantaloupe. Classic muskmelon with netted skin.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Early Crenshaw 2'],
    uses: ['fresh', 'fruit salad', 'dessert']
  },
  {
    id: 'honeydew-crimson-sweet-2',
    name: 'Honeydew - Crimson Sweet 2',
    scientificName: 'Cucumis melo var. inodorus',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Crimson Sweet 2 honeydew. Smooth pale skin, sweet green flesh.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Crimson Sweet 2'],
    uses: ['fresh', 'fruit salad', 'dessert']
  },
  {
    id: 'crenshaw-large-2',
    name: 'Crenshaw - Large 2',
    scientificName: 'Cucumis melo var. inodorus',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Large 2 crenshaw. Hybrid with salmon-pink flesh.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Large 2'],
    uses: ['fresh', 'fruit salad', 'dessert']
  },
  {
    id: 'casaba-imperial-2',
    name: 'Casaba - Imperial 2',
    scientificName: 'Cucumis melo var. inodorus',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Imperial 2 casaba. Wrinkled yellow skin, white flesh.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Imperial 2'],
    uses: ['fresh', 'fruit salad', 'dessert']
  },
  {
    id: 'persian-hybrid-2',
    name: 'Persian - Hybrid 2',
    scientificName: 'Cucumis melo var. reticulatus',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Hybrid 2 persian. Oval with netted skin, very sweet.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Hybrid 2'],
    uses: ['fresh', 'fruit salad', 'dessert']
  },
  {
    id: 'canary-golden-beauty-2',
    name: 'Canary - Golden Beauty 2',
    scientificName: 'Cucumis melo var. inodorus',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Golden Beauty 2 canary. Bright yellow, mild and sweet.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Golden Beauty 2'],
    uses: ['fresh', 'fruit salad', 'dessert']
  },
  {
    id: 'galia-snowball-2',
    name: 'Galia - Snowball 2',
    scientificName: 'Cucumis melo var. reticulatus',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Snowball 2 galia. Netted green skin, spicy-sweet.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Snowball 2'],
    uses: ['fresh', 'fruit salad', 'dessert']
  },
  {
    id: 'piel-de sapo-casaba-2',
    name: 'Piel de sapo - Casaba 2',
    scientificName: 'Cucumis melo var. inodorus',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Casaba 2 piel de sapo. Toad skin, white sweet flesh.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Casaba 2'],
    uses: ['fresh', 'fruit salad', 'dessert']
  },
  {
    id: 'bitter-melon-winter-2',
    name: 'Bitter melon - Winter 2',
    scientificName: 'Momordica charantia',
    category: 'cucurbit',
    spacing: 48,
    rowSpacing: 72,
    daysToGermination: 7,
    daysToHarvest: 70,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Winter 2 bitter melon. Bumpy green, used in Asian cuisine.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '10-12 feet',
    family: 'Cucurbitaceae',
    varieties: ['Winter 2'],
    uses: ['stir fry', 'curry', 'medicinal']
  },
  {
    id: 'winter-melon-santa-claus-2',
    name: 'Winter melon - Santa Claus 2',
    scientificName: 'Benincasa hispida',
    category: 'cucurbit',
    spacing: 48,
    rowSpacing: 72,
    daysToGermination: 7,
    daysToHarvest: 110,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Santa Claus 2 winter melon. Large waxy melon for soup and stew.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '10-12 feet',
    family: 'Benincaseae',
    varieties: ['Santa Claus 2'],
    uses: ['soup', 'stew', 'braising']
  },
  {
    id: 'cantaloupe-piel-de-sapo-2',
    name: 'Cantaloupe - Piel de Sapo 2',
    scientificName: 'Cucumis melo var. cantalupensis',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Piel de Sapo 2 cantaloupe. Classic muskmelon with netted skin.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Piel de Sapo 2'],
    uses: ['fresh', 'fruit salad', 'dessert']
  },
  {
    id: 'honeydew-toad-skin-2',
    name: 'Honeydew - Toad Skin 2',
    scientificName: 'Cucumis melo var. inodorus',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Toad Skin 2 honeydew. Smooth pale skin, sweet green flesh.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Toad Skin 2'],
    uses: ['fresh', 'fruit salad', 'dessert']
  },
  {
    id: 'crenshaw-santa-claus-2',
    name: 'Crenshaw - Santa Claus 2',
    scientificName: 'Cucumis melo var. inodorus',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Santa Claus 2 crenshaw. Hybrid with salmon-pink flesh.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Santa Claus 2'],
    uses: ['fresh', 'fruit salad', 'dessert']
  },
  {
    id: 'casaba-christmas-2',
    name: 'Casaba - Christmas 2',
    scientificName: 'Cucumis melo var. inodorus',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Christmas 2 casaba. Wrinkled yellow skin, white flesh.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Christmas 2'],
    uses: ['fresh', 'fruit salad', 'dessert']
  },
  {
    id: 'persian-canary-2',
    name: 'Persian - Canary 2',
    scientificName: 'Cucumis melo var. reticulatus',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Canary 2 persian. Oval with netted skin, very sweet.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Canary 2'],
    uses: ['fresh', 'fruit salad', 'dessert']
  },
  {
    id: 'canary-amarillo-2',
    name: 'Canary - Amarillo 2',
    scientificName: 'Cucumis melo var. inodorus',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Amarillo 2 canary. Bright yellow, mild and sweet.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Amarillo 2'],
    uses: ['fresh', 'fruit salad', 'dessert']
  },
  {
    id: 'galia-juan-canary-2',
    name: 'Galia - Juan Canary 2',
    scientificName: 'Cucumis melo var. reticulatus',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Juan Canary 2 galia. Netted green skin, spicy-sweet.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Juan Canary 2'],
    uses: ['fresh', 'fruit salad', 'dessert']
  },
  {
    id: 'piel-de sapo-yellow-2',
    name: 'Piel de sapo - Yellow 2',
    scientificName: 'Cucumis melo var. inodorus',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Yellow 2 piel de sapo. Toad skin, white sweet flesh.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Yellow 2'],
    uses: ['fresh', 'fruit salad', 'dessert']
  },
  {
    id: 'bitter-melon-galia-2',
    name: 'Bitter melon - Galia 2',
    scientificName: 'Momordica charantia',
    category: 'cucurbit',
    spacing: 48,
    rowSpacing: 72,
    daysToGermination: 7,
    daysToHarvest: 70,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Galia 2 bitter melon. Bumpy green, used in Asian cuisine.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '10-12 feet',
    family: 'Cucurbitaceae',
    varieties: ['Galia 2'],
    uses: ['stir fry', 'curry', 'medicinal']
  },
  {
    id: 'winter-melon-greek-2',
    name: 'Winter melon - Greek 2',
    scientificName: 'Benincasa hispida',
    category: 'cucurbit',
    spacing: 48,
    rowSpacing: 72,
    daysToGermination: 7,
    daysToHarvest: 110,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Greek 2 winter melon. Large waxy melon for soup and stew.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '10-12 feet',
    family: 'Benincaseae',
    varieties: ['Greek 2'],
    uses: ['soup', 'stew', 'braising']
  },
  {
    id: 'cantaloupe-arava-2',
    name: 'Cantaloupe - Arava 2',
    scientificName: 'Cucumis melo var. cantalupensis',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Arava 2 cantaloupe. Classic muskmelon with netted skin.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Arava 2'],
    uses: ['fresh', 'fruit salad', 'dessert']
  },
  {
    id: 'honeydew-diplomat-2',
    name: 'Honeydew - Diplomat 2',
    scientificName: 'Cucumis melo var. inodorus',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Diplomat 2 honeydew. Smooth pale skin, sweet green flesh.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Diplomat 2'],
    uses: ['fresh', 'fruit salad', 'dessert']
  },
  {
    id: 'crenshaw-gallicum-2',
    name: 'Crenshaw - Gallicum 2',
    scientificName: 'Cucumis melo var. inodorus',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Gallicum 2 crenshaw. Hybrid with salmon-pink flesh.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Gallicum 2'],
    uses: ['fresh', 'fruit salad', 'dessert']
  },
  {
    id: 'casaba-madonna-2',
    name: 'Casaba - Madonna 2',
    scientificName: 'Cucumis melo var. inodorus',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Madonna 2 casaba. Wrinkled yellow skin, white flesh.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Madonna 2'],
    uses: ['fresh', 'fruit salad', 'dessert']
  },
  {
    id: 'persian-magnum-2',
    name: 'Persian - Magnum 2',
    scientificName: 'Cucumis melo var. reticulatus',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Magnum 2 persian. Oval with netted skin, very sweet.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Magnum 2'],
    uses: ['fresh', 'fruit salad', 'dessert']
  },
  {
    id: 'canary-armenian-2',
    name: 'Canary - Armenian 2',
    scientificName: 'Cucumis melo var. inodorus',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Armenian 2 canary. Bright yellow, mild and sweet.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Armenian 2'],
    uses: ['fresh', 'fruit salad', 'dessert']
  },
  {
    id: 'galia-snake-2',
    name: 'Galia - Snake 2',
    scientificName: 'Cucumis melo var. reticulatus',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Snake 2 galia. Netted green skin, spicy-sweet.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Snake 2'],
    uses: ['fresh', 'fruit salad', 'dessert']
  },
  {
    id: 'piel-de sapo-yard-long-2',
    name: 'Piel de sapo - Yard Long 2',
    scientificName: 'Cucumis melo var. inodorus',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Yard Long 2 piel de sapo. Toad skin, white sweet flesh.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Yard Long 2'],
    uses: ['fresh', 'fruit salad', 'dessert']
  },
  {
    id: 'bitter-melon-bitter-2',
    name: 'Bitter melon - Bitter 2',
    scientificName: 'Momordica charantia',
    category: 'cucurbit',
    spacing: 48,
    rowSpacing: 72,
    daysToGermination: 7,
    daysToHarvest: 70,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Bitter 2 bitter melon. Bumpy green, used in Asian cuisine.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '10-12 feet',
    family: 'Cucurbitaceae',
    varieties: ['Bitter 2'],
    uses: ['stir fry', 'curry', 'medicinal']
  },
  {
    id: 'winter-melon-karela-2',
    name: 'Winter melon - Karela 2',
    scientificName: 'Benincasa hispida',
    category: 'cucurbit',
    spacing: 48,
    rowSpacing: 72,
    daysToGermination: 7,
    daysToHarvest: 110,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Karela 2 winter melon. Large waxy melon for soup and stew.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '10-12 feet',
    family: 'Benincaseae',
    varieties: ['Karela 2'],
    uses: ['soup', 'stew', 'braising']
  },
  {
    id: 'cantaloupe-chinese-2',
    name: 'Cantaloupe - Chinese 2',
    scientificName: 'Cucumis melo var. cantalupensis',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Chinese 2 cantaloupe. Classic muskmelon with netted skin.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Chinese 2'],
    uses: ['fresh', 'fruit salad', 'dessert']
  },
  {
    id: 'honeydew-indian-2',
    name: 'Honeydew - Indian 2',
    scientificName: 'Cucumis melo var. inodorus',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Indian 2 honeydew. Smooth pale skin, sweet green flesh.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Indian 2'],
    uses: ['fresh', 'fruit salad', 'dessert']
  },
  {
    id: 'crenshaw-thai-2',
    name: 'Crenshaw - Thai 2',
    scientificName: 'Cucumis melo var. inodorus',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Thai 2 crenshaw. Hybrid with salmon-pink flesh.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Thai 2'],
    uses: ['fresh', 'fruit salad', 'dessert']
  },
  {
    id: 'casaba-vietnamese-2',
    name: 'Casaba - Vietnamese 2',
    scientificName: 'Cucumis melo var. inodorus',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Vietnamese 2 casaba. Wrinkled yellow skin, white flesh.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Vietnamese 2'],
    uses: ['fresh', 'fruit salad', 'dessert']
  },
  {
    id: 'persian-japanese-2',
    name: 'Persian - Japanese 2',
    scientificName: 'Cucumis melo var. reticulatus',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Japanese 2 persian. Oval with netted skin, very sweet.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Japanese 2'],
    uses: ['fresh', 'fruit salad', 'dessert']
  },
  {
    id: 'canary-winter-melon-2',
    name: 'Canary - Winter Melon 2',
    scientificName: 'Cucumis melo var. inodorus',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Winter Melon 2 canary. Bright yellow, mild and sweet.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Winter Melon 2'],
    uses: ['fresh', 'fruit salad', 'dessert']
  },
  {
    id: 'galia-wax-gourd-2',
    name: 'Galia - Wax Gourd 2',
    scientificName: 'Cucumis melo var. reticulatus',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Wax Gourd 2 galia. Netted green skin, spicy-sweet.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Wax Gourd 2'],
    uses: ['fresh', 'fruit salad', 'dessert']
  },
  {
    id: 'piel-de sapo-ash-gourd-2',
    name: 'Piel de sapo - Ash Gourd 2',
    scientificName: 'Cucumis melo var. inodorus',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Ash Gourd 2 piel de sapo. Toad skin, white sweet flesh.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Ash Gourd 2'],
    uses: ['fresh', 'fruit salad', 'dessert']
  },
  {
    id: 'bitter-melon-chinese-watermelon-2',
    name: 'Bitter melon - Chinese Watermelon 2',
    scientificName: 'Momordica charantia',
    category: 'cucurbit',
    spacing: 48,
    rowSpacing: 72,
    daysToGermination: 7,
    daysToHarvest: 70,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Chinese Watermelon 2 bitter melon. Bumpy green, used in Asian cuisine.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '10-12 feet',
    family: 'Cucurbitaceae',
    varieties: ['Chinese Watermelon 2'],
    uses: ['stir fry', 'curry', 'medicinal']
  },
  {
    id: 'winter-melon-dong-gua-2',
    name: 'Winter melon - Dong Gua 2',
    scientificName: 'Benincasa hispida',
    category: 'cucurbit',
    spacing: 48,
    rowSpacing: 72,
    daysToGermination: 7,
    daysToHarvest: 110,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Dong Gua 2 winter melon. Large waxy melon for soup and stew.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '10-12 feet',
    family: 'Benincaseae',
    varieties: ['Dong Gua 2'],
    uses: ['soup', 'stew', 'braising']
  },
  {
    id: 'cantaloupe-sugar-2',
    name: 'Cantaloupe - Sugar 2',
    scientificName: 'Cucumis melo var. cantalupensis',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Sugar 2 cantaloupe. Classic muskmelon with netted skin.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Sugar 2'],
    uses: ['fresh', 'fruit salad', 'dessert']
  },
  {
    id: 'honeydew-sweet-2',
    name: 'Honeydew - Sweet 2',
    scientificName: 'Cucumis melo var. inodorus',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Sweet 2 honeydew. Smooth pale skin, sweet green flesh.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Sweet 2'],
    uses: ['fresh', 'fruit salad', 'dessert']
  },
  {
    id: 'crenshaw-super-sweet-2',
    name: 'Crenshaw - Super Sweet 2',
    scientificName: 'Cucumis melo var. inodorus',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Super Sweet 2 crenshaw. Hybrid with salmon-pink flesh.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Super Sweet 2'],
    uses: ['fresh', 'fruit salad', 'dessert']
  },
  {
    id: 'casaba-extra-sweet-2',
    name: 'Casaba - Extra Sweet 2',
    scientificName: 'Cucumis melo var. inodorus',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Extra Sweet 2 casaba. Wrinkled yellow skin, white flesh.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Extra Sweet 2'],
    uses: ['fresh', 'fruit salad', 'dessert']
  },
  {
    id: 'persian-ultra-sweet-2',
    name: 'Persian - Ultra Sweet 2',
    scientificName: 'Cucumis melo var. reticulatus',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Ultra Sweet 2 persian. Oval with netted skin, very sweet.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Ultra Sweet 2'],
    uses: ['fresh', 'fruit salad', 'dessert']
  },
  {
    id: 'canary-early-2',
    name: 'Canary - Early 2',
    scientificName: 'Cucumis melo var. inodorus',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Early 2 canary. Bright yellow, mild and sweet.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Early 2'],
    uses: ['fresh', 'fruit salad', 'dessert']
  },
  {
    id: 'galia-main-season-2',
    name: 'Galia - Main Season 2',
    scientificName: 'Cucumis melo var. reticulatus',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Main Season 2 galia. Netted green skin, spicy-sweet.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Main Season 2'],
    uses: ['fresh', 'fruit salad', 'dessert']
  },
  {
    id: 'piel-de sapo-late-2',
    name: 'Piel de sapo - Late 2',
    scientificName: 'Cucumis melo var. inodorus',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Late 2 piel de sapo. Toad skin, white sweet flesh.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Late 2'],
    uses: ['fresh', 'fruit salad', 'dessert']
  },
  {
    id: 'bitter-melon-all-season-2',
    name: 'Bitter melon - All Season 2',
    scientificName: 'Momordica charantia',
    category: 'cucurbit',
    spacing: 48,
    rowSpacing: 72,
    daysToGermination: 7,
    daysToHarvest: 70,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'All Season 2 bitter melon. Bumpy green, used in Asian cuisine.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '10-12 feet',
    family: 'Cucurbitaceae',
    varieties: ['All Season 2'],
    uses: ['stir fry', 'curry', 'medicinal']
  },
  {
    id: 'winter-melon-fall-2',
    name: 'Winter melon - Fall 2',
    scientificName: 'Benincasa hispida',
    category: 'cucurbit',
    spacing: 48,
    rowSpacing: 72,
    daysToGermination: 7,
    daysToHarvest: 110,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Fall 2 winter melon. Large waxy melon for soup and stew.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '10-12 feet',
    family: 'Benincaseae',
    varieties: ['Fall 2'],
    uses: ['soup', 'stew', 'braising']
  },
  {
    id: 'cantaloupe-spring-2',
    name: 'Cantaloupe - Spring 2',
    scientificName: 'Cucumis melo var. cantalupensis',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Spring 2 cantaloupe. Classic muskmelon with netted skin.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Spring 2'],
    uses: ['fresh', 'fruit salad', 'dessert']
  },
  {
    id: 'honeydew-summer-2',
    name: 'Honeydew - Summer 2',
    scientificName: 'Cucumis melo var. inodorus',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Summer 2 honeydew. Smooth pale skin, sweet green flesh.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Summer 2'],
    uses: ['fresh', 'fruit salad', 'dessert']
  },
  {
    id: 'crenshaw-winter-2',
    name: 'Crenshaw - Winter 2',
    scientificName: 'Cucumis melo var. inodorus',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Winter 2 crenshaw. Hybrid with salmon-pink flesh.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Winter 2'],
    uses: ['fresh', 'fruit salad', 'dessert']
  },
  {
    id: 'casaba-greenhouse-2',
    name: 'Casaba - Greenhouse 2',
    scientificName: 'Cucumis melo var. inodorus',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Greenhouse 2 casaba. Wrinkled yellow skin, white flesh.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Greenhouse 2'],
    uses: ['fresh', 'fruit salad', 'dessert']
  },
  {
    id: 'persian-field-2',
    name: 'Persian - Field 2',
    scientificName: 'Cucumis melo var. reticulatus',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Field 2 persian. Oval with netted skin, very sweet.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Field 2'],
    uses: ['fresh', 'fruit salad', 'dessert']
  },
  {
    id: 'canary-drought-tolerant-2',
    name: 'Canary - Drought Tolerant 2',
    scientificName: 'Cucumis melo var. inodorus',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Drought Tolerant 2 canary. Bright yellow, mild and sweet.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Drought Tolerant 2'],
    uses: ['fresh', 'fruit salad', 'dessert']
  },
  {
    id: 'galia-heat-resistant-2',
    name: 'Galia - Heat Resistant 2',
    scientificName: 'Cucumis melo var. reticulatus',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Heat Resistant 2 galia. Netted green skin, spicy-sweet.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Heat Resistant 2'],
    uses: ['fresh', 'fruit salad', 'dessert']
  },
  {
    id: 'piel-de sapo-disease-resistant-2',
    name: 'Piel de sapo - Disease Resistant 2',
    scientificName: 'Cucumis melo var. inodorus',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Disease Resistant 2 piel de sapo. Toad skin, white sweet flesh.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Disease Resistant 2'],
    uses: ['fresh', 'fruit salad', 'dessert']
  },
  {
    id: 'bitter-melon-virus-resistant-2',
    name: 'Bitter melon - Virus Resistant 2',
    scientificName: 'Momordica charantia',
    category: 'cucurbit',
    spacing: 48,
    rowSpacing: 72,
    daysToGermination: 7,
    daysToHarvest: 70,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Virus Resistant 2 bitter melon. Bumpy green, used in Asian cuisine.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '10-12 feet',
    family: 'Cucurbitaceae',
    varieties: ['Virus Resistant 2'],
    uses: ['stir fry', 'curry', 'medicinal']
  },
  {
    id: 'winter-melon-fusarium-resistant-2',
    name: 'Winter melon - Fusarium Resistant 2',
    scientificName: 'Benincasa hispida',
    category: 'cucurbit',
    spacing: 48,
    rowSpacing: 72,
    daysToGermination: 7,
    daysToHarvest: 110,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Fusarium Resistant 2 winter melon. Large waxy melon for soup and stew.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '10-12 feet',
    family: 'Benincaseae',
    varieties: ['Fusarium Resistant 2'],
    uses: ['soup', 'stew', 'braising']
  },
  {
    id: 'cantaloupe-small-2',
    name: 'Cantaloupe - Small 2',
    scientificName: 'Cucumis melo var. cantalupensis',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Small 2 cantaloupe. Classic muskmelon with netted skin.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Small 2'],
    uses: ['fresh', 'fruit salad', 'dessert']
  },
  {
    id: 'honeydew-medium-2',
    name: 'Honeydew - Medium 2',
    scientificName: 'Cucumis melo var. inodorus',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Medium 2 honeydew. Smooth pale skin, sweet green flesh.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Medium 2'],
    uses: ['fresh', 'fruit salad', 'dessert']
  },
  {
    id: 'crenshaw-large-2',
    name: 'Crenshaw - Large 2',
    scientificName: 'Cucumis melo var. inodorus',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Large 2 crenshaw. Hybrid with salmon-pink flesh.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Large 2'],
    uses: ['fresh', 'fruit salad', 'dessert']
  },
  {
    id: 'casaba-jumbo-2',
    name: 'Casaba - Jumbo 2',
    scientificName: 'Cucumis melo var. inodorus',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Jumbo 2 casaba. Wrinkled yellow skin, white flesh.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Jumbo 2'],
    uses: ['fresh', 'fruit salad', 'dessert']
  },
  {
    id: 'persian-giant-2',
    name: 'Persian - Giant 2',
    scientificName: 'Cucumis melo var. reticulatus',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Giant 2 persian. Oval with netted skin, very sweet.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Giant 2'],
    uses: ['fresh', 'fruit salad', 'dessert']
  },
  {
    id: 'canary-round-2',
    name: 'Canary - Round 2',
    scientificName: 'Cucumis melo var. inodorus',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Round 2 canary. Bright yellow, mild and sweet.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Round 2'],
    uses: ['fresh', 'fruit salad', 'dessert']
  },
  {
    id: 'galia-oval-2',
    name: 'Galia - Oval 2',
    scientificName: 'Cucumis melo var. reticulatus',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Oval 2 galia. Netted green skin, spicy-sweet.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Oval 2'],
    uses: ['fresh', 'fruit salad', 'dessert']
  },
  {
    id: 'piel-de sapo-elongated-2',
    name: 'Piel de sapo - Elongated 2',
    scientificName: 'Cucumis melo var. inodorus',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Elongated 2 piel de sapo. Toad skin, white sweet flesh.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Elongated 2'],
    uses: ['fresh', 'fruit salad', 'dessert']
  },
  {
    id: 'bitter-melon-slip-2',
    name: 'Bitter melon - Slip 2',
    scientificName: 'Momordica charantia',
    category: 'cucurbit',
    spacing: 48,
    rowSpacing: 72,
    daysToGermination: 7,
    daysToHarvest: 70,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Slip 2 bitter melon. Bumpy green, used in Asian cuisine.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '10-12 feet',
    family: 'Cucurbitaceae',
    varieties: ['Slip 2'],
    uses: ['stir fry', 'curry', 'medicinal']
  },
  {
    id: 'winter-melon-non-slip-2',
    name: 'Winter melon - Non-Slip 2',
    scientificName: 'Benincasa hispida',
    category: 'cucurbit',
    spacing: 48,
    rowSpacing: 72,
    daysToGermination: 7,
    daysToHarvest: 110,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Non-Slip 2 winter melon. Large waxy melon for soup and stew.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '10-12 feet',
    family: 'Benincaseae',
    varieties: ['Non-Slip 2'],
    uses: ['soup', 'stew', 'braising']
  },
  {
    id: 'cantaloupe-netted-2',
    name: 'Cantaloupe - Netted 2',
    scientificName: 'Cucumis melo var. cantalupensis',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Netted 2 cantaloupe. Classic muskmelon with netted skin.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Netted 2'],
    uses: ['fresh', 'fruit salad', 'dessert']
  },
  {
    id: 'honeydew-smooth-2',
    name: 'Honeydew - Smooth 2',
    scientificName: 'Cucumis melo var. inodorus',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Smooth 2 honeydew. Smooth pale skin, sweet green flesh.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Smooth 2'],
    uses: ['fresh', 'fruit salad', 'dessert']
  },
  {
    id: 'crenshaw-ribbed-2',
    name: 'Crenshaw - Ribbed 2',
    scientificName: 'Cucumis melo var. inodorus',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Ribbed 2 crenshaw. Hybrid with salmon-pink flesh.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Ribbed 2'],
    uses: ['fresh', 'fruit salad', 'dessert']
  },
  {
    id: 'casaba-sutured-2',
    name: 'Casaba - Sutured 2',
    scientificName: 'Cucumis melo var. inodorus',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Sutured 2 casaba. Wrinkled yellow skin, white flesh.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Sutured 2'],
    uses: ['fresh', 'fruit salad', 'dessert']
  },
  {
    id: 'persian-veined-2',
    name: 'Persian - Veined 2',
    scientificName: 'Cucumis melo var. reticulatus',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Veined 2 persian. Oval with netted skin, very sweet.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Veined 2'],
    uses: ['fresh', 'fruit salad', 'dessert']
  },
  {
    id: 'canary-orange-2',
    name: 'Canary - Orange 2',
    scientificName: 'Cucumis melo var. inodorus',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Orange 2 canary. Bright yellow, mild and sweet.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Orange 2'],
    uses: ['fresh', 'fruit salad', 'dessert']
  },
  {
    id: 'galia-green-2',
    name: 'Galia - Green 2',
    scientificName: 'Cucumis melo var. reticulatus',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Green 2 galia. Netted green skin, spicy-sweet.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Green 2'],
    uses: ['fresh', 'fruit salad', 'dessert']
  },
  {
    id: 'piel-de sapo-white-2',
    name: 'Piel de sapo - White 2',
    scientificName: 'Cucumis melo var. inodorus',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'White 2 piel de sapo. Toad skin, white sweet flesh.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['White 2'],
    uses: ['fresh', 'fruit salad', 'dessert']
  },
  {
    id: 'bitter-melon-yellow-2',
    name: 'Bitter melon - Yellow 2',
    scientificName: 'Momordica charantia',
    category: 'cucurbit',
    spacing: 48,
    rowSpacing: 72,
    daysToGermination: 7,
    daysToHarvest: 70,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Yellow 2 bitter melon. Bumpy green, used in Asian cuisine.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '10-12 feet',
    family: 'Cucurbitaceae',
    varieties: ['Yellow 2'],
    uses: ['stir fry', 'curry', 'medicinal']
  },
  {
    id: 'winter-melon-gold-2',
    name: 'Winter melon - Gold 2',
    scientificName: 'Benincasa hispida',
    category: 'cucurbit',
    spacing: 48,
    rowSpacing: 72,
    daysToGermination: 7,
    daysToHarvest: 110,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Gold 2 winter melon. Large waxy melon for soup and stew.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '10-12 feet',
    family: 'Benincaseae',
    varieties: ['Gold 2'],
    uses: ['soup', 'stew', 'braising']
  },
  {
    id: 'cantaloupe-red-2',
    name: 'Cantaloupe - Red 2',
    scientificName: 'Cucumis melo var. cantalupensis',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Red 2 cantaloupe. Classic muskmelon with netted skin.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Red 2'],
    uses: ['fresh', 'fruit salad', 'dessert']
  },
  {
    id: 'honeydew-pink-2',
    name: 'Honeydew - Pink 2',
    scientificName: 'Cucumis melo var. inodorus',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Pink 2 honeydew. Smooth pale skin, sweet green flesh.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Pink 2'],
    uses: ['fresh', 'fruit salad', 'dessert']
  },
  {
    id: 'crenshaw-salmon-2',
    name: 'Crenshaw - Salmon 2',
    scientificName: 'Cucumis melo var. inodorus',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Salmon 2 crenshaw. Hybrid with salmon-pink flesh.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Salmon 2'],
    uses: ['fresh', 'fruit salad', 'dessert']
  },
  {
    id: 'casaba-apricot-2',
    name: 'Casaba - Apricot 2',
    scientificName: 'Cucumis melo var. inodorus',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Apricot 2 casaba. Wrinkled yellow skin, white flesh.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Apricot 2'],
    uses: ['fresh', 'fruit salad', 'dessert']
  },
  {
    id: 'persian-cream-2',
    name: 'Persian - Cream 2',
    scientificName: 'Cucumis melo var. reticulatus',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Cream 2 persian. Oval with netted skin, very sweet.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Cream 2'],
    uses: ['fresh', 'fruit salad', 'dessert']
  },
  {
    id: 'canary-organic-2',
    name: 'Canary - Organic 2',
    scientificName: 'Cucumis melo var. inodorus',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Organic 2 canary. Bright yellow, mild and sweet.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Organic 2'],
    uses: ['fresh', 'fruit salad', 'dessert']
  },
  {
    id: 'galia-heirloom-2',
    name: 'Galia - Heirloom 2',
    scientificName: 'Cucumis melo var. reticulatus',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Heirloom 2 galia. Netted green skin, spicy-sweet.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Heirloom 2'],
    uses: ['fresh', 'fruit salad', 'dessert']
  },
  {
    id: 'piel-de sapo-hybrid-2',
    name: 'Piel de sapo - Hybrid 2',
    scientificName: 'Cucumis melo var. inodorus',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Hybrid 2 piel de sapo. Toad skin, white sweet flesh.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Hybrid 2'],
    uses: ['fresh', 'fruit salad', 'dessert']
  },
  {
    id: 'bitter-melon-f1-2',
    name: 'Bitter melon - F1 2',
    scientificName: 'Momordica charantia',
    category: 'cucurbit',
    spacing: 48,
    rowSpacing: 72,
    daysToGermination: 7,
    daysToHarvest: 70,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'F1 2 bitter melon. Bumpy green, used in Asian cuisine.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '10-12 feet',
    family: 'Cucurbitaceae',
    varieties: ['F1 2'],
    uses: ['stir fry', 'curry', 'medicinal']
  },
  {
    id: 'winter-melon-open-pollinated-2',
    name: 'Winter melon - Open Pollinated 2',
    scientificName: 'Benincasa hispida',
    category: 'cucurbit',
    spacing: 48,
    rowSpacing: 72,
    daysToGermination: 7,
    daysToHarvest: 110,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Open Pollinated 2 winter melon. Large waxy melon for soup and stew.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '10-12 feet',
    family: 'Benincaseae',
    varieties: ['Open Pollinated 2'],
    uses: ['soup', 'stew', 'braising']
  },
  {
    id: 'cantaloupe-hales-best-3',
    name: 'Cantaloupe - Hales Best 3',
    scientificName: 'Cucumis melo var. cantalupensis',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Hales Best 3 cantaloupe. Classic muskmelon with netted skin.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Hales Best 3'],
    uses: ['fresh', 'fruit salad', 'dessert']
  },
  {
    id: 'honeydew-ambrosia-3',
    name: 'Honeydew - Ambrosia 3',
    scientificName: 'Cucumis melo var. inodorus',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Ambrosia 3 honeydew. Smooth pale skin, sweet green flesh.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Ambrosia 3'],
    uses: ['fresh', 'fruit salad', 'dessert']
  },
  {
    id: 'crenshaw-athena-3',
    name: 'Crenshaw - Athena 3',
    scientificName: 'Cucumis melo var. inodorus',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Athena 3 crenshaw. Hybrid with salmon-pink flesh.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Athena 3'],
    uses: ['fresh', 'fruit salad', 'dessert']
  },
  {
    id: 'casaba-sarahs-choice-3',
    name: 'Casaba - Sarahs Choice 3',
    scientificName: 'Cucumis melo var. inodorus',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Sarahs Choice 3 casaba. Wrinkled yellow skin, white flesh.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Sarahs Choice 3'],
    uses: ['fresh', 'fruit salad', 'dessert']
  },
  {
    id: 'persian-sugar-cube-3',
    name: 'Persian - Sugar Cube 3',
    scientificName: 'Cucumis melo var. reticulatus',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Sugar Cube 3 persian. Oval with netted skin, very sweet.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Sugar Cube 3'],
    uses: ['fresh', 'fruit salad', 'dessert']
  },
  {
    id: 'canary-minnesota-midget-3',
    name: 'Canary - Minnesota Midget 3',
    scientificName: 'Cucumis melo var. inodorus',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Minnesota Midget 3 canary. Bright yellow, mild and sweet.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Minnesota Midget 3'],
    uses: ['fresh', 'fruit salad', 'dessert']
  },
  {
    id: 'galia-hearts-of-gold-3',
    name: 'Galia - Hearts of Gold 3',
    scientificName: 'Cucumis melo var. reticulatus',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Hearts of Gold 3 galia. Netted green skin, spicy-sweet.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Hearts of Gold 3'],
    uses: ['fresh', 'fruit salad', 'dessert']
  },
  {
    id: 'piel-de sapo-pmr-45-3',
    name: 'Piel de sapo - PMR 45 3',
    scientificName: 'Cucumis melo var. inodorus',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'PMR 45 3 piel de sapo. Toad skin, white sweet flesh.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['PMR 45 3'],
    uses: ['fresh', 'fruit salad', 'dessert']
  },
  {
    id: 'bitter-melon-savor-3',
    name: 'Bitter melon - Savor 3',
    scientificName: 'Momordica charantia',
    category: 'cucurbit',
    spacing: 48,
    rowSpacing: 72,
    daysToGermination: 7,
    daysToHarvest: 70,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Savor 3 bitter melon. Bumpy green, used in Asian cuisine.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '10-12 feet',
    family: 'Cucurbitaceae',
    varieties: ['Savor 3'],
    uses: ['stir fry', 'curry', 'medicinal']
  },
  {
    id: 'winter-melon-tasty-bites-3',
    name: 'Winter melon - Tasty Bites 3',
    scientificName: 'Benincasa hispida',
    category: 'cucurbit',
    spacing: 48,
    rowSpacing: 72,
    daysToGermination: 7,
    daysToHarvest: 110,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Tasty Bites 3 winter melon. Large waxy melon for soup and stew.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '10-12 feet',
    family: 'Benincaseae',
    varieties: ['Tasty Bites 3'],
    uses: ['soup', 'stew', 'braising']
  },
  {
    id: 'cantaloupe-green-flesh-3',
    name: 'Cantaloupe - Green Flesh 3',
    scientificName: 'Cucumis melo var. cantalupensis',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Green Flesh 3 cantaloupe. Classic muskmelon with netted skin.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Green Flesh 3'],
    uses: ['fresh', 'fruit salad', 'dessert']
  },
  {
    id: 'honeydew-orange-flesh-3',
    name: 'Honeydew - Orange Flesh 3',
    scientificName: 'Cucumis melo var. inodorus',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Orange Flesh 3 honeydew. Smooth pale skin, sweet green flesh.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Orange Flesh 3'],
    uses: ['fresh', 'fruit salad', 'dessert']
  },
  {
    id: 'crenshaw-honey-dew-3',
    name: 'Crenshaw - Honey Dew 3',
    scientificName: 'Cucumis melo var. inodorus',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Honey Dew 3 crenshaw. Hybrid with salmon-pink flesh.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Honey Dew 3'],
    uses: ['fresh', 'fruit salad', 'dessert']
  },
  {
    id: 'casaba-honey-orange-3',
    name: 'Casaba - Honey Orange 3',
    scientificName: 'Cucumis melo var. inodorus',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Honey Orange 3 casaba. Wrinkled yellow skin, white flesh.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Honey Orange 3'],
    uses: ['fresh', 'fruit salad', 'dessert']
  },
  {
    id: 'persian-temptation-3',
    name: 'Persian - Temptation 3',
    scientificName: 'Cucumis melo var. reticulatus',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Temptation 3 persian. Oval with netted skin, very sweet.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Temptation 3'],
    uses: ['fresh', 'fruit salad', 'dessert']
  },
  {
    id: 'canary-passport-3',
    name: 'Canary - Passport 3',
    scientificName: 'Cucumis melo var. inodorus',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Passport 3 canary. Bright yellow, mild and sweet.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Passport 3'],
    uses: ['fresh', 'fruit salad', 'dessert']
  },
  {
    id: 'galia-earli-dew-3',
    name: 'Galia - Earli-Dew 3',
    scientificName: 'Cucumis melo var. reticulatus',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Earli-Dew 3 galia. Netted green skin, spicy-sweet.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Earli-Dew 3'],
    uses: ['fresh', 'fruit salad', 'dessert']
  },
  {
    id: 'piel-de sapo-honey-white-3',
    name: 'Piel de sapo - Honey White 3',
    scientificName: 'Cucumis melo var. inodorus',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Honey White 3 piel de sapo. Toad skin, white sweet flesh.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Honey White 3'],
    uses: ['fresh', 'fruit salad', 'dessert']
  },
  {
    id: 'bitter-melon-honey-yellow-3',
    name: 'Bitter melon - Honey Yellow 3',
    scientificName: 'Momordica charantia',
    category: 'cucurbit',
    spacing: 48,
    rowSpacing: 72,
    daysToGermination: 7,
    daysToHarvest: 70,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Honey Yellow 3 bitter melon. Bumpy green, used in Asian cuisine.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '10-12 feet',
    family: 'Cucurbitaceae',
    varieties: ['Honey Yellow 3'],
    uses: ['stir fry', 'curry', 'medicinal']
  },
  {
    id: 'winter-melon-honey-gold-3',
    name: 'Winter melon - Honey Gold 3',
    scientificName: 'Benincasa hispida',
    category: 'cucurbit',
    spacing: 48,
    rowSpacing: 72,
    daysToGermination: 7,
    daysToHarvest: 110,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Honey Gold 3 winter melon. Large waxy melon for soup and stew.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '10-12 feet',
    family: 'Benincaseae',
    varieties: ['Honey Gold 3'],
    uses: ['soup', 'stew', 'braising']
  },
  {
    id: 'cantaloupe-early-crenshaw-3',
    name: 'Cantaloupe - Early Crenshaw 3',
    scientificName: 'Cucumis melo var. cantalupensis',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Early Crenshaw 3 cantaloupe. Classic muskmelon with netted skin.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Early Crenshaw 3'],
    uses: ['fresh', 'fruit salad', 'dessert']
  },
  {
    id: 'honeydew-crimson-sweet-3',
    name: 'Honeydew - Crimson Sweet 3',
    scientificName: 'Cucumis melo var. inodorus',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Crimson Sweet 3 honeydew. Smooth pale skin, sweet green flesh.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Crimson Sweet 3'],
    uses: ['fresh', 'fruit salad', 'dessert']
  },
  {
    id: 'crenshaw-large-3',
    name: 'Crenshaw - Large 3',
    scientificName: 'Cucumis melo var. inodorus',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Large 3 crenshaw. Hybrid with salmon-pink flesh.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Large 3'],
    uses: ['fresh', 'fruit salad', 'dessert']
  },
  {
    id: 'casaba-imperial-3',
    name: 'Casaba - Imperial 3',
    scientificName: 'Cucumis melo var. inodorus',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Imperial 3 casaba. Wrinkled yellow skin, white flesh.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Imperial 3'],
    uses: ['fresh', 'fruit salad', 'dessert']
  },
  {
    id: 'persian-hybrid-3',
    name: 'Persian - Hybrid 3',
    scientificName: 'Cucumis melo var. reticulatus',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Hybrid 3 persian. Oval with netted skin, very sweet.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Hybrid 3'],
    uses: ['fresh', 'fruit salad', 'dessert']
  },
  {
    id: 'canary-golden-beauty-3',
    name: 'Canary - Golden Beauty 3',
    scientificName: 'Cucumis melo var. inodorus',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Golden Beauty 3 canary. Bright yellow, mild and sweet.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Golden Beauty 3'],
    uses: ['fresh', 'fruit salad', 'dessert']
  },
  {
    id: 'galia-snowball-3',
    name: 'Galia - Snowball 3',
    scientificName: 'Cucumis melo var. reticulatus',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Snowball 3 galia. Netted green skin, spicy-sweet.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Snowball 3'],
    uses: ['fresh', 'fruit salad', 'dessert']
  },
  {
    id: 'piel-de sapo-casaba-3',
    name: 'Piel de sapo - Casaba 3',
    scientificName: 'Cucumis melo var. inodorus',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Casaba 3 piel de sapo. Toad skin, white sweet flesh.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Casaba 3'],
    uses: ['fresh', 'fruit salad', 'dessert']
  },
  {
    id: 'bitter-melon-winter-3',
    name: 'Bitter melon - Winter 3',
    scientificName: 'Momordica charantia',
    category: 'cucurbit',
    spacing: 48,
    rowSpacing: 72,
    daysToGermination: 7,
    daysToHarvest: 70,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Winter 3 bitter melon. Bumpy green, used in Asian cuisine.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '10-12 feet',
    family: 'Cucurbitaceae',
    varieties: ['Winter 3'],
    uses: ['stir fry', 'curry', 'medicinal']
  },
  {
    id: 'winter-melon-santa-claus-3',
    name: 'Winter melon - Santa Claus 3',
    scientificName: 'Benincasa hispida',
    category: 'cucurbit',
    spacing: 48,
    rowSpacing: 72,
    daysToGermination: 7,
    daysToHarvest: 110,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Santa Claus 3 winter melon. Large waxy melon for soup and stew.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '10-12 feet',
    family: 'Benincaseae',
    varieties: ['Santa Claus 3'],
    uses: ['soup', 'stew', 'braising']
  },
  {
    id: 'cantaloupe-piel-de-sapo-3',
    name: 'Cantaloupe - Piel de Sapo 3',
    scientificName: 'Cucumis melo var. cantalupensis',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Piel de Sapo 3 cantaloupe. Classic muskmelon with netted skin.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Piel de Sapo 3'],
    uses: ['fresh', 'fruit salad', 'dessert']
  },
  {
    id: 'honeydew-toad-skin-3',
    name: 'Honeydew - Toad Skin 3',
    scientificName: 'Cucumis melo var. inodorus',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Toad Skin 3 honeydew. Smooth pale skin, sweet green flesh.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Toad Skin 3'],
    uses: ['fresh', 'fruit salad', 'dessert']
  },
  {
    id: 'crenshaw-santa-claus-3',
    name: 'Crenshaw - Santa Claus 3',
    scientificName: 'Cucumis melo var. inodorus',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Santa Claus 3 crenshaw. Hybrid with salmon-pink flesh.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Santa Claus 3'],
    uses: ['fresh', 'fruit salad', 'dessert']
  },
  {
    id: 'casaba-christmas-3',
    name: 'Casaba - Christmas 3',
    scientificName: 'Cucumis melo var. inodorus',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Christmas 3 casaba. Wrinkled yellow skin, white flesh.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Christmas 3'],
    uses: ['fresh', 'fruit salad', 'dessert']
  },
  {
    id: 'persian-canary-3',
    name: 'Persian - Canary 3',
    scientificName: 'Cucumis melo var. reticulatus',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Canary 3 persian. Oval with netted skin, very sweet.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Canary 3'],
    uses: ['fresh', 'fruit salad', 'dessert']
  },
  {
    id: 'canary-amarillo-3',
    name: 'Canary - Amarillo 3',
    scientificName: 'Cucumis melo var. inodorus',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Amarillo 3 canary. Bright yellow, mild and sweet.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Amarillo 3'],
    uses: ['fresh', 'fruit salad', 'dessert']
  },
  {
    id: 'galia-juan-canary-3',
    name: 'Galia - Juan Canary 3',
    scientificName: 'Cucumis melo var. reticulatus',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Juan Canary 3 galia. Netted green skin, spicy-sweet.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Juan Canary 3'],
    uses: ['fresh', 'fruit salad', 'dessert']
  },
  {
    id: 'piel-de sapo-yellow-3',
    name: 'Piel de sapo - Yellow 3',
    scientificName: 'Cucumis melo var. inodorus',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Yellow 3 piel de sapo. Toad skin, white sweet flesh.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Yellow 3'],
    uses: ['fresh', 'fruit salad', 'dessert']
  },
  {
    id: 'bitter-melon-galia-3',
    name: 'Bitter melon - Galia 3',
    scientificName: 'Momordica charantia',
    category: 'cucurbit',
    spacing: 48,
    rowSpacing: 72,
    daysToGermination: 7,
    daysToHarvest: 70,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Galia 3 bitter melon. Bumpy green, used in Asian cuisine.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '10-12 feet',
    family: 'Cucurbitaceae',
    varieties: ['Galia 3'],
    uses: ['stir fry', 'curry', 'medicinal']
  },
  {
    id: 'winter-melon-greek-3',
    name: 'Winter melon - Greek 3',
    scientificName: 'Benincasa hispida',
    category: 'cucurbit',
    spacing: 48,
    rowSpacing: 72,
    daysToGermination: 7,
    daysToHarvest: 110,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Greek 3 winter melon. Large waxy melon for soup and stew.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '10-12 feet',
    family: 'Benincaseae',
    varieties: ['Greek 3'],
    uses: ['soup', 'stew', 'braising']
  },
  {
    id: 'cantaloupe-arava-3',
    name: 'Cantaloupe - Arava 3',
    scientificName: 'Cucumis melo var. cantalupensis',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Arava 3 cantaloupe. Classic muskmelon with netted skin.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Arava 3'],
    uses: ['fresh', 'fruit salad', 'dessert']
  },
  {
    id: 'honeydew-diplomat-3',
    name: 'Honeydew - Diplomat 3',
    scientificName: 'Cucumis melo var. inodorus',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Diplomat 3 honeydew. Smooth pale skin, sweet green flesh.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Diplomat 3'],
    uses: ['fresh', 'fruit salad', 'dessert']
  },
  {
    id: 'crenshaw-gallicum-3',
    name: 'Crenshaw - Gallicum 3',
    scientificName: 'Cucumis melo var. inodorus',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Gallicum 3 crenshaw. Hybrid with salmon-pink flesh.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Gallicum 3'],
    uses: ['fresh', 'fruit salad', 'dessert']
  },
  {
    id: 'casaba-madonna-3',
    name: 'Casaba - Madonna 3',
    scientificName: 'Cucumis melo var. inodorus',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Madonna 3 casaba. Wrinkled yellow skin, white flesh.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Madonna 3'],
    uses: ['fresh', 'fruit salad', 'dessert']
  },
  {
    id: 'persian-magnum-3',
    name: 'Persian - Magnum 3',
    scientificName: 'Cucumis melo var. reticulatus',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Magnum 3 persian. Oval with netted skin, very sweet.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Magnum 3'],
    uses: ['fresh', 'fruit salad', 'dessert']
  },
  {
    id: 'canary-armenian-3',
    name: 'Canary - Armenian 3',
    scientificName: 'Cucumis melo var. inodorus',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Armenian 3 canary. Bright yellow, mild and sweet.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Armenian 3'],
    uses: ['fresh', 'fruit salad', 'dessert']
  },
  {
    id: 'galia-snake-3',
    name: 'Galia - Snake 3',
    scientificName: 'Cucumis melo var. reticulatus',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Snake 3 galia. Netted green skin, spicy-sweet.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Snake 3'],
    uses: ['fresh', 'fruit salad', 'dessert']
  },
  {
    id: 'piel-de sapo-yard-long-3',
    name: 'Piel de sapo - Yard Long 3',
    scientificName: 'Cucumis melo var. inodorus',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Yard Long 3 piel de sapo. Toad skin, white sweet flesh.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Yard Long 3'],
    uses: ['fresh', 'fruit salad', 'dessert']
  },
  {
    id: 'bitter-melon-bitter-3',
    name: 'Bitter melon - Bitter 3',
    scientificName: 'Momordica charantia',
    category: 'cucurbit',
    spacing: 48,
    rowSpacing: 72,
    daysToGermination: 7,
    daysToHarvest: 70,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Bitter 3 bitter melon. Bumpy green, used in Asian cuisine.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '10-12 feet',
    family: 'Cucurbitaceae',
    varieties: ['Bitter 3'],
    uses: ['stir fry', 'curry', 'medicinal']
  },
  {
    id: 'winter-melon-karela-3',
    name: 'Winter melon - Karela 3',
    scientificName: 'Benincasa hispida',
    category: 'cucurbit',
    spacing: 48,
    rowSpacing: 72,
    daysToGermination: 7,
    daysToHarvest: 110,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Karela 3 winter melon. Large waxy melon for soup and stew.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '10-12 feet',
    family: 'Benincaseae',
    varieties: ['Karela 3'],
    uses: ['soup', 'stew', 'braising']
  },
  {
    id: 'cantaloupe-chinese-3',
    name: 'Cantaloupe - Chinese 3',
    scientificName: 'Cucumis melo var. cantalupensis',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Chinese 3 cantaloupe. Classic muskmelon with netted skin.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Chinese 3'],
    uses: ['fresh', 'fruit salad', 'dessert']
  },
  {
    id: 'honeydew-indian-3',
    name: 'Honeydew - Indian 3',
    scientificName: 'Cucumis melo var. inodorus',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Indian 3 honeydew. Smooth pale skin, sweet green flesh.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Indian 3'],
    uses: ['fresh', 'fruit salad', 'dessert']
  },
  {
    id: 'crenshaw-thai-3',
    name: 'Crenshaw - Thai 3',
    scientificName: 'Cucumis melo var. inodorus',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Thai 3 crenshaw. Hybrid with salmon-pink flesh.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Thai 3'],
    uses: ['fresh', 'fruit salad', 'dessert']
  },
  {
    id: 'casaba-vietnamese-3',
    name: 'Casaba - Vietnamese 3',
    scientificName: 'Cucumis melo var. inodorus',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Vietnamese 3 casaba. Wrinkled yellow skin, white flesh.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Vietnamese 3'],
    uses: ['fresh', 'fruit salad', 'dessert']
  },
  {
    id: 'persian-japanese-3',
    name: 'Persian - Japanese 3',
    scientificName: 'Cucumis melo var. reticulatus',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Japanese 3 persian. Oval with netted skin, very sweet.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Japanese 3'],
    uses: ['fresh', 'fruit salad', 'dessert']
  },
  {
    id: 'canary-winter-melon-3',
    name: 'Canary - Winter Melon 3',
    scientificName: 'Cucumis melo var. inodorus',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Winter Melon 3 canary. Bright yellow, mild and sweet.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Winter Melon 3'],
    uses: ['fresh', 'fruit salad', 'dessert']
  },
  {
    id: 'galia-wax-gourd-3',
    name: 'Galia - Wax Gourd 3',
    scientificName: 'Cucumis melo var. reticulatus',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Wax Gourd 3 galia. Netted green skin, spicy-sweet.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Wax Gourd 3'],
    uses: ['fresh', 'fruit salad', 'dessert']
  },
  {
    id: 'piel-de sapo-ash-gourd-3',
    name: 'Piel de sapo - Ash Gourd 3',
    scientificName: 'Cucumis melo var. inodorus',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Ash Gourd 3 piel de sapo. Toad skin, white sweet flesh.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Ash Gourd 3'],
    uses: ['fresh', 'fruit salad', 'dessert']
  },
  {
    id: 'bitter-melon-chinese-watermelon-3',
    name: 'Bitter melon - Chinese Watermelon 3',
    scientificName: 'Momordica charantia',
    category: 'cucurbit',
    spacing: 48,
    rowSpacing: 72,
    daysToGermination: 7,
    daysToHarvest: 70,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Chinese Watermelon 3 bitter melon. Bumpy green, used in Asian cuisine.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '10-12 feet',
    family: 'Cucurbitaceae',
    varieties: ['Chinese Watermelon 3'],
    uses: ['stir fry', 'curry', 'medicinal']
  },
  {
    id: 'winter-melon-dong-gua-3',
    name: 'Winter melon - Dong Gua 3',
    scientificName: 'Benincasa hispida',
    category: 'cucurbit',
    spacing: 48,
    rowSpacing: 72,
    daysToGermination: 7,
    daysToHarvest: 110,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Dong Gua 3 winter melon. Large waxy melon for soup and stew.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '10-12 feet',
    family: 'Benincaseae',
    varieties: ['Dong Gua 3'],
    uses: ['soup', 'stew', 'braising']
  },
  {
    id: 'cantaloupe-sugar-3',
    name: 'Cantaloupe - Sugar 3',
    scientificName: 'Cucumis melo var. cantalupensis',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Sugar 3 cantaloupe. Classic muskmelon with netted skin.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Sugar 3'],
    uses: ['fresh', 'fruit salad', 'dessert']
  },
  {
    id: 'honeydew-sweet-3',
    name: 'Honeydew - Sweet 3',
    scientificName: 'Cucumis melo var. inodorus',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Sweet 3 honeydew. Smooth pale skin, sweet green flesh.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Sweet 3'],
    uses: ['fresh', 'fruit salad', 'dessert']
  },
  {
    id: 'crenshaw-super-sweet-3',
    name: 'Crenshaw - Super Sweet 3',
    scientificName: 'Cucumis melo var. inodorus',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Super Sweet 3 crenshaw. Hybrid with salmon-pink flesh.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Super Sweet 3'],
    uses: ['fresh', 'fruit salad', 'dessert']
  },
  {
    id: 'casaba-extra-sweet-3',
    name: 'Casaba - Extra Sweet 3',
    scientificName: 'Cucumis melo var. inodorus',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Extra Sweet 3 casaba. Wrinkled yellow skin, white flesh.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Extra Sweet 3'],
    uses: ['fresh', 'fruit salad', 'dessert']
  },
  {
    id: 'persian-ultra-sweet-3',
    name: 'Persian - Ultra Sweet 3',
    scientificName: 'Cucumis melo var. reticulatus',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Ultra Sweet 3 persian. Oval with netted skin, very sweet.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Ultra Sweet 3'],
    uses: ['fresh', 'fruit salad', 'dessert']
  },
  {
    id: 'canary-early-3',
    name: 'Canary - Early 3',
    scientificName: 'Cucumis melo var. inodorus',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Early 3 canary. Bright yellow, mild and sweet.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Early 3'],
    uses: ['fresh', 'fruit salad', 'dessert']
  },
  {
    id: 'galia-main-season-3',
    name: 'Galia - Main Season 3',
    scientificName: 'Cucumis melo var. reticulatus',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Main Season 3 galia. Netted green skin, spicy-sweet.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Main Season 3'],
    uses: ['fresh', 'fruit salad', 'dessert']
  },
  {
    id: 'piel-de sapo-late-3',
    name: 'Piel de sapo - Late 3',
    scientificName: 'Cucumis melo var. inodorus',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Late 3 piel de sapo. Toad skin, white sweet flesh.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Late 3'],
    uses: ['fresh', 'fruit salad', 'dessert']
  },
  {
    id: 'bitter-melon-all-season-3',
    name: 'Bitter melon - All Season 3',
    scientificName: 'Momordica charantia',
    category: 'cucurbit',
    spacing: 48,
    rowSpacing: 72,
    daysToGermination: 7,
    daysToHarvest: 70,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'All Season 3 bitter melon. Bumpy green, used in Asian cuisine.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '10-12 feet',
    family: 'Cucurbitaceae',
    varieties: ['All Season 3'],
    uses: ['stir fry', 'curry', 'medicinal']
  },
  {
    id: 'winter-melon-fall-3',
    name: 'Winter melon - Fall 3',
    scientificName: 'Benincasa hispida',
    category: 'cucurbit',
    spacing: 48,
    rowSpacing: 72,
    daysToGermination: 7,
    daysToHarvest: 110,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Fall 3 winter melon. Large waxy melon for soup and stew.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '10-12 feet',
    family: 'Benincaseae',
    varieties: ['Fall 3'],
    uses: ['soup', 'stew', 'braising']
  },
  {
    id: 'cantaloupe-spring-3',
    name: 'Cantaloupe - Spring 3',
    scientificName: 'Cucumis melo var. cantalupensis',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Spring 3 cantaloupe. Classic muskmelon with netted skin.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Spring 3'],
    uses: ['fresh', 'fruit salad', 'dessert']
  },
  {
    id: 'honeydew-summer-3',
    name: 'Honeydew - Summer 3',
    scientificName: 'Cucumis melo var. inodorus',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Summer 3 honeydew. Smooth pale skin, sweet green flesh.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Summer 3'],
    uses: ['fresh', 'fruit salad', 'dessert']
  },
  {
    id: 'crenshaw-winter-3',
    name: 'Crenshaw - Winter 3',
    scientificName: 'Cucumis melo var. inodorus',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Winter 3 crenshaw. Hybrid with salmon-pink flesh.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Winter 3'],
    uses: ['fresh', 'fruit salad', 'dessert']
  },
  {
    id: 'casaba-greenhouse-3',
    name: 'Casaba - Greenhouse 3',
    scientificName: 'Cucumis melo var. inodorus',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Greenhouse 3 casaba. Wrinkled yellow skin, white flesh.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Greenhouse 3'],
    uses: ['fresh', 'fruit salad', 'dessert']
  },
  {
    id: 'persian-field-3',
    name: 'Persian - Field 3',
    scientificName: 'Cucumis melo var. reticulatus',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Field 3 persian. Oval with netted skin, very sweet.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Field 3'],
    uses: ['fresh', 'fruit salad', 'dessert']
  },
  {
    id: 'canary-drought-tolerant-3',
    name: 'Canary - Drought Tolerant 3',
    scientificName: 'Cucumis melo var. inodorus',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Drought Tolerant 3 canary. Bright yellow, mild and sweet.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Drought Tolerant 3'],
    uses: ['fresh', 'fruit salad', 'dessert']
  },
  {
    id: 'galia-heat-resistant-3',
    name: 'Galia - Heat Resistant 3',
    scientificName: 'Cucumis melo var. reticulatus',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Heat Resistant 3 galia. Netted green skin, spicy-sweet.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Heat Resistant 3'],
    uses: ['fresh', 'fruit salad', 'dessert']
  },
  {
    id: 'piel-de sapo-disease-resistant-3',
    name: 'Piel de sapo - Disease Resistant 3',
    scientificName: 'Cucumis melo var. inodorus',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Disease Resistant 3 piel de sapo. Toad skin, white sweet flesh.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Disease Resistant 3'],
    uses: ['fresh', 'fruit salad', 'dessert']
  },
  {
    id: 'bitter-melon-virus-resistant-3',
    name: 'Bitter melon - Virus Resistant 3',
    scientificName: 'Momordica charantia',
    category: 'cucurbit',
    spacing: 48,
    rowSpacing: 72,
    daysToGermination: 7,
    daysToHarvest: 70,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Virus Resistant 3 bitter melon. Bumpy green, used in Asian cuisine.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '10-12 feet',
    family: 'Cucurbitaceae',
    varieties: ['Virus Resistant 3'],
    uses: ['stir fry', 'curry', 'medicinal']
  },
  {
    id: 'winter-melon-fusarium-resistant-3',
    name: 'Winter melon - Fusarium Resistant 3',
    scientificName: 'Benincasa hispida',
    category: 'cucurbit',
    spacing: 48,
    rowSpacing: 72,
    daysToGermination: 7,
    daysToHarvest: 110,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Fusarium Resistant 3 winter melon. Large waxy melon for soup and stew.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '10-12 feet',
    family: 'Benincaseae',
    varieties: ['Fusarium Resistant 3'],
    uses: ['soup', 'stew', 'braising']
  },
  {
    id: 'cantaloupe-small-3',
    name: 'Cantaloupe - Small 3',
    scientificName: 'Cucumis melo var. cantalupensis',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Small 3 cantaloupe. Classic muskmelon with netted skin.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Small 3'],
    uses: ['fresh', 'fruit salad', 'dessert']
  },
  {
    id: 'honeydew-medium-3',
    name: 'Honeydew - Medium 3',
    scientificName: 'Cucumis melo var. inodorus',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Medium 3 honeydew. Smooth pale skin, sweet green flesh.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Medium 3'],
    uses: ['fresh', 'fruit salad', 'dessert']
  },
  {
    id: 'crenshaw-large-3',
    name: 'Crenshaw - Large 3',
    scientificName: 'Cucumis melo var. inodorus',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Large 3 crenshaw. Hybrid with salmon-pink flesh.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Large 3'],
    uses: ['fresh', 'fruit salad', 'dessert']
  },
  {
    id: 'casaba-jumbo-3',
    name: 'Casaba - Jumbo 3',
    scientificName: 'Cucumis melo var. inodorus',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Jumbo 3 casaba. Wrinkled yellow skin, white flesh.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Jumbo 3'],
    uses: ['fresh', 'fruit salad', 'dessert']
  },
  {
    id: 'persian-giant-3',
    name: 'Persian - Giant 3',
    scientificName: 'Cucumis melo var. reticulatus',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Giant 3 persian. Oval with netted skin, very sweet.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Giant 3'],
    uses: ['fresh', 'fruit salad', 'dessert']
  },
  {
    id: 'canary-round-3',
    name: 'Canary - Round 3',
    scientificName: 'Cucumis melo var. inodorus',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Round 3 canary. Bright yellow, mild and sweet.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Round 3'],
    uses: ['fresh', 'fruit salad', 'dessert']
  },
  {
    id: 'galia-oval-3',
    name: 'Galia - Oval 3',
    scientificName: 'Cucumis melo var. reticulatus',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Oval 3 galia. Netted green skin, spicy-sweet.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Oval 3'],
    uses: ['fresh', 'fruit salad', 'dessert']
  },
  {
    id: 'piel-de sapo-elongated-3',
    name: 'Piel de sapo - Elongated 3',
    scientificName: 'Cucumis melo var. inodorus',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Elongated 3 piel de sapo. Toad skin, white sweet flesh.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Elongated 3'],
    uses: ['fresh', 'fruit salad', 'dessert']
  },
  {
    id: 'bitter-melon-slip-3',
    name: 'Bitter melon - Slip 3',
    scientificName: 'Momordica charantia',
    category: 'cucurbit',
    spacing: 48,
    rowSpacing: 72,
    daysToGermination: 7,
    daysToHarvest: 70,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Slip 3 bitter melon. Bumpy green, used in Asian cuisine.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '10-12 feet',
    family: 'Cucurbitaceae',
    varieties: ['Slip 3'],
    uses: ['stir fry', 'curry', 'medicinal']
  },
  {
    id: 'winter-melon-non-slip-3',
    name: 'Winter melon - Non-Slip 3',
    scientificName: 'Benincasa hispida',
    category: 'cucurbit',
    spacing: 48,
    rowSpacing: 72,
    daysToGermination: 7,
    daysToHarvest: 110,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Non-Slip 3 winter melon. Large waxy melon for soup and stew.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '10-12 feet',
    family: 'Benincaseae',
    varieties: ['Non-Slip 3'],
    uses: ['soup', 'stew', 'braising']
  },
  {
    id: 'cantaloupe-netted-3',
    name: 'Cantaloupe - Netted 3',
    scientificName: 'Cucumis melo var. cantalupensis',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Netted 3 cantaloupe. Classic muskmelon with netted skin.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Netted 3'],
    uses: ['fresh', 'fruit salad', 'dessert']
  },
  {
    id: 'honeydew-smooth-3',
    name: 'Honeydew - Smooth 3',
    scientificName: 'Cucumis melo var. inodorus',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Smooth 3 honeydew. Smooth pale skin, sweet green flesh.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Smooth 3'],
    uses: ['fresh', 'fruit salad', 'dessert']
  },
  {
    id: 'crenshaw-ribbed-3',
    name: 'Crenshaw - Ribbed 3',
    scientificName: 'Cucumis melo var. inodorus',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Ribbed 3 crenshaw. Hybrid with salmon-pink flesh.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Ribbed 3'],
    uses: ['fresh', 'fruit salad', 'dessert']
  },
  {
    id: 'casaba-sutured-3',
    name: 'Casaba - Sutured 3',
    scientificName: 'Cucumis melo var. inodorus',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Sutured 3 casaba. Wrinkled yellow skin, white flesh.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Sutured 3'],
    uses: ['fresh', 'fruit salad', 'dessert']
  },
  {
    id: 'persian-veined-3',
    name: 'Persian - Veined 3',
    scientificName: 'Cucumis melo var. reticulatus',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Veined 3 persian. Oval with netted skin, very sweet.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Veined 3'],
    uses: ['fresh', 'fruit salad', 'dessert']
  },
  {
    id: 'canary-orange-3',
    name: 'Canary - Orange 3',
    scientificName: 'Cucumis melo var. inodorus',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Orange 3 canary. Bright yellow, mild and sweet.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Orange 3'],
    uses: ['fresh', 'fruit salad', 'dessert']
  },
  {
    id: 'galia-green-3',
    name: 'Galia - Green 3',
    scientificName: 'Cucumis melo var. reticulatus',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Green 3 galia. Netted green skin, spicy-sweet.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Green 3'],
    uses: ['fresh', 'fruit salad', 'dessert']
  },
  {
    id: 'piel-de sapo-white-3',
    name: 'Piel de sapo - White 3',
    scientificName: 'Cucumis melo var. inodorus',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'White 3 piel de sapo. Toad skin, white sweet flesh.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['White 3'],
    uses: ['fresh', 'fruit salad', 'dessert']
  },
  {
    id: 'bitter-melon-yellow-3',
    name: 'Bitter melon - Yellow 3',
    scientificName: 'Momordica charantia',
    category: 'cucurbit',
    spacing: 48,
    rowSpacing: 72,
    daysToGermination: 7,
    daysToHarvest: 70,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Yellow 3 bitter melon. Bumpy green, used in Asian cuisine.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '10-12 feet',
    family: 'Cucurbitaceae',
    varieties: ['Yellow 3'],
    uses: ['stir fry', 'curry', 'medicinal']
  },
  {
    id: 'winter-melon-gold-3',
    name: 'Winter melon - Gold 3',
    scientificName: 'Benincasa hispida',
    category: 'cucurbit',
    spacing: 48,
    rowSpacing: 72,
    daysToGermination: 7,
    daysToHarvest: 110,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Gold 3 winter melon. Large waxy melon for soup and stew.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '10-12 feet',
    family: 'Benincaseae',
    varieties: ['Gold 3'],
    uses: ['soup', 'stew', 'braising']
  },
  {
    id: 'cantaloupe-red-3',
    name: 'Cantaloupe - Red 3',
    scientificName: 'Cucumis melo var. cantalupensis',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Red 3 cantaloupe. Classic muskmelon with netted skin.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Red 3'],
    uses: ['fresh', 'fruit salad', 'dessert']
  },
  {
    id: 'honeydew-pink-3',
    name: 'Honeydew - Pink 3',
    scientificName: 'Cucumis melo var. inodorus',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Pink 3 honeydew. Smooth pale skin, sweet green flesh.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Pink 3'],
    uses: ['fresh', 'fruit salad', 'dessert']
  },
  {
    id: 'crenshaw-salmon-3',
    name: 'Crenshaw - Salmon 3',
    scientificName: 'Cucumis melo var. inodorus',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Salmon 3 crenshaw. Hybrid with salmon-pink flesh.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Salmon 3'],
    uses: ['fresh', 'fruit salad', 'dessert']
  },
  {
    id: 'casaba-apricot-3',
    name: 'Casaba - Apricot 3',
    scientificName: 'Cucumis melo var. inodorus',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Apricot 3 casaba. Wrinkled yellow skin, white flesh.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Apricot 3'],
    uses: ['fresh', 'fruit salad', 'dessert']
  },
  {
    id: 'persian-cream-3',
    name: 'Persian - Cream 3',
    scientificName: 'Cucumis melo var. reticulatus',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Cream 3 persian. Oval with netted skin, very sweet.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Cream 3'],
    uses: ['fresh', 'fruit salad', 'dessert']
  },
  {
    id: 'canary-organic-3',
    name: 'Canary - Organic 3',
    scientificName: 'Cucumis melo var. inodorus',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Organic 3 canary. Bright yellow, mild and sweet.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Organic 3'],
    uses: ['fresh', 'fruit salad', 'dessert']
  },
  {
    id: 'galia-heirloom-3',
    name: 'Galia - Heirloom 3',
    scientificName: 'Cucumis melo var. reticulatus',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Heirloom 3 galia. Netted green skin, spicy-sweet.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Heirloom 3'],
    uses: ['fresh', 'fruit salad', 'dessert']
  },
  {
    id: 'piel-de sapo-hybrid-3',
    name: 'Piel de sapo - Hybrid 3',
    scientificName: 'Cucumis melo var. inodorus',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Hybrid 3 piel de sapo. Toad skin, white sweet flesh.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Hybrid 3'],
    uses: ['fresh', 'fruit salad', 'dessert']
  },
  {
    id: 'bitter-melon-f1-3',
    name: 'Bitter melon - F1 3',
    scientificName: 'Momordica charantia',
    category: 'cucurbit',
    spacing: 48,
    rowSpacing: 72,
    daysToGermination: 7,
    daysToHarvest: 70,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'F1 3 bitter melon. Bumpy green, used in Asian cuisine.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '10-12 feet',
    family: 'Cucurbitaceae',
    varieties: ['F1 3'],
    uses: ['stir fry', 'curry', 'medicinal']
  },
  {
    id: 'winter-melon-open-pollinated-3',
    name: 'Winter melon - Open Pollinated 3',
    scientificName: 'Benincasa hispida',
    category: 'cucurbit',
    spacing: 48,
    rowSpacing: 72,
    daysToGermination: 7,
    daysToHarvest: 110,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Open Pollinated 3 winter melon. Large waxy melon for soup and stew.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '10-12 feet',
    family: 'Benincaseae',
    varieties: ['Open Pollinated 3'],
    uses: ['soup', 'stew', 'braising']
  },
  {
    id: 'cantaloupe-hales-best-4',
    name: 'Cantaloupe - Hales Best 4',
    scientificName: 'Cucumis melo var. cantalupensis',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Hales Best 4 cantaloupe. Classic muskmelon with netted skin.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Hales Best 4'],
    uses: ['fresh', 'fruit salad', 'dessert']
  },
  {
    id: 'honeydew-ambrosia-4',
    name: 'Honeydew - Ambrosia 4',
    scientificName: 'Cucumis melo var. inodorus',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Ambrosia 4 honeydew. Smooth pale skin, sweet green flesh.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Ambrosia 4'],
    uses: ['fresh', 'fruit salad', 'dessert']
  },
  {
    id: 'crenshaw-athena-4',
    name: 'Crenshaw - Athena 4',
    scientificName: 'Cucumis melo var. inodorus',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Athena 4 crenshaw. Hybrid with salmon-pink flesh.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Athena 4'],
    uses: ['fresh', 'fruit salad', 'dessert']
  },
  {
    id: 'casaba-sarahs-choice-4',
    name: 'Casaba - Sarahs Choice 4',
    scientificName: 'Cucumis melo var. inodorus',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Sarahs Choice 4 casaba. Wrinkled yellow skin, white flesh.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Sarahs Choice 4'],
    uses: ['fresh', 'fruit salad', 'dessert']
  },
  {
    id: 'persian-sugar-cube-4',
    name: 'Persian - Sugar Cube 4',
    scientificName: 'Cucumis melo var. reticulatus',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Sugar Cube 4 persian. Oval with netted skin, very sweet.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Sugar Cube 4'],
    uses: ['fresh', 'fruit salad', 'dessert']
  },
  {
    id: 'canary-minnesota-midget-4',
    name: 'Canary - Minnesota Midget 4',
    scientificName: 'Cucumis melo var. inodorus',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Minnesota Midget 4 canary. Bright yellow, mild and sweet.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Minnesota Midget 4'],
    uses: ['fresh', 'fruit salad', 'dessert']
  },
  {
    id: 'galia-hearts-of-gold-4',
    name: 'Galia - Hearts of Gold 4',
    scientificName: 'Cucumis melo var. reticulatus',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Hearts of Gold 4 galia. Netted green skin, spicy-sweet.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Hearts of Gold 4'],
    uses: ['fresh', 'fruit salad', 'dessert']
  },
  {
    id: 'piel-de sapo-pmr-45-4',
    name: 'Piel de sapo - PMR 45 4',
    scientificName: 'Cucumis melo var. inodorus',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'PMR 45 4 piel de sapo. Toad skin, white sweet flesh.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['PMR 45 4'],
    uses: ['fresh', 'fruit salad', 'dessert']
  },
  {
    id: 'bitter-melon-savor-4',
    name: 'Bitter melon - Savor 4',
    scientificName: 'Momordica charantia',
    category: 'cucurbit',
    spacing: 48,
    rowSpacing: 72,
    daysToGermination: 7,
    daysToHarvest: 70,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Savor 4 bitter melon. Bumpy green, used in Asian cuisine.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '10-12 feet',
    family: 'Cucurbitaceae',
    varieties: ['Savor 4'],
    uses: ['stir fry', 'curry', 'medicinal']
  },
  {
    id: 'winter-melon-tasty-bites-4',
    name: 'Winter melon - Tasty Bites 4',
    scientificName: 'Benincasa hispida',
    category: 'cucurbit',
    spacing: 48,
    rowSpacing: 72,
    daysToGermination: 7,
    daysToHarvest: 110,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Tasty Bites 4 winter melon. Large waxy melon for soup and stew.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '10-12 feet',
    family: 'Benincaseae',
    varieties: ['Tasty Bites 4'],
    uses: ['soup', 'stew', 'braising']
  },
  {
    id: 'cantaloupe-green-flesh-4',
    name: 'Cantaloupe - Green Flesh 4',
    scientificName: 'Cucumis melo var. cantalupensis',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Green Flesh 4 cantaloupe. Classic muskmelon with netted skin.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Green Flesh 4'],
    uses: ['fresh', 'fruit salad', 'dessert']
  },
  {
    id: 'honeydew-orange-flesh-4',
    name: 'Honeydew - Orange Flesh 4',
    scientificName: 'Cucumis melo var. inodorus',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Orange Flesh 4 honeydew. Smooth pale skin, sweet green flesh.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Orange Flesh 4'],
    uses: ['fresh', 'fruit salad', 'dessert']
  },
  {
    id: 'crenshaw-honey-dew-4',
    name: 'Crenshaw - Honey Dew 4',
    scientificName: 'Cucumis melo var. inodorus',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Honey Dew 4 crenshaw. Hybrid with salmon-pink flesh.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Honey Dew 4'],
    uses: ['fresh', 'fruit salad', 'dessert']
  },
  {
    id: 'casaba-honey-orange-4',
    name: 'Casaba - Honey Orange 4',
    scientificName: 'Cucumis melo var. inodorus',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Honey Orange 4 casaba. Wrinkled yellow skin, white flesh.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Honey Orange 4'],
    uses: ['fresh', 'fruit salad', 'dessert']
  },
  {
    id: 'persian-temptation-4',
    name: 'Persian - Temptation 4',
    scientificName: 'Cucumis melo var. reticulatus',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Temptation 4 persian. Oval with netted skin, very sweet.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Temptation 4'],
    uses: ['fresh', 'fruit salad', 'dessert']
  },
  {
    id: 'canary-passport-4',
    name: 'Canary - Passport 4',
    scientificName: 'Cucumis melo var. inodorus',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Passport 4 canary. Bright yellow, mild and sweet.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Passport 4'],
    uses: ['fresh', 'fruit salad', 'dessert']
  },
  {
    id: 'galia-earli-dew-4',
    name: 'Galia - Earli-Dew 4',
    scientificName: 'Cucumis melo var. reticulatus',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Earli-Dew 4 galia. Netted green skin, spicy-sweet.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Earli-Dew 4'],
    uses: ['fresh', 'fruit salad', 'dessert']
  },
  {
    id: 'piel-de sapo-honey-white-4',
    name: 'Piel de sapo - Honey White 4',
    scientificName: 'Cucumis melo var. inodorus',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Honey White 4 piel de sapo. Toad skin, white sweet flesh.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Honey White 4'],
    uses: ['fresh', 'fruit salad', 'dessert']
  },
  {
    id: 'bitter-melon-honey-yellow-4',
    name: 'Bitter melon - Honey Yellow 4',
    scientificName: 'Momordica charantia',
    category: 'cucurbit',
    spacing: 48,
    rowSpacing: 72,
    daysToGermination: 7,
    daysToHarvest: 70,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Honey Yellow 4 bitter melon. Bumpy green, used in Asian cuisine.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '10-12 feet',
    family: 'Cucurbitaceae',
    varieties: ['Honey Yellow 4'],
    uses: ['stir fry', 'curry', 'medicinal']
  },
  {
    id: 'winter-melon-honey-gold-4',
    name: 'Winter melon - Honey Gold 4',
    scientificName: 'Benincasa hispida',
    category: 'cucurbit',
    spacing: 48,
    rowSpacing: 72,
    daysToGermination: 7,
    daysToHarvest: 110,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Honey Gold 4 winter melon. Large waxy melon for soup and stew.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '10-12 feet',
    family: 'Benincaseae',
    varieties: ['Honey Gold 4'],
    uses: ['soup', 'stew', 'braising']
  },
  {
    id: 'cantaloupe-early-crenshaw-4',
    name: 'Cantaloupe - Early Crenshaw 4',
    scientificName: 'Cucumis melo var. cantalupensis',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Early Crenshaw 4 cantaloupe. Classic muskmelon with netted skin.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Early Crenshaw 4'],
    uses: ['fresh', 'fruit salad', 'dessert']
  },
  {
    id: 'honeydew-crimson-sweet-4',
    name: 'Honeydew - Crimson Sweet 4',
    scientificName: 'Cucumis melo var. inodorus',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Crimson Sweet 4 honeydew. Smooth pale skin, sweet green flesh.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Crimson Sweet 4'],
    uses: ['fresh', 'fruit salad', 'dessert']
  },
  {
    id: 'crenshaw-large-4',
    name: 'Crenshaw - Large 4',
    scientificName: 'Cucumis melo var. inodorus',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Large 4 crenshaw. Hybrid with salmon-pink flesh.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Large 4'],
    uses: ['fresh', 'fruit salad', 'dessert']
  },
  {
    id: 'casaba-imperial-4',
    name: 'Casaba - Imperial 4',
    scientificName: 'Cucumis melo var. inodorus',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Imperial 4 casaba. Wrinkled yellow skin, white flesh.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Imperial 4'],
    uses: ['fresh', 'fruit salad', 'dessert']
  },
  {
    id: 'persian-hybrid-4',
    name: 'Persian - Hybrid 4',
    scientificName: 'Cucumis melo var. reticulatus',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Hybrid 4 persian. Oval with netted skin, very sweet.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Hybrid 4'],
    uses: ['fresh', 'fruit salad', 'dessert']
  },
  {
    id: 'canary-golden-beauty-4',
    name: 'Canary - Golden Beauty 4',
    scientificName: 'Cucumis melo var. inodorus',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Golden Beauty 4 canary. Bright yellow, mild and sweet.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Golden Beauty 4'],
    uses: ['fresh', 'fruit salad', 'dessert']
  },
  {
    id: 'galia-snowball-4',
    name: 'Galia - Snowball 4',
    scientificName: 'Cucumis melo var. reticulatus',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Snowball 4 galia. Netted green skin, spicy-sweet.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Snowball 4'],
    uses: ['fresh', 'fruit salad', 'dessert']
  },
  {
    id: 'piel-de sapo-casaba-4',
    name: 'Piel de sapo - Casaba 4',
    scientificName: 'Cucumis melo var. inodorus',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Casaba 4 piel de sapo. Toad skin, white sweet flesh.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Casaba 4'],
    uses: ['fresh', 'fruit salad', 'dessert']
  },
  {
    id: 'bitter-melon-winter-4',
    name: 'Bitter melon - Winter 4',
    scientificName: 'Momordica charantia',
    category: 'cucurbit',
    spacing: 48,
    rowSpacing: 72,
    daysToGermination: 7,
    daysToHarvest: 70,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Winter 4 bitter melon. Bumpy green, used in Asian cuisine.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '10-12 feet',
    family: 'Cucurbitaceae',
    varieties: ['Winter 4'],
    uses: ['stir fry', 'curry', 'medicinal']
  },
  {
    id: 'winter-melon-santa-claus-4',
    name: 'Winter melon - Santa Claus 4',
    scientificName: 'Benincasa hispida',
    category: 'cucurbit',
    spacing: 48,
    rowSpacing: 72,
    daysToGermination: 7,
    daysToHarvest: 110,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Santa Claus 4 winter melon. Large waxy melon for soup and stew.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '10-12 feet',
    family: 'Benincaseae',
    varieties: ['Santa Claus 4'],
    uses: ['soup', 'stew', 'braising']
  },
  {
    id: 'cantaloupe-piel-de-sapo-4',
    name: 'Cantaloupe - Piel de Sapo 4',
    scientificName: 'Cucumis melo var. cantalupensis',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Piel de Sapo 4 cantaloupe. Classic muskmelon with netted skin.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Piel de Sapo 4'],
    uses: ['fresh', 'fruit salad', 'dessert']
  },
  {
    id: 'honeydew-toad-skin-4',
    name: 'Honeydew - Toad Skin 4',
    scientificName: 'Cucumis melo var. inodorus',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Toad Skin 4 honeydew. Smooth pale skin, sweet green flesh.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Toad Skin 4'],
    uses: ['fresh', 'fruit salad', 'dessert']
  },
  {
    id: 'crenshaw-santa-claus-4',
    name: 'Crenshaw - Santa Claus 4',
    scientificName: 'Cucumis melo var. inodorus',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Santa Claus 4 crenshaw. Hybrid with salmon-pink flesh.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Santa Claus 4'],
    uses: ['fresh', 'fruit salad', 'dessert']
  },
  {
    id: 'casaba-christmas-4',
    name: 'Casaba - Christmas 4',
    scientificName: 'Cucumis melo var. inodorus',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Christmas 4 casaba. Wrinkled yellow skin, white flesh.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Christmas 4'],
    uses: ['fresh', 'fruit salad', 'dessert']
  },
  {
    id: 'persian-canary-4',
    name: 'Persian - Canary 4',
    scientificName: 'Cucumis melo var. reticulatus',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Canary 4 persian. Oval with netted skin, very sweet.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Canary 4'],
    uses: ['fresh', 'fruit salad', 'dessert']
  },
  {
    id: 'canary-amarillo-4',
    name: 'Canary - Amarillo 4',
    scientificName: 'Cucumis melo var. inodorus',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Amarillo 4 canary. Bright yellow, mild and sweet.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Amarillo 4'],
    uses: ['fresh', 'fruit salad', 'dessert']
  },
  {
    id: 'galia-juan-canary-4',
    name: 'Galia - Juan Canary 4',
    scientificName: 'Cucumis melo var. reticulatus',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Juan Canary 4 galia. Netted green skin, spicy-sweet.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Juan Canary 4'],
    uses: ['fresh', 'fruit salad', 'dessert']
  },
  {
    id: 'piel-de sapo-yellow-4',
    name: 'Piel de sapo - Yellow 4',
    scientificName: 'Cucumis melo var. inodorus',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Yellow 4 piel de sapo. Toad skin, white sweet flesh.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Yellow 4'],
    uses: ['fresh', 'fruit salad', 'dessert']
  },
  {
    id: 'bitter-melon-galia-4',
    name: 'Bitter melon - Galia 4',
    scientificName: 'Momordica charantia',
    category: 'cucurbit',
    spacing: 48,
    rowSpacing: 72,
    daysToGermination: 7,
    daysToHarvest: 70,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Galia 4 bitter melon. Bumpy green, used in Asian cuisine.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '10-12 feet',
    family: 'Cucurbitaceae',
    varieties: ['Galia 4'],
    uses: ['stir fry', 'curry', 'medicinal']
  },
  {
    id: 'winter-melon-greek-4',
    name: 'Winter melon - Greek 4',
    scientificName: 'Benincasa hispida',
    category: 'cucurbit',
    spacing: 48,
    rowSpacing: 72,
    daysToGermination: 7,
    daysToHarvest: 110,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Greek 4 winter melon. Large waxy melon for soup and stew.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '10-12 feet',
    family: 'Benincaseae',
    varieties: ['Greek 4'],
    uses: ['soup', 'stew', 'braising']
  },
  {
    id: 'cantaloupe-arava-4',
    name: 'Cantaloupe - Arava 4',
    scientificName: 'Cucumis melo var. cantalupensis',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Arava 4 cantaloupe. Classic muskmelon with netted skin.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Arava 4'],
    uses: ['fresh', 'fruit salad', 'dessert']
  },
  {
    id: 'honeydew-diplomat-4',
    name: 'Honeydew - Diplomat 4',
    scientificName: 'Cucumis melo var. inodorus',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Diplomat 4 honeydew. Smooth pale skin, sweet green flesh.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Diplomat 4'],
    uses: ['fresh', 'fruit salad', 'dessert']
  },
  {
    id: 'crenshaw-gallicum-4',
    name: 'Crenshaw - Gallicum 4',
    scientificName: 'Cucumis melo var. inodorus',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Gallicum 4 crenshaw. Hybrid with salmon-pink flesh.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Gallicum 4'],
    uses: ['fresh', 'fruit salad', 'dessert']
  },
  {
    id: 'casaba-madonna-4',
    name: 'Casaba - Madonna 4',
    scientificName: 'Cucumis melo var. inodorus',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Madonna 4 casaba. Wrinkled yellow skin, white flesh.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Madonna 4'],
    uses: ['fresh', 'fruit salad', 'dessert']
  },
  {
    id: 'persian-magnum-4',
    name: 'Persian - Magnum 4',
    scientificName: 'Cucumis melo var. reticulatus',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Magnum 4 persian. Oval with netted skin, very sweet.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Magnum 4'],
    uses: ['fresh', 'fruit salad', 'dessert']
  },
  {
    id: 'canary-armenian-4',
    name: 'Canary - Armenian 4',
    scientificName: 'Cucumis melo var. inodorus',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Armenian 4 canary. Bright yellow, mild and sweet.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Armenian 4'],
    uses: ['fresh', 'fruit salad', 'dessert']
  },
  {
    id: 'galia-snake-4',
    name: 'Galia - Snake 4',
    scientificName: 'Cucumis melo var. reticulatus',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Snake 4 galia. Netted green skin, spicy-sweet.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Snake 4'],
    uses: ['fresh', 'fruit salad', 'dessert']
  },
  {
    id: 'piel-de sapo-yard-long-4',
    name: 'Piel de sapo - Yard Long 4',
    scientificName: 'Cucumis melo var. inodorus',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Yard Long 4 piel de sapo. Toad skin, white sweet flesh.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Yard Long 4'],
    uses: ['fresh', 'fruit salad', 'dessert']
  },
  {
    id: 'bitter-melon-bitter-4',
    name: 'Bitter melon - Bitter 4',
    scientificName: 'Momordica charantia',
    category: 'cucurbit',
    spacing: 48,
    rowSpacing: 72,
    daysToGermination: 7,
    daysToHarvest: 70,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Bitter 4 bitter melon. Bumpy green, used in Asian cuisine.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '10-12 feet',
    family: 'Cucurbitaceae',
    varieties: ['Bitter 4'],
    uses: ['stir fry', 'curry', 'medicinal']
  },
  {
    id: 'winter-melon-karela-4',
    name: 'Winter melon - Karela 4',
    scientificName: 'Benincasa hispida',
    category: 'cucurbit',
    spacing: 48,
    rowSpacing: 72,
    daysToGermination: 7,
    daysToHarvest: 110,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Karela 4 winter melon. Large waxy melon for soup and stew.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '10-12 feet',
    family: 'Benincaseae',
    varieties: ['Karela 4'],
    uses: ['soup', 'stew', 'braising']
  },
  {
    id: 'cantaloupe-chinese-4',
    name: 'Cantaloupe - Chinese 4',
    scientificName: 'Cucumis melo var. cantalupensis',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Chinese 4 cantaloupe. Classic muskmelon with netted skin.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Chinese 4'],
    uses: ['fresh', 'fruit salad', 'dessert']
  },
  {
    id: 'honeydew-indian-4',
    name: 'Honeydew - Indian 4',
    scientificName: 'Cucumis melo var. inodorus',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Indian 4 honeydew. Smooth pale skin, sweet green flesh.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Indian 4'],
    uses: ['fresh', 'fruit salad', 'dessert']
  },
  {
    id: 'crenshaw-thai-4',
    name: 'Crenshaw - Thai 4',
    scientificName: 'Cucumis melo var. inodorus',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Thai 4 crenshaw. Hybrid with salmon-pink flesh.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Thai 4'],
    uses: ['fresh', 'fruit salad', 'dessert']
  },
  {
    id: 'casaba-vietnamese-4',
    name: 'Casaba - Vietnamese 4',
    scientificName: 'Cucumis melo var. inodorus',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Vietnamese 4 casaba. Wrinkled yellow skin, white flesh.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Vietnamese 4'],
    uses: ['fresh', 'fruit salad', 'dessert']
  },
  {
    id: 'persian-japanese-4',
    name: 'Persian - Japanese 4',
    scientificName: 'Cucumis melo var. reticulatus',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Japanese 4 persian. Oval with netted skin, very sweet.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Japanese 4'],
    uses: ['fresh', 'fruit salad', 'dessert']
  },
  {
    id: 'canary-winter-melon-4',
    name: 'Canary - Winter Melon 4',
    scientificName: 'Cucumis melo var. inodorus',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Winter Melon 4 canary. Bright yellow, mild and sweet.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Winter Melon 4'],
    uses: ['fresh', 'fruit salad', 'dessert']
  },
  {
    id: 'galia-wax-gourd-4',
    name: 'Galia - Wax Gourd 4',
    scientificName: 'Cucumis melo var. reticulatus',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Wax Gourd 4 galia. Netted green skin, spicy-sweet.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Wax Gourd 4'],
    uses: ['fresh', 'fruit salad', 'dessert']
  },
  {
    id: 'piel-de sapo-ash-gourd-4',
    name: 'Piel de sapo - Ash Gourd 4',
    scientificName: 'Cucumis melo var. inodorus',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Ash Gourd 4 piel de sapo. Toad skin, white sweet flesh.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Ash Gourd 4'],
    uses: ['fresh', 'fruit salad', 'dessert']
  },
  {
    id: 'bitter-melon-chinese-watermelon-4',
    name: 'Bitter melon - Chinese Watermelon 4',
    scientificName: 'Momordica charantia',
    category: 'cucurbit',
    spacing: 48,
    rowSpacing: 72,
    daysToGermination: 7,
    daysToHarvest: 70,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Chinese Watermelon 4 bitter melon. Bumpy green, used in Asian cuisine.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '10-12 feet',
    family: 'Cucurbitaceae',
    varieties: ['Chinese Watermelon 4'],
    uses: ['stir fry', 'curry', 'medicinal']
  },
  {
    id: 'winter-melon-dong-gua-4',
    name: 'Winter melon - Dong Gua 4',
    scientificName: 'Benincasa hispida',
    category: 'cucurbit',
    spacing: 48,
    rowSpacing: 72,
    daysToGermination: 7,
    daysToHarvest: 110,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Dong Gua 4 winter melon. Large waxy melon for soup and stew.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '10-12 feet',
    family: 'Benincaseae',
    varieties: ['Dong Gua 4'],
    uses: ['soup', 'stew', 'braising']
  },
  {
    id: 'cantaloupe-sugar-4',
    name: 'Cantaloupe - Sugar 4',
    scientificName: 'Cucumis melo var. cantalupensis',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Sugar 4 cantaloupe. Classic muskmelon with netted skin.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Sugar 4'],
    uses: ['fresh', 'fruit salad', 'dessert']
  },
  {
    id: 'honeydew-sweet-4',
    name: 'Honeydew - Sweet 4',
    scientificName: 'Cucumis melo var. inodorus',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Sweet 4 honeydew. Smooth pale skin, sweet green flesh.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Sweet 4'],
    uses: ['fresh', 'fruit salad', 'dessert']
  },
  {
    id: 'crenshaw-super-sweet-4',
    name: 'Crenshaw - Super Sweet 4',
    scientificName: 'Cucumis melo var. inodorus',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Super Sweet 4 crenshaw. Hybrid with salmon-pink flesh.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Super Sweet 4'],
    uses: ['fresh', 'fruit salad', 'dessert']
  },
  {
    id: 'casaba-extra-sweet-4',
    name: 'Casaba - Extra Sweet 4',
    scientificName: 'Cucumis melo var. inodorus',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Extra Sweet 4 casaba. Wrinkled yellow skin, white flesh.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Extra Sweet 4'],
    uses: ['fresh', 'fruit salad', 'dessert']
  },
  {
    id: 'persian-ultra-sweet-4',
    name: 'Persian - Ultra Sweet 4',
    scientificName: 'Cucumis melo var. reticulatus',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Ultra Sweet 4 persian. Oval with netted skin, very sweet.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Ultra Sweet 4'],
    uses: ['fresh', 'fruit salad', 'dessert']
  },
  {
    id: 'canary-early-4',
    name: 'Canary - Early 4',
    scientificName: 'Cucumis melo var. inodorus',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Early 4 canary. Bright yellow, mild and sweet.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Early 4'],
    uses: ['fresh', 'fruit salad', 'dessert']
  },
  {
    id: 'galia-main-season-4',
    name: 'Galia - Main Season 4',
    scientificName: 'Cucumis melo var. reticulatus',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Main Season 4 galia. Netted green skin, spicy-sweet.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Main Season 4'],
    uses: ['fresh', 'fruit salad', 'dessert']
  },
  {
    id: 'piel-de sapo-late-4',
    name: 'Piel de sapo - Late 4',
    scientificName: 'Cucumis melo var. inodorus',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Late 4 piel de sapo. Toad skin, white sweet flesh.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Late 4'],
    uses: ['fresh', 'fruit salad', 'dessert']
  },
  {
    id: 'bitter-melon-all-season-4',
    name: 'Bitter melon - All Season 4',
    scientificName: 'Momordica charantia',
    category: 'cucurbit',
    spacing: 48,
    rowSpacing: 72,
    daysToGermination: 7,
    daysToHarvest: 70,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'All Season 4 bitter melon. Bumpy green, used in Asian cuisine.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '10-12 feet',
    family: 'Cucurbitaceae',
    varieties: ['All Season 4'],
    uses: ['stir fry', 'curry', 'medicinal']
  },
  {
    id: 'winter-melon-fall-4',
    name: 'Winter melon - Fall 4',
    scientificName: 'Benincasa hispida',
    category: 'cucurbit',
    spacing: 48,
    rowSpacing: 72,
    daysToGermination: 7,
    daysToHarvest: 110,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Fall 4 winter melon. Large waxy melon for soup and stew.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '10-12 feet',
    family: 'Benincaseae',
    varieties: ['Fall 4'],
    uses: ['soup', 'stew', 'braising']
  },
  {
    id: 'cantaloupe-spring-4',
    name: 'Cantaloupe - Spring 4',
    scientificName: 'Cucumis melo var. cantalupensis',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Spring 4 cantaloupe. Classic muskmelon with netted skin.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Spring 4'],
    uses: ['fresh', 'fruit salad', 'dessert']
  },
  {
    id: 'honeydew-summer-4',
    name: 'Honeydew - Summer 4',
    scientificName: 'Cucumis melo var. inodorus',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Summer 4 honeydew. Smooth pale skin, sweet green flesh.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Summer 4'],
    uses: ['fresh', 'fruit salad', 'dessert']
  },
  {
    id: 'crenshaw-winter-4',
    name: 'Crenshaw - Winter 4',
    scientificName: 'Cucumis melo var. inodorus',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Winter 4 crenshaw. Hybrid with salmon-pink flesh.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Winter 4'],
    uses: ['fresh', 'fruit salad', 'dessert']
  },
  {
    id: 'casaba-greenhouse-4',
    name: 'Casaba - Greenhouse 4',
    scientificName: 'Cucumis melo var. inodorus',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Greenhouse 4 casaba. Wrinkled yellow skin, white flesh.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Greenhouse 4'],
    uses: ['fresh', 'fruit salad', 'dessert']
  },
  {
    id: 'persian-field-4',
    name: 'Persian - Field 4',
    scientificName: 'Cucumis melo var. reticulatus',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Field 4 persian. Oval with netted skin, very sweet.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Field 4'],
    uses: ['fresh', 'fruit salad', 'dessert']
  },
  {
    id: 'canary-drought-tolerant-4',
    name: 'Canary - Drought Tolerant 4',
    scientificName: 'Cucumis melo var. inodorus',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Drought Tolerant 4 canary. Bright yellow, mild and sweet.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Drought Tolerant 4'],
    uses: ['fresh', 'fruit salad', 'dessert']
  },
  {
    id: 'galia-heat-resistant-4',
    name: 'Galia - Heat Resistant 4',
    scientificName: 'Cucumis melo var. reticulatus',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Heat Resistant 4 galia. Netted green skin, spicy-sweet.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Heat Resistant 4'],
    uses: ['fresh', 'fruit salad', 'dessert']
  },
  {
    id: 'piel-de sapo-disease-resistant-4',
    name: 'Piel de sapo - Disease Resistant 4',
    scientificName: 'Cucumis melo var. inodorus',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Disease Resistant 4 piel de sapo. Toad skin, white sweet flesh.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Disease Resistant 4'],
    uses: ['fresh', 'fruit salad', 'dessert']
  },
  {
    id: 'bitter-melon-virus-resistant-4',
    name: 'Bitter melon - Virus Resistant 4',
    scientificName: 'Momordica charantia',
    category: 'cucurbit',
    spacing: 48,
    rowSpacing: 72,
    daysToGermination: 7,
    daysToHarvest: 70,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Virus Resistant 4 bitter melon. Bumpy green, used in Asian cuisine.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '10-12 feet',
    family: 'Cucurbitaceae',
    varieties: ['Virus Resistant 4'],
    uses: ['stir fry', 'curry', 'medicinal']
  },
  {
    id: 'winter-melon-fusarium-resistant-4',
    name: 'Winter melon - Fusarium Resistant 4',
    scientificName: 'Benincasa hispida',
    category: 'cucurbit',
    spacing: 48,
    rowSpacing: 72,
    daysToGermination: 7,
    daysToHarvest: 110,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Fusarium Resistant 4 winter melon. Large waxy melon for soup and stew.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '10-12 feet',
    family: 'Benincaseae',
    varieties: ['Fusarium Resistant 4'],
    uses: ['soup', 'stew', 'braising']
  },
  {
    id: 'cantaloupe-small-4',
    name: 'Cantaloupe - Small 4',
    scientificName: 'Cucumis melo var. cantalupensis',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Small 4 cantaloupe. Classic muskmelon with netted skin.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Small 4'],
    uses: ['fresh', 'fruit salad', 'dessert']
  },
  {
    id: 'honeydew-medium-4',
    name: 'Honeydew - Medium 4',
    scientificName: 'Cucumis melo var. inodorus',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Medium 4 honeydew. Smooth pale skin, sweet green flesh.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Medium 4'],
    uses: ['fresh', 'fruit salad', 'dessert']
  },
  {
    id: 'crenshaw-large-4',
    name: 'Crenshaw - Large 4',
    scientificName: 'Cucumis melo var. inodorus',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Large 4 crenshaw. Hybrid with salmon-pink flesh.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Large 4'],
    uses: ['fresh', 'fruit salad', 'dessert']
  },
  {
    id: 'casaba-jumbo-4',
    name: 'Casaba - Jumbo 4',
    scientificName: 'Cucumis melo var. inodorus',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Jumbo 4 casaba. Wrinkled yellow skin, white flesh.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Jumbo 4'],
    uses: ['fresh', 'fruit salad', 'dessert']
  },
  {
    id: 'persian-giant-4',
    name: 'Persian - Giant 4',
    scientificName: 'Cucumis melo var. reticulatus',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Giant 4 persian. Oval with netted skin, very sweet.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Giant 4'],
    uses: ['fresh', 'fruit salad', 'dessert']
  },
  {
    id: 'canary-round-4',
    name: 'Canary - Round 4',
    scientificName: 'Cucumis melo var. inodorus',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Round 4 canary. Bright yellow, mild and sweet.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Round 4'],
    uses: ['fresh', 'fruit salad', 'dessert']
  },
  {
    id: 'galia-oval-4',
    name: 'Galia - Oval 4',
    scientificName: 'Cucumis melo var. reticulatus',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Oval 4 galia. Netted green skin, spicy-sweet.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Oval 4'],
    uses: ['fresh', 'fruit salad', 'dessert']
  },
  {
    id: 'piel-de sapo-elongated-4',
    name: 'Piel de sapo - Elongated 4',
    scientificName: 'Cucumis melo var. inodorus',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Elongated 4 piel de sapo. Toad skin, white sweet flesh.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Elongated 4'],
    uses: ['fresh', 'fruit salad', 'dessert']
  },
  {
    id: 'bitter-melon-slip-4',
    name: 'Bitter melon - Slip 4',
    scientificName: 'Momordica charantia',
    category: 'cucurbit',
    spacing: 48,
    rowSpacing: 72,
    daysToGermination: 7,
    daysToHarvest: 70,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Slip 4 bitter melon. Bumpy green, used in Asian cuisine.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '10-12 feet',
    family: 'Cucurbitaceae',
    varieties: ['Slip 4'],
    uses: ['stir fry', 'curry', 'medicinal']
  },
  {
    id: 'winter-melon-non-slip-4',
    name: 'Winter melon - Non-Slip 4',
    scientificName: 'Benincasa hispida',
    category: 'cucurbit',
    spacing: 48,
    rowSpacing: 72,
    daysToGermination: 7,
    daysToHarvest: 110,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Non-Slip 4 winter melon. Large waxy melon for soup and stew.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '10-12 feet',
    family: 'Benincaseae',
    varieties: ['Non-Slip 4'],
    uses: ['soup', 'stew', 'braising']
  },
  {
    id: 'cantaloupe-netted-4',
    name: 'Cantaloupe - Netted 4',
    scientificName: 'Cucumis melo var. cantalupensis',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Netted 4 cantaloupe. Classic muskmelon with netted skin.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Netted 4'],
    uses: ['fresh', 'fruit salad', 'dessert']
  },
  {
    id: 'honeydew-smooth-4',
    name: 'Honeydew - Smooth 4',
    scientificName: 'Cucumis melo var. inodorus',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Smooth 4 honeydew. Smooth pale skin, sweet green flesh.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Smooth 4'],
    uses: ['fresh', 'fruit salad', 'dessert']
  },
  {
    id: 'crenshaw-ribbed-4',
    name: 'Crenshaw - Ribbed 4',
    scientificName: 'Cucumis melo var. inodorus',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Ribbed 4 crenshaw. Hybrid with salmon-pink flesh.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Ribbed 4'],
    uses: ['fresh', 'fruit salad', 'dessert']
  },
  {
    id: 'casaba-sutured-4',
    name: 'Casaba - Sutured 4',
    scientificName: 'Cucumis melo var. inodorus',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Sutured 4 casaba. Wrinkled yellow skin, white flesh.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Sutured 4'],
    uses: ['fresh', 'fruit salad', 'dessert']
  },
  {
    id: 'persian-veined-4',
    name: 'Persian - Veined 4',
    scientificName: 'Cucumis melo var. reticulatus',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Veined 4 persian. Oval with netted skin, very sweet.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Veined 4'],
    uses: ['fresh', 'fruit salad', 'dessert']
  },
  {
    id: 'canary-orange-4',
    name: 'Canary - Orange 4',
    scientificName: 'Cucumis melo var. inodorus',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Orange 4 canary. Bright yellow, mild and sweet.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Orange 4'],
    uses: ['fresh', 'fruit salad', 'dessert']
  },
  {
    id: 'galia-green-4',
    name: 'Galia - Green 4',
    scientificName: 'Cucumis melo var. reticulatus',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Green 4 galia. Netted green skin, spicy-sweet.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Green 4'],
    uses: ['fresh', 'fruit salad', 'dessert']
  },
  {
    id: 'piel-de sapo-white-4',
    name: 'Piel de sapo - White 4',
    scientificName: 'Cucumis melo var. inodorus',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'White 4 piel de sapo. Toad skin, white sweet flesh.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['White 4'],
    uses: ['fresh', 'fruit salad', 'dessert']
  },
  {
    id: 'bitter-melon-yellow-4',
    name: 'Bitter melon - Yellow 4',
    scientificName: 'Momordica charantia',
    category: 'cucurbit',
    spacing: 48,
    rowSpacing: 72,
    daysToGermination: 7,
    daysToHarvest: 70,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Yellow 4 bitter melon. Bumpy green, used in Asian cuisine.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '10-12 feet',
    family: 'Cucurbitaceae',
    varieties: ['Yellow 4'],
    uses: ['stir fry', 'curry', 'medicinal']
  },
  {
    id: 'winter-melon-gold-4',
    name: 'Winter melon - Gold 4',
    scientificName: 'Benincasa hispida',
    category: 'cucurbit',
    spacing: 48,
    rowSpacing: 72,
    daysToGermination: 7,
    daysToHarvest: 110,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Gold 4 winter melon. Large waxy melon for soup and stew.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '10-12 feet',
    family: 'Benincaseae',
    varieties: ['Gold 4'],
    uses: ['soup', 'stew', 'braising']
  },
  {
    id: 'cantaloupe-red-4',
    name: 'Cantaloupe - Red 4',
    scientificName: 'Cucumis melo var. cantalupensis',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Red 4 cantaloupe. Classic muskmelon with netted skin.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Red 4'],
    uses: ['fresh', 'fruit salad', 'dessert']
  },
  {
    id: 'honeydew-pink-4',
    name: 'Honeydew - Pink 4',
    scientificName: 'Cucumis melo var. inodorus',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Pink 4 honeydew. Smooth pale skin, sweet green flesh.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Pink 4'],
    uses: ['fresh', 'fruit salad', 'dessert']
  },
  {
    id: 'crenshaw-salmon-4',
    name: 'Crenshaw - Salmon 4',
    scientificName: 'Cucumis melo var. inodorus',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Salmon 4 crenshaw. Hybrid with salmon-pink flesh.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Salmon 4'],
    uses: ['fresh', 'fruit salad', 'dessert']
  },
  {
    id: 'casaba-apricot-4',
    name: 'Casaba - Apricot 4',
    scientificName: 'Cucumis melo var. inodorus',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Apricot 4 casaba. Wrinkled yellow skin, white flesh.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Apricot 4'],
    uses: ['fresh', 'fruit salad', 'dessert']
  },
  {
    id: 'persian-cream-4',
    name: 'Persian - Cream 4',
    scientificName: 'Cucumis melo var. reticulatus',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Cream 4 persian. Oval with netted skin, very sweet.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Cream 4'],
    uses: ['fresh', 'fruit salad', 'dessert']
  },
  {
    id: 'canary-organic-4',
    name: 'Canary - Organic 4',
    scientificName: 'Cucumis melo var. inodorus',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Organic 4 canary. Bright yellow, mild and sweet.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Organic 4'],
    uses: ['fresh', 'fruit salad', 'dessert']
  },
  {
    id: 'galia-heirloom-4',
    name: 'Galia - Heirloom 4',
    scientificName: 'Cucumis melo var. reticulatus',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Heirloom 4 galia. Netted green skin, spicy-sweet.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Heirloom 4'],
    uses: ['fresh', 'fruit salad', 'dessert']
  },
  {
    id: 'piel-de sapo-hybrid-4',
    name: 'Piel de sapo - Hybrid 4',
    scientificName: 'Cucumis melo var. inodorus',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Hybrid 4 piel de sapo. Toad skin, white sweet flesh.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Hybrid 4'],
    uses: ['fresh', 'fruit salad', 'dessert']
  },
  {
    id: 'bitter-melon-f1-4',
    name: 'Bitter melon - F1 4',
    scientificName: 'Momordica charantia',
    category: 'cucurbit',
    spacing: 48,
    rowSpacing: 72,
    daysToGermination: 7,
    daysToHarvest: 70,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'F1 4 bitter melon. Bumpy green, used in Asian cuisine.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '10-12 feet',
    family: 'Cucurbitaceae',
    varieties: ['F1 4'],
    uses: ['stir fry', 'curry', 'medicinal']
  },
  {
    id: 'winter-melon-open-pollinated-4',
    name: 'Winter melon - Open Pollinated 4',
    scientificName: 'Benincasa hispida',
    category: 'cucurbit',
    spacing: 48,
    rowSpacing: 72,
    daysToGermination: 7,
    daysToHarvest: 110,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Open Pollinated 4 winter melon. Large waxy melon for soup and stew.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '10-12 feet',
    family: 'Benincaseae',
    varieties: ['Open Pollinated 4'],
    uses: ['soup', 'stew', 'braising']
  },
  {
    id: 'cantaloupe-hales-best-5',
    name: 'Cantaloupe - Hales Best 5',
    scientificName: 'Cucumis melo var. cantalupensis',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Hales Best 5 cantaloupe. Classic muskmelon with netted skin.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Hales Best 5'],
    uses: ['fresh', 'fruit salad', 'dessert']
  },
  {
    id: 'honeydew-ambrosia-5',
    name: 'Honeydew - Ambrosia 5',
    scientificName: 'Cucumis melo var. inodorus',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Ambrosia 5 honeydew. Smooth pale skin, sweet green flesh.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Ambrosia 5'],
    uses: ['fresh', 'fruit salad', 'dessert']
  },
  {
    id: 'crenshaw-athena-5',
    name: 'Crenshaw - Athena 5',
    scientificName: 'Cucumis melo var. inodorus',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Athena 5 crenshaw. Hybrid with salmon-pink flesh.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Athena 5'],
    uses: ['fresh', 'fruit salad', 'dessert']
  },
  {
    id: 'casaba-sarahs-choice-5',
    name: 'Casaba - Sarahs Choice 5',
    scientificName: 'Cucumis melo var. inodorus',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Sarahs Choice 5 casaba. Wrinkled yellow skin, white flesh.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Sarahs Choice 5'],
    uses: ['fresh', 'fruit salad', 'dessert']
  },
  {
    id: 'persian-sugar-cube-5',
    name: 'Persian - Sugar Cube 5',
    scientificName: 'Cucumis melo var. reticulatus',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Sugar Cube 5 persian. Oval with netted skin, very sweet.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Sugar Cube 5'],
    uses: ['fresh', 'fruit salad', 'dessert']
  },
  {
    id: 'canary-minnesota-midget-5',
    name: 'Canary - Minnesota Midget 5',
    scientificName: 'Cucumis melo var. inodorus',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Minnesota Midget 5 canary. Bright yellow, mild and sweet.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Minnesota Midget 5'],
    uses: ['fresh', 'fruit salad', 'dessert']
  },
  {
    id: 'galia-hearts-of-gold-5',
    name: 'Galia - Hearts of Gold 5',
    scientificName: 'Cucumis melo var. reticulatus',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Hearts of Gold 5 galia. Netted green skin, spicy-sweet.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Hearts of Gold 5'],
    uses: ['fresh', 'fruit salad', 'dessert']
  },
  {
    id: 'piel-de sapo-pmr-45-5',
    name: 'Piel de sapo - PMR 45 5',
    scientificName: 'Cucumis melo var. inodorus',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'PMR 45 5 piel de sapo. Toad skin, white sweet flesh.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['PMR 45 5'],
    uses: ['fresh', 'fruit salad', 'dessert']
  },
  {
    id: 'bitter-melon-savor-5',
    name: 'Bitter melon - Savor 5',
    scientificName: 'Momordica charantia',
    category: 'cucurbit',
    spacing: 48,
    rowSpacing: 72,
    daysToGermination: 7,
    daysToHarvest: 70,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Savor 5 bitter melon. Bumpy green, used in Asian cuisine.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '10-12 feet',
    family: 'Cucurbitaceae',
    varieties: ['Savor 5'],
    uses: ['stir fry', 'curry', 'medicinal']
  },
  {
    id: 'winter-melon-tasty-bites-5',
    name: 'Winter melon - Tasty Bites 5',
    scientificName: 'Benincasa hispida',
    category: 'cucurbit',
    spacing: 48,
    rowSpacing: 72,
    daysToGermination: 7,
    daysToHarvest: 110,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Tasty Bites 5 winter melon. Large waxy melon for soup and stew.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '10-12 feet',
    family: 'Benincaseae',
    varieties: ['Tasty Bites 5'],
    uses: ['soup', 'stew', 'braising']
  },
  {
    id: 'cantaloupe-green-flesh-5',
    name: 'Cantaloupe - Green Flesh 5',
    scientificName: 'Cucumis melo var. cantalupensis',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Green Flesh 5 cantaloupe. Classic muskmelon with netted skin.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Green Flesh 5'],
    uses: ['fresh', 'fruit salad', 'dessert']
  },
  {
    id: 'honeydew-orange-flesh-5',
    name: 'Honeydew - Orange Flesh 5',
    scientificName: 'Cucumis melo var. inodorus',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Orange Flesh 5 honeydew. Smooth pale skin, sweet green flesh.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Orange Flesh 5'],
    uses: ['fresh', 'fruit salad', 'dessert']
  },
  {
    id: 'crenshaw-honey-dew-5',
    name: 'Crenshaw - Honey Dew 5',
    scientificName: 'Cucumis melo var. inodorus',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Honey Dew 5 crenshaw. Hybrid with salmon-pink flesh.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Honey Dew 5'],
    uses: ['fresh', 'fruit salad', 'dessert']
  },
  {
    id: 'casaba-honey-orange-5',
    name: 'Casaba - Honey Orange 5',
    scientificName: 'Cucumis melo var. inodorus',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Honey Orange 5 casaba. Wrinkled yellow skin, white flesh.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Honey Orange 5'],
    uses: ['fresh', 'fruit salad', 'dessert']
  },
  {
    id: 'persian-temptation-5',
    name: 'Persian - Temptation 5',
    scientificName: 'Cucumis melo var. reticulatus',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Temptation 5 persian. Oval with netted skin, very sweet.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Temptation 5'],
    uses: ['fresh', 'fruit salad', 'dessert']
  },
  {
    id: 'canary-passport-5',
    name: 'Canary - Passport 5',
    scientificName: 'Cucumis melo var. inodorus',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Passport 5 canary. Bright yellow, mild and sweet.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Passport 5'],
    uses: ['fresh', 'fruit salad', 'dessert']
  },
  {
    id: 'galia-earli-dew-5',
    name: 'Galia - Earli-Dew 5',
    scientificName: 'Cucumis melo var. reticulatus',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Earli-Dew 5 galia. Netted green skin, spicy-sweet.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Earli-Dew 5'],
    uses: ['fresh', 'fruit salad', 'dessert']
  },
  {
    id: 'piel-de sapo-honey-white-5',
    name: 'Piel de sapo - Honey White 5',
    scientificName: 'Cucumis melo var. inodorus',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Honey White 5 piel de sapo. Toad skin, white sweet flesh.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Honey White 5'],
    uses: ['fresh', 'fruit salad', 'dessert']
  },
  {
    id: 'bitter-melon-honey-yellow-5',
    name: 'Bitter melon - Honey Yellow 5',
    scientificName: 'Momordica charantia',
    category: 'cucurbit',
    spacing: 48,
    rowSpacing: 72,
    daysToGermination: 7,
    daysToHarvest: 70,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Honey Yellow 5 bitter melon. Bumpy green, used in Asian cuisine.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '10-12 feet',
    family: 'Cucurbitaceae',
    varieties: ['Honey Yellow 5'],
    uses: ['stir fry', 'curry', 'medicinal']
  },
  {
    id: 'winter-melon-honey-gold-5',
    name: 'Winter melon - Honey Gold 5',
    scientificName: 'Benincasa hispida',
    category: 'cucurbit',
    spacing: 48,
    rowSpacing: 72,
    daysToGermination: 7,
    daysToHarvest: 110,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Honey Gold 5 winter melon. Large waxy melon for soup and stew.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '10-12 feet',
    family: 'Benincaseae',
    varieties: ['Honey Gold 5'],
    uses: ['soup', 'stew', 'braising']
  },
  {
    id: 'cantaloupe-early-crenshaw-5',
    name: 'Cantaloupe - Early Crenshaw 5',
    scientificName: 'Cucumis melo var. cantalupensis',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Early Crenshaw 5 cantaloupe. Classic muskmelon with netted skin.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Early Crenshaw 5'],
    uses: ['fresh', 'fruit salad', 'dessert']
  },
  {
    id: 'honeydew-crimson-sweet-5',
    name: 'Honeydew - Crimson Sweet 5',
    scientificName: 'Cucumis melo var. inodorus',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Crimson Sweet 5 honeydew. Smooth pale skin, sweet green flesh.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Crimson Sweet 5'],
    uses: ['fresh', 'fruit salad', 'dessert']
  },
  {
    id: 'crenshaw-large-5',
    name: 'Crenshaw - Large 5',
    scientificName: 'Cucumis melo var. inodorus',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Large 5 crenshaw. Hybrid with salmon-pink flesh.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Large 5'],
    uses: ['fresh', 'fruit salad', 'dessert']
  },
  {
    id: 'casaba-imperial-5',
    name: 'Casaba - Imperial 5',
    scientificName: 'Cucumis melo var. inodorus',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Imperial 5 casaba. Wrinkled yellow skin, white flesh.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Imperial 5'],
    uses: ['fresh', 'fruit salad', 'dessert']
  },
  {
    id: 'persian-hybrid-5',
    name: 'Persian - Hybrid 5',
    scientificName: 'Cucumis melo var. reticulatus',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Hybrid 5 persian. Oval with netted skin, very sweet.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Hybrid 5'],
    uses: ['fresh', 'fruit salad', 'dessert']
  },
  {
    id: 'canary-golden-beauty-5',
    name: 'Canary - Golden Beauty 5',
    scientificName: 'Cucumis melo var. inodorus',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Golden Beauty 5 canary. Bright yellow, mild and sweet.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Golden Beauty 5'],
    uses: ['fresh', 'fruit salad', 'dessert']
  },
  {
    id: 'galia-snowball-5',
    name: 'Galia - Snowball 5',
    scientificName: 'Cucumis melo var. reticulatus',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Snowball 5 galia. Netted green skin, spicy-sweet.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Snowball 5'],
    uses: ['fresh', 'fruit salad', 'dessert']
  },
  {
    id: 'piel-de sapo-casaba-5',
    name: 'Piel de sapo - Casaba 5',
    scientificName: 'Cucumis melo var. inodorus',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Casaba 5 piel de sapo. Toad skin, white sweet flesh.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Casaba 5'],
    uses: ['fresh', 'fruit salad', 'dessert']
  },
  {
    id: 'bitter-melon-winter-5',
    name: 'Bitter melon - Winter 5',
    scientificName: 'Momordica charantia',
    category: 'cucurbit',
    spacing: 48,
    rowSpacing: 72,
    daysToGermination: 7,
    daysToHarvest: 70,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Winter 5 bitter melon. Bumpy green, used in Asian cuisine.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '10-12 feet',
    family: 'Cucurbitaceae',
    varieties: ['Winter 5'],
    uses: ['stir fry', 'curry', 'medicinal']
  },
  {
    id: 'winter-melon-santa-claus-5',
    name: 'Winter melon - Santa Claus 5',
    scientificName: 'Benincasa hispida',
    category: 'cucurbit',
    spacing: 48,
    rowSpacing: 72,
    daysToGermination: 7,
    daysToHarvest: 110,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Santa Claus 5 winter melon. Large waxy melon for soup and stew.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '10-12 feet',
    family: 'Benincaseae',
    varieties: ['Santa Claus 5'],
    uses: ['soup', 'stew', 'braising']
  },
  {
    id: 'cantaloupe-piel-de-sapo-5',
    name: 'Cantaloupe - Piel de Sapo 5',
    scientificName: 'Cucumis melo var. cantalupensis',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Piel de Sapo 5 cantaloupe. Classic muskmelon with netted skin.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Piel de Sapo 5'],
    uses: ['fresh', 'fruit salad', 'dessert']
  },
  {
    id: 'honeydew-toad-skin-5',
    name: 'Honeydew - Toad Skin 5',
    scientificName: 'Cucumis melo var. inodorus',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Toad Skin 5 honeydew. Smooth pale skin, sweet green flesh.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Toad Skin 5'],
    uses: ['fresh', 'fruit salad', 'dessert']
  },
  {
    id: 'crenshaw-santa-claus-5',
    name: 'Crenshaw - Santa Claus 5',
    scientificName: 'Cucumis melo var. inodorus',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Santa Claus 5 crenshaw. Hybrid with salmon-pink flesh.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Santa Claus 5'],
    uses: ['fresh', 'fruit salad', 'dessert']
  },
  {
    id: 'casaba-christmas-5',
    name: 'Casaba - Christmas 5',
    scientificName: 'Cucumis melo var. inodorus',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Christmas 5 casaba. Wrinkled yellow skin, white flesh.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Christmas 5'],
    uses: ['fresh', 'fruit salad', 'dessert']
  },
  {
    id: 'persian-canary-5',
    name: 'Persian - Canary 5',
    scientificName: 'Cucumis melo var. reticulatus',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Canary 5 persian. Oval with netted skin, very sweet.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Canary 5'],
    uses: ['fresh', 'fruit salad', 'dessert']
  },
  {
    id: 'canary-amarillo-5',
    name: 'Canary - Amarillo 5',
    scientificName: 'Cucumis melo var. inodorus',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Amarillo 5 canary. Bright yellow, mild and sweet.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Amarillo 5'],
    uses: ['fresh', 'fruit salad', 'dessert']
  },
  {
    id: 'galia-juan-canary-5',
    name: 'Galia - Juan Canary 5',
    scientificName: 'Cucumis melo var. reticulatus',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Juan Canary 5 galia. Netted green skin, spicy-sweet.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Juan Canary 5'],
    uses: ['fresh', 'fruit salad', 'dessert']
  },
  {
    id: 'piel-de sapo-yellow-5',
    name: 'Piel de sapo - Yellow 5',
    scientificName: 'Cucumis melo var. inodorus',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Yellow 5 piel de sapo. Toad skin, white sweet flesh.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Yellow 5'],
    uses: ['fresh', 'fruit salad', 'dessert']
  },
  {
    id: 'bitter-melon-galia-5',
    name: 'Bitter melon - Galia 5',
    scientificName: 'Momordica charantia',
    category: 'cucurbit',
    spacing: 48,
    rowSpacing: 72,
    daysToGermination: 7,
    daysToHarvest: 70,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Galia 5 bitter melon. Bumpy green, used in Asian cuisine.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '10-12 feet',
    family: 'Cucurbitaceae',
    varieties: ['Galia 5'],
    uses: ['stir fry', 'curry', 'medicinal']
  },
  {
    id: 'winter-melon-greek-5',
    name: 'Winter melon - Greek 5',
    scientificName: 'Benincasa hispida',
    category: 'cucurbit',
    spacing: 48,
    rowSpacing: 72,
    daysToGermination: 7,
    daysToHarvest: 110,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Greek 5 winter melon. Large waxy melon for soup and stew.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '10-12 feet',
    family: 'Benincaseae',
    varieties: ['Greek 5'],
    uses: ['soup', 'stew', 'braising']
  },
  {
    id: 'cantaloupe-arava-5',
    name: 'Cantaloupe - Arava 5',
    scientificName: 'Cucumis melo var. cantalupensis',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Arava 5 cantaloupe. Classic muskmelon with netted skin.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Arava 5'],
    uses: ['fresh', 'fruit salad', 'dessert']
  },
  {
    id: 'honeydew-diplomat-5',
    name: 'Honeydew - Diplomat 5',
    scientificName: 'Cucumis melo var. inodorus',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Diplomat 5 honeydew. Smooth pale skin, sweet green flesh.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Diplomat 5'],
    uses: ['fresh', 'fruit salad', 'dessert']
  },
  {
    id: 'crenshaw-gallicum-5',
    name: 'Crenshaw - Gallicum 5',
    scientificName: 'Cucumis melo var. inodorus',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Gallicum 5 crenshaw. Hybrid with salmon-pink flesh.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Gallicum 5'],
    uses: ['fresh', 'fruit salad', 'dessert']
  },
  {
    id: 'casaba-madonna-5',
    name: 'Casaba - Madonna 5',
    scientificName: 'Cucumis melo var. inodorus',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Madonna 5 casaba. Wrinkled yellow skin, white flesh.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Madonna 5'],
    uses: ['fresh', 'fruit salad', 'dessert']
  },
  {
    id: 'persian-magnum-5',
    name: 'Persian - Magnum 5',
    scientificName: 'Cucumis melo var. reticulatus',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Magnum 5 persian. Oval with netted skin, very sweet.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Magnum 5'],
    uses: ['fresh', 'fruit salad', 'dessert']
  },
  {
    id: 'canary-armenian-5',
    name: 'Canary - Armenian 5',
    scientificName: 'Cucumis melo var. inodorus',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Armenian 5 canary. Bright yellow, mild and sweet.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Armenian 5'],
    uses: ['fresh', 'fruit salad', 'dessert']
  },
  {
    id: 'galia-snake-5',
    name: 'Galia - Snake 5',
    scientificName: 'Cucumis melo var. reticulatus',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Snake 5 galia. Netted green skin, spicy-sweet.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Snake 5'],
    uses: ['fresh', 'fruit salad', 'dessert']
  },
  {
    id: 'piel-de sapo-yard-long-5',
    name: 'Piel de sapo - Yard Long 5',
    scientificName: 'Cucumis melo var. inodorus',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Yard Long 5 piel de sapo. Toad skin, white sweet flesh.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Yard Long 5'],
    uses: ['fresh', 'fruit salad', 'dessert']
  },
  {
    id: 'bitter-melon-bitter-5',
    name: 'Bitter melon - Bitter 5',
    scientificName: 'Momordica charantia',
    category: 'cucurbit',
    spacing: 48,
    rowSpacing: 72,
    daysToGermination: 7,
    daysToHarvest: 70,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Bitter 5 bitter melon. Bumpy green, used in Asian cuisine.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '10-12 feet',
    family: 'Cucurbitaceae',
    varieties: ['Bitter 5'],
    uses: ['stir fry', 'curry', 'medicinal']
  },
  {
    id: 'winter-melon-karela-5',
    name: 'Winter melon - Karela 5',
    scientificName: 'Benincasa hispida',
    category: 'cucurbit',
    spacing: 48,
    rowSpacing: 72,
    daysToGermination: 7,
    daysToHarvest: 110,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Karela 5 winter melon. Large waxy melon for soup and stew.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '10-12 feet',
    family: 'Benincaseae',
    varieties: ['Karela 5'],
    uses: ['soup', 'stew', 'braising']
  },
  {
    id: 'cantaloupe-chinese-5',
    name: 'Cantaloupe - Chinese 5',
    scientificName: 'Cucumis melo var. cantalupensis',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Chinese 5 cantaloupe. Classic muskmelon with netted skin.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Chinese 5'],
    uses: ['fresh', 'fruit salad', 'dessert']
  },
  {
    id: 'honeydew-indian-5',
    name: 'Honeydew - Indian 5',
    scientificName: 'Cucumis melo var. inodorus',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Indian 5 honeydew. Smooth pale skin, sweet green flesh.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Indian 5'],
    uses: ['fresh', 'fruit salad', 'dessert']
  },
  {
    id: 'crenshaw-thai-5',
    name: 'Crenshaw - Thai 5',
    scientificName: 'Cucumis melo var. inodorus',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Thai 5 crenshaw. Hybrid with salmon-pink flesh.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Thai 5'],
    uses: ['fresh', 'fruit salad', 'dessert']
  },
  {
    id: 'casaba-vietnamese-5',
    name: 'Casaba - Vietnamese 5',
    scientificName: 'Cucumis melo var. inodorus',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Vietnamese 5 casaba. Wrinkled yellow skin, white flesh.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Vietnamese 5'],
    uses: ['fresh', 'fruit salad', 'dessert']
  },
  {
    id: 'persian-japanese-5',
    name: 'Persian - Japanese 5',
    scientificName: 'Cucumis melo var. reticulatus',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Japanese 5 persian. Oval with netted skin, very sweet.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Japanese 5'],
    uses: ['fresh', 'fruit salad', 'dessert']
  },
  {
    id: 'canary-winter-melon-5',
    name: 'Canary - Winter Melon 5',
    scientificName: 'Cucumis melo var. inodorus',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Winter Melon 5 canary. Bright yellow, mild and sweet.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Winter Melon 5'],
    uses: ['fresh', 'fruit salad', 'dessert']
  },
  {
    id: 'galia-wax-gourd-5',
    name: 'Galia - Wax Gourd 5',
    scientificName: 'Cucumis melo var. reticulatus',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Wax Gourd 5 galia. Netted green skin, spicy-sweet.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Wax Gourd 5'],
    uses: ['fresh', 'fruit salad', 'dessert']
  },
  {
    id: 'piel-de sapo-ash-gourd-5',
    name: 'Piel de sapo - Ash Gourd 5',
    scientificName: 'Cucumis melo var. inodorus',
    category: 'cucurbit',
    spacing: 36,
    rowSpacing: 60,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Ash Gourd 5 piel de sapo. Toad skin, white sweet flesh.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '8-10 feet',
    family: 'Cucurbitaceae',
    varieties: ['Ash Gourd 5'],
    uses: ['fresh', 'fruit salad', 'dessert']
  },
  {
    id: 'bitter-melon-chinese-watermelon-5',
    name: 'Bitter melon - Chinese Watermelon 5',
    scientificName: 'Momordica charantia',
    category: 'cucurbit',
    spacing: 48,
    rowSpacing: 72,
    daysToGermination: 7,
    daysToHarvest: 70,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Chinese Watermelon 5 bitter melon. Bumpy green, used in Asian cuisine.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '10-12 feet',
    family: 'Cucurbitaceae',
    varieties: ['Chinese Watermelon 5'],
    uses: ['stir fry', 'curry', 'medicinal']
  },
  {
    id: 'winter-melon-dong-gua-5',
    name: 'Winter melon - Dong Gua 5',
    scientificName: 'Benincasa hispida',
    category: 'cucurbit',
    spacing: 48,
    rowSpacing: 72,
    daysToGermination: 7,
    daysToHarvest: 110,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn'],
    enemies: ['potato'],
    description: 'Dong Gua 5 winter melon. Large waxy melon for soup and stew.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '10-12 feet',
    family: 'Benincaseae',
    varieties: ['Dong Gua 5'],
    uses: ['soup', 'stew', 'braising']
  }
]
